// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/arrow-down.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&amp;display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cstm-charity-table tr th:last-child{
     width: 15%;
}
.cstm-gift-price-main {
    margin-bottom: 25px;
}

.autocomplete-dropdown-container {
    position: absolute;
    background: #FFF;
    z-index: 88;
	border: 1px solid #dddddd;
    width: 56%;
}
span.drag-gift-sp-cstm {
    font-size: 24px;
    line-height: 16px;
}
 
.cstm-gp-btn {
    position: absolute;
    top: 38px;
    right: 8px;
    height: 40px;
    width: 40px;
    display: inline-block;
    border: 1px solid #edaea2;
    border-radius: 7px;
    text-align: center;
    line-height: 42px;
    color: #EE6F57;
    font-size: 18px;
    margin-right: 12px;
    vertical-align: top;
    background: white;
}
.cstm-gp-btn:hover {
    background: #EE6F57;
    color: #FFF;
}
.cstm-gift-price-main .cstm-input {
    padding-right: 60px;
}
.cstm-switch .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 24px;
}
.cstm-switch .switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.cstm-switch .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ededed;
    transition: .4s;
}
.cstm-switch .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    top: 3px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
}
.cstm-switch input:checked+.slider {
    background-color: #00CCCC;
}
.cstm-switch input:focus+.slider {
    box-shadow: 0 0 1px #00CCCC;
}
.cstm-switch input:checked+.slider:before {
    transform: translateX(26px);
}
.cstm-switch .slider.round {
    border-radius: 34px;
}
.cstm-switch .slider.round:before {
    border-radius: 50%;
}


.error-yup {
	color: red
}

.logo-brand-admin-portal {
	text-align: center;
	padding-bottom: 40px;
}

.cstm-privacy-policy-main .DraftEditor-editorContainer {
    height: 600px;
}

h1,
.h1 {
	font-size: 42px;
	line-height: 1.5;
	font-weight: 600
}

h2,
.h2 {
	font-size: 30px;
	line-height: 1.5;
	font-weight: 600
}

h3,
.h3 {
	font-size: 24px;
	line-height: 1.5;
	font-weight: 600
}

h4,
.h4 {
	font-size: 20px;
	line-height: 1.5;
	font-weight: 600
}

h5,
.h5 { 
	font-size: 16px;
	line-height: 1.5;
	font-weight: 600
}

h6,
.h6 {

	font-size: 14px;
	line-height: 1.5;
	font-weight: 600
}
.cstm-rr input[type="checkbox"] {
    accent-color: #14a5a5;
    height: 16px;
    width: 16px;
    vertical-align: -2px;
    margin-right: 5px;
}
span.topic-label-in button {
    position: absolute;
    top: -7px;
    right: -5px;
    color: #939393;
    border-radius: 50px;
    background: #FFF;
    border: 1px solid #d7d7d7;
    font-size: 16px;
    padding: 0px 4px 2px 4px;
    line-height: 16px;
}
span.topic-label-in {
    border: 1px solid #00cccc;
    padding: 5px 20px 5px 15px;
    border-radius: 40px;
    margin: 0px 15px 10px 0px;
    font-weight: 300;
    font-family: "Inter", sans-serif;
    position: relative;
}
.cstm-vi-bx img {
    width: 200px;
    height: 170px;
    object-fit: cover;
	vertical-align: middle;
    align-items: center;
}
.cstm-vi-bx video {
    width: 200px;
    height: 170px;
    object-fit: cover;
	vertical-align: middle;
    align-items: center;
}

.cstm-vi-box {
    margin-right: 20px;
    position: relative;  
    margin-bottom: 20px;
    border: 1px solid #e5e5e5; 
} 
.cstm-vi-box button {
    color: #939393; 
    position: absolute;
    right: -12px;
    top: -12px;
    border-radius: 50px;
    background: #FFF;
    border: 1px solid #d7d7d7;
}
.cstm-vi-box button:hover {
    background: #00cccc;
    color: #FFF;
}
.cstm-video-image-upload {
    min-height: 40px;
}
.cstm-vi-in {
    padding-left: 170px;
    display: flex;
    flex-wrap: wrap;
}
.cstm-video-image-upload .cstm-uploadbtn {
    position: absolute;
}
.DraftEditor-editorContainer {
    height: 600px;
}
.display-1 {
	font-size: 80px
}

.display-2 {
	font-size: 72px
}

.display-3 {
	font-size: 64px
}

.display-4 {
	font-size: 56px
}

.bg-primary {
	background-color: #00CCCC !important
}

.bg-soft-primary {
	background-color: rgba(57, 108, 240, 0.1) !important;
	border: 1px solid rgba(57, 108, 240, 0.1) !important;
	color: #00CCCC !important
}

.text-primary {
	color: #00CCCC !important
}

a {
	transition: all 0.5s ease
}

a.text-primary:hover,
a.text-primary:focus {
	color: #215aee !important
}

.bg-secondary {
	background-color: #5a6d90 !important
}

.bg-soft-secondary {
	background-color: rgba(90, 109, 144, 0.1) !important;
	border: 1px solid rgba(90, 109, 144, 0.1) !important;
	color: #5a6d90 !important
}

.text-secondary {
	color: #5a6d90 !important
}

a {
	transition: all 0.5s ease
}

a.text-secondary:hover,
a.text-secondary:focus {
	color: #506180 !important
}

.bg-success {
	background-color: #53c797 !important
}

.bg-soft-success {
	background-color: rgba(83, 199, 151, 0.1) !important;
	border: 1px solid rgba(83, 199, 151, 0.1) !important;
	color: #53c797 !important
}

.text-success {
	color: #53c797 !important
}

a {
	transition: all 0.5s ease
}

a.text-success:hover,
a.text-success:focus {
	color: #40c18b !important
}

.bg-warning {
	background-color: #f1b561 !important
}

.bg-soft-warning {
	background-color: rgba(241, 181, 97, 0.1) !important;
	border: 1px solid rgba(241, 181, 97, 0.1) !important;
	color: #f1b561 !important
}

.text-warning {
	color: #f1b561 !important
}

a {
	transition: all 0.5s ease
}

a.text-warning:hover,
a.text-warning:focus {
	color: #efaa4a !important
}

.bg-info {
	background-color: #64c2f1 !important
}

.bg-soft-info {
	background-color: rgba(100, 194, 241, 0.1) !important;
	border: 1px solid rgba(100, 194, 241, 0.1) !important;
	color: #64c2f1 !important
}

.text-info {
	color: #64c2f1 !important
}

a {
	transition: all 0.5s ease
}

a.text-info:hover,
a.text-info:focus {
	color: #4db9ef !important
}

.bg-danger {
	background-color: #f0735a !important
}

.bg-soft-danger {
	background-color: rgba(240, 115, 90, 0.1) !important;
	border: 1px solid rgba(240, 115, 90, 0.1) !important;
	color: #f0735a !important
}

.text-danger {
	color: #f0735a !important
}

a {
	transition: all 0.5s ease
}

a.text-danger:hover,
a.text-danger:focus {
	color: #ee5f43 !important
}

.bg-dark {
	background-color: #343a40 !important
}

.bg-soft-dark {
	background-color: rgba(52, 58, 64, 0.1) !important;
	border: 1px solid rgba(52, 58, 64, 0.1) !important;
	color: #343a40 !important
}

.text-dark {
	color: #343a40 !important
}

a {
	transition: all 0.5s ease
}

a.text-dark:hover,
a.text-dark:focus {
	color: #292d32 !important
}

.bg-muted {
	background-color: #8492a6 !important
}

.bg-soft-muted {
	background-color: rgba(132, 146, 166, 0.1) !important;
	border: 1px solid rgba(132, 146, 166, 0.1) !important;
	color: #8492a6 !important
}

.text-muted {
	color: #8492A6 !important
}

.cstm-tx14 {
	font-size: 14px;
}

a {
	transition: all 0.5s ease
}

a.text-muted:hover,
a.text-muted:focus {
	color: #75859b !important
}

.bg-light {
	background-color: #f8f9fc !important
}

.bg-soft-light {
	background-color: rgba(248, 249, 252, 0.1) !important;
	border: 1px solid rgba(248, 249, 252, 0.1) !important;
	color: #f8f9fc !important
}

.text-light {
	color: #f8f9fc !important
}

a {
	transition: all 0.5s ease
}

a.text-light:hover,
a.text-light:focus {
	color: #e6eaf4 !important
}

.bg-footer {
	background-color: #202942 !important
}

.bg-soft-footer {
	background-color: rgba(32, 41, 66, 0.1) !important;
	border: 1px solid rgba(32, 41, 66, 0.1) !important;
	color: #202942 !important
}

.text-footer {
	color: #202942 !important
}

a {
	transition: all 0.5s ease
}

a.text-footer:hover,
a.text-footer:focus {
	color: #181e30 !important
}

.bg-white-50 {
	background-color: rgba(255, 255, 255, 0.5)
}

@media (min-width: 1400px) {
	.container {
		max-width: 1140px !important
	}
}

.row>* {
	position: relative
}

.list-inline-item:not(:last-child) {
	margin-right: 0px;
	margin-bottom: 5px
}

.margin-nagative.mt-n5 {
	margin-top: -48px
}

.d-flex .flex-1 {
	flex: 1 1
}

.rounded {
	border-radius: 5px !important
}

.rounded-top {
	border-top-left-radius: 5px !important;
	border-top-right-radius: 5px !important
}

.rounded-left {
	border-top-left-radius: 5px !important;
	border-bottom-left-radius: 5px !important
}

.rounded-bottom {
	border-bottom-left-radius: 5px !important;
	border-bottom-right-radius: 5px !important
}

.rounded-right {
	border-top-right-radius: 5px !important;
	border-bottom-right-radius: 5px !important
}

.rounded-md {
	border-radius: 10px !important
}

.rounded-lg {
	border-radius: 30px !important
}

.border {
	border: 1px solid #e9ecef !important
}

.border-top {
	border-top: 1px solid #e9ecef !important
}

.border-bottom {
	border-bottom: 1px solid #e9ecef !important
}

.border-left {
	border-left: 1px solid #e9ecef !important
}

.border-right {
	border-right: 1px solid #e9ecef !important
}

.small,
small {
	font-size: 14px;
}

.card {
	border: 0
}

.card .card-body {
	padding: 1.5rem
}

.offcanvas .offcanvas-header .dark-version {
	display: none
}

.offcanvas .offcanvas-header .light-version {
	display: inline-block
}

.offcanvas .offcanvas-header .btn-close {
	color: #343a40;
	background: none
}

.btn-primary {
	background-color: #00CCCC !important;
	border: 1px solid #00CCCC !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(57, 108, 240, 0.3)
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.btn-primary.focus {
	background-color: #215aee !important;
	border-color: #215aee !important;
	color: #fff !important
}

.btn-soft-primary {
	background-color: rgba(57, 108, 240, 0.1) !important;
	border: 1px solid rgba(57, 108, 240, 0.1) !important;
	color: #00CCCC !important;
	box-shadow: 0 3px 5px 0 rgba(57, 108, 240, 0.3)
}

.btn-soft-primary:hover,
.btn-soft-primary:focus,
.btn-soft-primary:active,
.btn-soft-primary.active,
.btn-soft-primary.focus {
	background-color: #00CCCC !important;
	border-color: #00CCCC !important;
	color: #fff !important
}

.btn-outline-primary {
	border: 1px solid #00CCCC;
	color: #00CCCC;
	background-color: transparent
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active,
.btn-outline-primary.active,
.btn-outline-primary.focus,
.btn-outline-primary:not(:disabled):not(.disabled):active {
	background-color: #00CCCC;
	border-color: #00CCCC;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(57, 108, 240, 0.3)
}

.btn-secondary {
	background-color: #5a6d90 !important;
	border: 1px solid #5a6d90 !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(90, 109, 144, 0.3)
}

.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary:active,
.btn-secondary.active,
.btn-secondary.focus {
	background-color: #506180 !important;
	border-color: #506180 !important;
	color: #fff !important
}

.btn-soft-secondary {
	background-color: rgba(90, 109, 144, 0.1) !important;
	border: 1px solid rgba(90, 109, 144, 0.1) !important;
	color: #5a6d90 !important;
	box-shadow: 0 3px 5px 0 rgba(90, 109, 144, 0.3)
}

.btn-soft-secondary:hover,
.btn-soft-secondary:focus,
.btn-soft-secondary:active,
.btn-soft-secondary.active,
.btn-soft-secondary.focus {
	background-color: #5a6d90 !important;
	border-color: #5a6d90 !important;
	color: #fff !important
}

.btn-outline-secondary {
	border: 1px solid #5a6d90;
	color: #5a6d90;
	background-color: transparent
}

.btn-outline-secondary:hover,
.btn-outline-secondary:focus,
.btn-outline-secondary:active,
.btn-outline-secondary.active,
.btn-outline-secondary.focus,
.btn-outline-secondary:not(:disabled):not(.disabled):active {
	background-color: #5a6d90;
	border-color: #5a6d90;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(90, 109, 144, 0.3)
}

.btn-success {
	background-color: #53c797 !important;
	border: 1px solid #53c797 !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(83, 199, 151, 0.3)
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.btn-success.focus {
	background-color: #40c18b !important;
	border-color: #40c18b !important;
	color: #fff !important
}

.btn-soft-success {
	background-color: rgba(83, 199, 151, 0.1) !important;
	border: 1px solid rgba(83, 199, 151, 0.1) !important;
	color: #53c797 !important;
	box-shadow: 0 3px 5px 0 rgba(83, 199, 151, 0.3)
}

.btn-soft-success:hover,
.btn-soft-success:focus,
.btn-soft-success:active,
.btn-soft-success.active,
.btn-soft-success.focus {
	background-color: #53c797 !important;
	border-color: #53c797 !important;
	color: #fff !important
}

.btn-outline-success {
	border: 1px solid #53c797;
	color: #53c797;
	background-color: transparent
}

.btn-outline-success:hover,
.btn-outline-success:focus,
.btn-outline-success:active,
.btn-outline-success.active,
.btn-outline-success.focus,
.btn-outline-success:not(:disabled):not(.disabled):active {
	background-color: #53c797;
	border-color: #53c797;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(83, 199, 151, 0.3)
}

.btn-warning {
	background-color: #f1b561 !important;
	border: 1px solid #f1b561 !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(241, 181, 97, 0.3)
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.btn-warning.focus {
	background-color: #efaa4a !important;
	border-color: #efaa4a !important;
	color: #fff !important
}

.btn-soft-warning {
	background-color: rgba(241, 181, 97, 0.1) !important;
	border: 1px solid rgba(241, 181, 97, 0.1) !important;
	color: #f1b561 !important;
	box-shadow: 0 3px 5px 0 rgba(241, 181, 97, 0.3)
}

.btn-soft-warning:hover,
.btn-soft-warning:focus,
.btn-soft-warning:active,
.btn-soft-warning.active,
.btn-soft-warning.focus {
	background-color: #f1b561 !important;
	border-color: #f1b561 !important;
	color: #fff !important
}

.btn-outline-warning {
	border: 1px solid #f1b561;
	color: #f1b561;
	background-color: transparent
}

.btn-outline-warning:hover,
.btn-outline-warning:focus,
.btn-outline-warning:active,
.btn-outline-warning.active,
.btn-outline-warning.focus,
.btn-outline-warning:not(:disabled):not(.disabled):active {
	background-color: #f1b561;
	border-color: #f1b561;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(241, 181, 97, 0.3)
}

.btn-info {
	background-color: #64c2f1 !important;
	border: 1px solid #64c2f1 !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(100, 194, 241, 0.3)
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.btn-info.focus {
	background-color: #4db9ef !important;
	border-color: #4db9ef !important;
	color: #fff !important
}

.btn-soft-info {
	background-color: rgba(100, 194, 241, 0.1) !important;
	border: 1px solid rgba(100, 194, 241, 0.1) !important;
	color: #64c2f1 !important;
	box-shadow: 0 3px 5px 0 rgba(100, 194, 241, 0.3)
}

.btn-soft-info:hover,
.btn-soft-info:focus,
.btn-soft-info:active,
.btn-soft-info.active,
.btn-soft-info.focus {
	background-color: #64c2f1 !important;
	border-color: #64c2f1 !important;
	color: #fff !important
}

.btn-outline-info {
	border: 1px solid #64c2f1;
	color: #64c2f1;
	background-color: transparent
}

.btn-outline-info:hover,
.btn-outline-info:focus,
.btn-outline-info:active,
.btn-outline-info.active,
.btn-outline-info.focus,
.btn-outline-info:not(:disabled):not(.disabled):active {
	background-color: #64c2f1;
	border-color: #64c2f1;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(100, 194, 241, 0.3)
}

.btn-danger {
	background-color: #f0735a !important;
	border: 1px solid #f0735a !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(240, 115, 90, 0.3)
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.btn-danger.focus {
	background-color: #ee5f43 !important;
	border-color: #ee5f43 !important;
	color: #fff !important
}

.btn-soft-danger {
	background-color: rgba(240, 115, 90, 0.1) !important;
	border: 1px solid rgba(240, 115, 90, 0.1) !important;
	color: #f0735a !important;
	box-shadow: 0 3px 5px 0 rgba(240, 115, 90, 0.3)
}

.btn-soft-danger:hover,
.btn-soft-danger:focus,
.btn-soft-danger:active,
.btn-soft-danger.active,
.btn-soft-danger.focus {
	background-color: #f0735a !important;
	border-color: #f0735a !important;
	color: #fff !important
}

.btn-outline-danger {
	border: 1px solid #f0735a;
	color: #f0735a;
	background-color: transparent
}

.btn-outline-danger:hover,
.btn-outline-danger:focus,
.btn-outline-danger:active,
.btn-outline-danger.active,
.btn-outline-danger.focus,
.btn-outline-danger:not(:disabled):not(.disabled):active {
	background-color: #f0735a;
	border-color: #f0735a;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(240, 115, 90, 0.3)
}

.btn-dark {
	background-color: #343a40 !important;
	border: 1px solid #343a40 !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(52, 58, 64, 0.3)
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active,
.btn-dark.focus {
	background-color: #292d32 !important;
	border-color: #292d32 !important;
	color: #fff !important
}

.btn-soft-dark {
	background-color: rgba(52, 58, 64, 0.1) !important;
	border: 1px solid rgba(52, 58, 64, 0.1) !important;
	color: #343a40 !important;
	box-shadow: 0 3px 5px 0 rgba(52, 58, 64, 0.3)
}

.btn-soft-dark:hover,
.btn-soft-dark:focus,
.btn-soft-dark:active,
.btn-soft-dark.active,
.btn-soft-dark.focus {
	background-color: #343a40 !important;
	border-color: #343a40 !important;
	color: #fff !important
}

.btn-outline-dark {
	border: 1px solid #343a40;
	color: #343a40;
	background-color: transparent
}

.btn-outline-dark:hover,
.btn-outline-dark:focus,
.btn-outline-dark:active,
.btn-outline-dark.active,
.btn-outline-dark.focus,
.btn-outline-dark:not(:disabled):not(.disabled):active {
	background-color: #343a40;
	border-color: #343a40;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(52, 58, 64, 0.3)
}

.btn-muted {
	background-color: #8492a6 !important;
	border: 1px solid #8492a6 !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(132, 146, 166, 0.3)
}

.btn-muted:hover,
.btn-muted:focus,
.btn-muted:active,
.btn-muted.active,
.btn-muted.focus {
	background-color: #75859b !important;
	border-color: #75859b !important;
	color: #fff !important
}

.btn-soft-muted {
	background-color: rgba(132, 146, 166, 0.1) !important;
	border: 1px solid rgba(132, 146, 166, 0.1) !important;
	color: #8492a6 !important;
	box-shadow: 0 3px 5px 0 rgba(132, 146, 166, 0.3)
}

.btn-soft-muted:hover,
.btn-soft-muted:focus,
.btn-soft-muted:active,
.btn-soft-muted.active,
.btn-soft-muted.focus {
	background-color: #8492a6 !important;
	border-color: #8492a6 !important;
	color: #fff !important
}

.btn-outline-muted {
	border: 1px solid #8492a6;
	color: #8492a6;
	background-color: transparent
}

.btn-outline-muted:hover,
.btn-outline-muted:focus,
.btn-outline-muted:active,
.btn-outline-muted.active,
.btn-outline-muted.focus,
.btn-outline-muted:not(:disabled):not(.disabled):active {
	background-color: #8492a6;
	border-color: #8492a6;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(132, 146, 166, 0.3)
}

.btn-light {
	background-color: #f8f9fc !important;
	border: 1px solid #f8f9fc !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.3)
}

.btn-light:hover,
.btn-light:focus,
.btn-light:active,
.btn-light.active,
.btn-light.focus {
	background-color: #e6eaf4 !important;
	border-color: #e6eaf4 !important;
	color: #fff !important
}

.btn-soft-light {
	background-color: rgba(248, 249, 252, 0.1) !important;
	border: 1px solid rgba(248, 249, 252, 0.1) !important;
	color: #f8f9fc !important;
	box-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.3)
}

.btn-soft-light:hover,
.btn-soft-light:focus,
.btn-soft-light:active,
.btn-soft-light.active,
.btn-soft-light.focus {
	background-color: #f8f9fc !important;
	border-color: #f8f9fc !important;
	color: #fff !important
}

.btn-outline-light {
	border: 1px solid #f8f9fc;
	color: #f8f9fc;
	background-color: transparent
}

.btn-outline-light:hover,
.btn-outline-light:focus,
.btn-outline-light:active,
.btn-outline-light.active,
.btn-outline-light.focus,
.btn-outline-light:not(:disabled):not(.disabled):active {
	background-color: #f8f9fc;
	border-color: #f8f9fc;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.3)
}

.btn-footer {
	background-color: #202942 !important;
	border: 1px solid #202942 !important;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(32, 41, 66, 0.3)
}

.btn-footer:hover,
.btn-footer:focus,
.btn-footer:active,
.btn-footer.active,
.btn-footer.focus {
	background-color: #181e30 !important;
	border-color: #181e30 !important;
	color: #fff !important
}

.btn-soft-footer {
	background-color: rgba(32, 41, 66, 0.1) !important;
	border: 1px solid rgba(32, 41, 66, 0.1) !important;
	color: #202942 !important;
	box-shadow: 0 3px 5px 0 rgba(32, 41, 66, 0.3)
}

.btn-soft-footer:hover,
.btn-soft-footer:focus,
.btn-soft-footer:active,
.btn-soft-footer.active,
.btn-soft-footer.focus {
	background-color: #202942 !important;
	border-color: #202942 !important;
	color: #fff !important
}

.btn-outline-footer {
	border: 1px solid #202942;
	color: #202942;
	background-color: transparent
}

.btn-outline-footer:hover,
.btn-outline-footer:focus,
.btn-outline-footer:active,
.btn-outline-footer.active,
.btn-outline-footer.focus,
.btn-outline-footer:not(:disabled):not(.disabled):active {
	background-color: #202942;
	border-color: #202942;
	color: #fff !important;
	box-shadow: 0 3px 5px 0 rgba(32, 41, 66, 0.3)
}

.btn {
	padding: 8px 20px;
	outline: none;
	text-decoration: none;
	font-size: 15px;
	letter-spacing: 0.5px;
	transition: all 0.3s;
	border-radius: 5px
}

.btn:focus {
	box-shadow: none !important
}

.btn.btn-sm {
	padding: 7px 16px;
	font-size: 10px
}

.btn.btn-lg {
	padding: 14px 30px;
	font-size: 16px
}

.btn.btn-pills {
	border-radius: 30px
}

.btn.btn-light {
	color: #343a40 !important;
	border: 1px solid #dee2e6 !important
}

.btn.btn-light:hover,
.btn.btn-light:focus,
.btn.btn-light:active,
.btn.btn-light.active,
.btn.btn-light.focus {
	background-color: #fff !important;
	color: #343a40 !important
}

.btn.btn-soft-light {
	color: rgba(52, 58, 64, 0.5) !important;
	border: 1px solid rgba(248, 249, 252, 0.1) !important;
	background-color: rgba(248, 249, 252, 0.1);
	box-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.2)
}

.btn.btn-soft-light:hover,
.btn.btn-soft-light:focus,
.btn.btn-soft-light:active,
.btn.btn-soft-light.active,
.btn.btn-soft-light.focus {
	color: #343a40 !important
}

.btn.btn-soft-light-alt {
	background-color: rgba(248, 249, 252, 0.1);
	color: #f8f9fc;
	border: 1px solid rgba(248, 249, 252, 0.1);
	box-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.2)
}

.btn.btn-soft-light-alt:hover,
.btn.btn-soft-light-alt:focus,
.btn.btn-soft-light-alt:active,
.btn.btn-soft-light-alt.active,
.btn.btn-soft-light-alt.focus {
	background: #fff;
	color: #343a40 !important
}

.btn.btn-outline-light {
	border: 1px solid #dee2e6 !important;
	color: #343a40 !important;
	background-color: transparent
}

.btn.btn-outline-light:hover,
.btn.btn-outline-light:focus,
.btn.btn-outline-light:active,
.btn.btn-outline-light.active,
.btn.btn-outline-light.focus {
	background-color: #f8f9fc !important
}

.btn.btn-outline-light-alt {
	border: 1px solid #dee2e6 !important;
	color: #fff !important;
	background-color: transparent
}

.btn.btn-outline-light-alt:hover,
.btn.btn-outline-light-alt:focus,
.btn.btn-outline-light-alt:active,
.btn.btn-outline-light-alt.active,
.btn.btn-outline-light-alt.focus {
	background-color: #f8f9fc !important;
	color: #343a40 !important
}

.btn.btn-icon {
	height: 36px;
	width: 36px;
	line-height: 34px;
	padding: 0
}

.btn.btn-icon .icons {
	height: 16px;
	width: 16px;
	font-size: 16px
}

.btn.btn-icon.btn-lg {
	height: 48px;
	width: 48px;
	line-height: 46px
}

.btn.btn-icon.btn-lg .icons {
	height: 20px;
	width: 20px;
	font-size: 20px
}

.btn.btn-icon.btn-sm {
	height: 30px;
	width: 30px;
	line-height: 28px
}

button:not(:disabled) {
	outline: none
}

.shadow {
	box-shadow: 0 0 3px rgba(52, 58, 64, 0.15) !important
}

.shadow-lg {
	box-shadow: 0 10px 25px rgba(52, 58, 64, 0.15) !important
}

.shadow-md {
	box-shadow: 0 5px 13px rgba(52, 58, 64, 0.2) !important
}

.badge-primary {
	background-color: #00CCCC !important;
	color: #fff !important
}

.badge-outline-primary {
	background-color: transparent !important;
	color: #00CCCC !important;
	border: 1px solid #00CCCC !important
}

.badge-soft-primary {
	background-color: rgba(57, 108, 240, 0.1) !important;
	border: 1px solid rgba(57, 108, 240, 0.1) !important;
	color: #00CCCC !important
}

.badge-secondary {
	background-color: #5a6d90 !important;
	color: #fff !important
}

.badge-outline-secondary {
	background-color: transparent !important;
	color: #5a6d90 !important;
	border: 1px solid #5a6d90 !important
}

.badge-soft-secondary {
	background-color: rgba(90, 109, 144, 0.1) !important;
	border: 1px solid rgba(90, 109, 144, 0.1) !important;
	color: #5a6d90 !important
}

.badge-success {
	background-color: #53c797 !important;
	color: #fff !important
}

.badge-outline-success {
	background-color: transparent !important;
	color: #53c797 !important;
	border: 1px solid #53c797 !important
}

.badge-soft-success {
	background-color: rgba(83, 199, 151, 0.1) !important;
	border: 1px solid rgba(83, 199, 151, 0.1) !important;
	color: #53c797 !important
}

.badge-warning {
	background-color: #f1b561 !important;
	color: #fff !important
}

.badge-outline-warning {
	background-color: transparent !important;
	color: #f1b561 !important;
	border: 1px solid #f1b561 !important
}

.badge-soft-warning {
	background-color: rgba(241, 181, 97, 0.1) !important;
	border: 1px solid rgba(241, 181, 97, 0.1) !important;
	color: #f1b561 !important
}

.badge-info {
	background-color: #64c2f1 !important;
	color: #fff !important
}

.badge-outline-info {
	background-color: transparent !important;
	color: #64c2f1 !important;
	border: 1px solid #64c2f1 !important
}

.badge-soft-info {
	background-color: rgba(100, 194, 241, 0.1) !important;
	border: 1px solid rgba(100, 194, 241, 0.1) !important;
	color: #64c2f1 !important
}

.badge-danger {
	background-color: #f0735a !important;
	color: #fff !important
}

.badge-outline-danger {
	background-color: transparent !important;
	color: #f0735a !important;
	border: 1px solid #f0735a !important
}

.badge-soft-danger {
	background-color: rgba(240, 115, 90, 0.1) !important;
	border: 1px solid rgba(240, 115, 90, 0.1) !important;
	color: #f0735a !important
}

.badge-dark {
	background-color: #343a40 !important;
	color: #fff !important
}

.badge-outline-dark {
	background-color: transparent !important;
	color: #343a40 !important;
	border: 1px solid #343a40 !important
}

.badge-soft-dark {
	background-color: rgba(52, 58, 64, 0.1) !important;
	border: 1px solid rgba(52, 58, 64, 0.1) !important;
	color: #343a40 !important
}

.badge-muted {
	background-color: #8492a6 !important;
	color: #fff !important
}

.badge-outline-muted {
	background-color: transparent !important;
	color: #8492a6 !important;
	border: 1px solid #8492a6 !important
}

.badge-soft-muted {
	background-color: rgba(132, 146, 166, 0.1) !important;
	border: 1px solid rgba(132, 146, 166, 0.1) !important;
	color: #8492a6 !important
}

.badge-light {
	background-color: #f8f9fc !important;
	color: #fff !important
}

.badge-outline-light {
	background-color: transparent !important;
	color: #f8f9fc !important;
	border: 1px solid #f8f9fc !important
}

.badge-soft-light {
	background-color: rgba(248, 249, 252, 0.1) !important;
	border: 1px solid rgba(248, 249, 252, 0.1) !important;
	color: #f8f9fc !important
}

.badge-footer {
	background-color: #202942 !important;
	color: #fff !important
}

.badge-outline-footer {
	background-color: transparent !important;
	color: #202942 !important;
	border: 1px solid #202942 !important
}

.badge-soft-footer {
	background-color: rgba(32, 41, 66, 0.1) !important;
	border: 1px solid rgba(32, 41, 66, 0.1) !important;
	color: #202942 !important
}

.badge {
	display: inline-block;
	letter-spacing: 0.5px;
	padding: 4px 8px;
	font-weight: 600;
	line-height: 1;
	text-align: center
}

.badge.badge-light {
	color: #343a40 !important;
	background-color: #f8f9fc !important
}

.badge.badge-outline-light {
	color: #343a40 !important;
	border: 1px solid #fff !important;
	background-color: transparent !important
}

.badge.badge-pill {
	border-radius: 12px
}

.badge:focus,
.badge.focus {
	box-shadow: none !important
}

.dropdown-primary .dropdown-menu .dropdown-item:hover,
.dropdown-primary .dropdown-menu .dropdown-item.active,
.dropdown-primary .dropdown-menu .dropdown-item:active,
.dropdown-primary .dropdown-menu .dropdown-item.focus,
.dropdown-primary .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #00CCCC !important
}

.dropdown-secondary .dropdown-menu .dropdown-item:hover,
.dropdown-secondary .dropdown-menu .dropdown-item.active,
.dropdown-secondary .dropdown-menu .dropdown-item:active,
.dropdown-secondary .dropdown-menu .dropdown-item.focus,
.dropdown-secondary .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #5a6d90 !important
}

.dropdown-success .dropdown-menu .dropdown-item:hover,
.dropdown-success .dropdown-menu .dropdown-item.active,
.dropdown-success .dropdown-menu .dropdown-item:active,
.dropdown-success .dropdown-menu .dropdown-item.focus,
.dropdown-success .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #53c797 !important
}

.dropdown-warning .dropdown-menu .dropdown-item:hover,
.dropdown-warning .dropdown-menu .dropdown-item.active,
.dropdown-warning .dropdown-menu .dropdown-item:active,
.dropdown-warning .dropdown-menu .dropdown-item.focus,
.dropdown-warning .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #f1b561 !important
}

.dropdown-info .dropdown-menu .dropdown-item:hover,
.dropdown-info .dropdown-menu .dropdown-item.active,
.dropdown-info .dropdown-menu .dropdown-item:active,
.dropdown-info .dropdown-menu .dropdown-item.focus,
.dropdown-info .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #64c2f1 !important
}

.dropdown-danger .dropdown-menu .dropdown-item:hover,
.dropdown-danger .dropdown-menu .dropdown-item.active,
.dropdown-danger .dropdown-menu .dropdown-item:active,
.dropdown-danger .dropdown-menu .dropdown-item.focus,
.dropdown-danger .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #f0735a !important
}

.dropdown-dark .dropdown-menu .dropdown-item:hover,
.dropdown-dark .dropdown-menu .dropdown-item.active,
.dropdown-dark .dropdown-menu .dropdown-item:active,
.dropdown-dark .dropdown-menu .dropdown-item.focus,
.dropdown-dark .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #343a40 !important
}

.dropdown-muted .dropdown-menu .dropdown-item:hover,
.dropdown-muted .dropdown-menu .dropdown-item.active,
.dropdown-muted .dropdown-menu .dropdown-item:active,
.dropdown-muted .dropdown-menu .dropdown-item.focus,
.dropdown-muted .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #8492a6 !important
}

.dropdown-light .dropdown-menu .dropdown-item:hover,
.dropdown-light .dropdown-menu .dropdown-item.active,
.dropdown-light .dropdown-menu .dropdown-item:active,
.dropdown-light .dropdown-menu .dropdown-item.focus,
.dropdown-light .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #f8f9fc !important
}

.dropdown-footer .dropdown-menu .dropdown-item:hover,
.dropdown-footer .dropdown-menu .dropdown-item.active,
.dropdown-footer .dropdown-menu .dropdown-item:active,
.dropdown-footer .dropdown-menu .dropdown-item.focus,
.dropdown-footer .dropdown-menu .dropdown-item:focus {
	background-color: transparent;
	color: #202942 !important
}

.dropdown-menu {
	margin-top: 10px;
	border: 0;
	border-radius: 5px;
	box-shadow: 0 0 3px rgba(52, 58, 64, 0.15);
	/* top: 2px !important */
}

.dropdown-menu .dropdown-item {
	padding: 5px 20px;
	clear: both;
	white-space: nowrap;
	font-size: 11px;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	font-weight: 600
}

.dropdown .dropdown-toggle:after {
	display: none !important
}

.alert-primary {
	background-color: rgba(57, 108, 240, 0.9);
	color: #fff;
	border-color: #00CCCC
}

.alert-primary .alert-link {
	color: #0a2d86
}

.alert-outline-primary {
	background-color: transparent;
	color: #00CCCC;
	border-color: #00CCCC
}

.alert-secondary {
	background-color: rgba(90, 109, 144, 0.9);
	color: #fff;
	border-color: #5a6d90
}

.alert-secondary .alert-link {
	color: #1f2632
}

.alert-outline-secondary {
	background-color: transparent;
	color: #5a6d90;
	border-color: #5a6d90
}

.alert-success {
	background-color: rgba(83, 199, 151, 0.9);
	color: #fff;
	border-color: #53c797
}

.alert-success .alert-link {
	color: #206146
}

.alert-outline-success {
	background-color: transparent;
	color: #53c797;
	border-color: #53c797
}

.alert-warning {
	background-color: rgba(241, 181, 97, 0.9);
	color: #fff;
	border-color: #f1b561
}

.alert-warning .alert-link {
	color: #aa690f
}

.alert-outline-warning {
	background-color: transparent;
	color: #f1b561;
	border-color: #f1b561
}

.alert-info {
	background-color: rgba(100, 194, 241, 0.9);
	color: #fff;
	border-color: #64c2f1
}

.alert-info .alert-link {
	color: #1078ac
}

.alert-outline-info {
	background-color: transparent;
	color: #64c2f1;
	border-color: #64c2f1
}

.alert-danger {
	background-color: rgba(240, 115, 90, 0.9);
	color: #fff;
	border-color: #f0735a
}

.alert-danger .alert-link {
	color: #a2270f
}

.alert-outline-danger {
	background-color: transparent;
	color: #f0735a;
	border-color: #f0735a
}

.alert-dark {
	background-color: rgba(52, 58, 64, 0.9);
	color: #fff;
	border-color: #343a40
}

.alert-dark .alert-link {
	color: #000
}

.alert-outline-dark {
	background-color: transparent;
	color: #343a40;
	border-color: #343a40
}

.alert-muted {
	background-color: rgba(132, 146, 166, 0.9);
	color: #fff;
	border-color: #8492a6
}

.alert-muted .alert-link {
	color: #3d4654
}

.alert-outline-muted {
	background-color: transparent;
	color: #8492a6;
	border-color: #8492a6
}

.alert-light {
	background-color: rgba(248, 249, 252, 0.9);
	color: #fff;
	border-color: #f8f9fc
}

.alert-light .alert-link {
	color: #8d9dce
}

.alert-outline-light {
	background-color: transparent;
	color: #f8f9fc;
	border-color: #f8f9fc
}

.alert-footer {
	background-color: rgba(32, 41, 66, 0.9);
	color: #fff;
	border-color: #202942
}

.alert-footer .alert-link {
	color: #000
}

.alert-outline-footer {
	background-color: transparent;
	color: #202942;
	border-color: #202942
}

.alert {
	padding: 8px 15px;
	border-radius: 5px;
	font-size: 14px
}

.alert.alert-light {
	background-color: #fff;
	color: #343a40;
	border-color: #e9ecef
}

.alert.alert-dismissible {
	padding-right: 30px
}

.alert.alert-dismissible .close {
	top: -2px;
	right: -10px;
	font-size: 16px !important
}

.alert.alert-pills {
	border-radius: 30px;
	display: inline-block
}

.alert.alert-pills .content {
	font-weight: 600
}

.breadcrumb {
	letter-spacing: 0.5px;
	padding: 8px 24px;
	display: block
}

.breadcrumb .breadcrumb-item {
	text-transform: uppercase;
	font-size: 12px;
	font-weight: 500;
	padding-left: 0;
	display: inline-block
}

.breadcrumb .breadcrumb-item a {
	color: #343a40
}

.breadcrumb .breadcrumb-item a:hover {
	color: #00CCCC
}

.breadcrumb .breadcrumb-item.active {
	color: #00CCCC
}

.breadcrumb .breadcrumb-item:before {
	content: ""
}

.breadcrumb .breadcrumb-item:after {
	content: "\\F0142" !important;
	color: #343a40;
	font-family: 'Material Design Icons';
	padding-left: 5px
}

.breadcrumb .breadcrumb-item:last-child:after {
	display: none
}

.pagination .page-item:first-child .page-link {
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px
}

.pagination .page-item:last-child .page-link {
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px
}

.pagination .page-item .page-link {
	color: #343a40;
	border: 1px solid #dee2e6;
	padding: 8px 16px;
	font-size: 14px
}

.pagination .page-item .page-link:focus {
	box-shadow: none
}

.pagination .page-item .page-link:hover {
	color: #fff;
	background: #00CCCC;
	border-color: #00CCCC;
}

.pagination .page-item.active .page-link {
	color: #fff;
	background: #00CCCC !important;
	border-color: #00CCCC;
	cursor: not-allowed
}

#preloader {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-image: linear-gradient(45deg, #fff, #fff);
	z-index: 9999999
}

#preloader #status {
	position: absolute;
	left: 0;
	right: 0;
	top: 50%;
	transform: translateY(-50%)
}

#preloader #status .spinner {
	width: 40px;
	height: 40px;
	position: relative;
	margin: 100px auto
}

#preloader #status .spinner .double-bounce1,
#preloader #status .spinner .double-bounce2 {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background-color: #00CCCC;
	opacity: 0.6;
	position: absolute;
	top: 0;
	left: 0;
	animation: sk-bounce 2s infinite ease-in-out
}

#preloader #status .spinner .double-bounce2 {
	animation-delay: -1s
}

@keyframes sk-bounce {

	0%,
	100% {
		transform: scale(0)
	}

	50% {
		transform: scale(1)
	}
}

.avatar.avatar-ex-sm {
	height: 30px;
	width: 30px
}

.avatar.avatar-ex-small {
	height: 40px;
	width: 40px
}

.avatar.avatar-md-sm {
	height: 45px;
	width: 45px
}

.avatar.avatar-small {
	height: 65px;
	width: 65px
}

.avatar.avatar-md-md {
	height: 80px;
	width: 80px
}

.avatar.avatar-medium {
	height: 110px;
	width: 110px
}

.avatar.avatar-large {
	height: 140px;
	width: 140px
}

.avatar.avatar-ex-large {
	height: 180px;
	width: 180px
}

.avatar.avatar-client {
	max-height: 25px
}

.accordion .accordion-item {
	overflow: hidden;
	background: transparent
}

.accordion .accordion-item .accordion-button {
	font-weight: 600;
	text-align: left;
	box-shadow: none;
	padding: 1rem 2.5rem 1rem 1.25rem
}

.accordion .accordion-item .accordion-button:focus {
	box-shadow: none
}

.accordion .accordion-item .accordion-button:before {
	content: '\\F0143';
	display: block;
	font-family: 'Material Design Icons';
	font-size: 16px;
	color: #00CCCC;
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
	transition: all 0.5s ease
}

.accordion .accordion-item .accordion-button.collapsed {
	background-color: #fff;
	color: #343a40 !important;
	transition: all 0.5s
}

.accordion .accordion-item .accordion-button.collapsed:before {
	top: 15px;
	transform: rotate(180deg);
	color: #343a40 !important
}

.accordion .accordion-item .accordion-button:after {
	display: none
}

.nav-pills {
	margin-bottom: 15px;
	background: #f4f6fa
}

.nav-pills .nav-link {
	color: #495057 !important;
	padding: 5px;
	transition: all 0.5s ease
}

.nav-pills .nav-link.nav-link-alt.active {
	background: #343a40;
	color: #fff !important
}

.nav-pills .nav-link.active {
	background: #00CCCC;
	color: #fff !important
}

.nav-pills .nav-link.active .tab-para {
	color: rgba(255, 255, 255, 0.65) !important
}

.nav-pills a .title {
	font-size: 17px !important
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
	color: #00CCCC !important;
	border-color: transparent transparent #00CCCC !important
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
	border-color: transparent
}

.progress-box .title {
	font-size: 15px
}

.progress-box .progress {
	height: 8px;
	overflow: visible
}

.progress-box .progress .progress-bar {
	border-radius: 5px;
	overflow: visible !important
}

.progress-box .progress .progress-value {
	position: absolute;
	top: -28px;
	right: -15px;
	font-size: 14px
}

.blockquote {
	border-left: 3px solid #dee2e6;
	border-radius: 5px;
	font-size: 16px
}

.form-label {
	font-weight: 500
}

.form-control {
	border: 1px solid #e9ecef;
	font-size: 14px;
	line-height: 26px;
	background-color: #fff
}

.form-control:focus {
	border-color: #00CCCC;
	box-shadow: none
}

.form-control[readonly] {
	background-color: #fff
}

.form-control:disabled {
	background-color: #e9ecef
}

.form-control::placeholder {
	color: #343a40
}

.form-check-input:focus {
	border-color: #00CCCC;
	box-shadow: none
}

.select2-container {
	display: block !important;
	width: 100% !important
}

.select2-container--default .select2-selection--single {
	background-color: #fff !important;
	border: 1px solid #dee2e6 !important;
	border-radius: 5px !important;
	height: 40px !important;
	text-align: left
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
	color: #343a40 !important;
	line-height: 40px !important;
	font-size: 13px !important
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
	border-color: #343a40 transparent transparent transparent;
	top: 20px
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
	border-color: transparent transparent #343a40 transparent
}

.select2-container--default .select2-search--dropdown .select2-search__field {
	border: 1px solid #dee2e6;
	border-radius: 5px
}

.select2-container--default .select2-search--dropdown .select2-search__field:focus {
	outline: none;
	border-color: #00CCCC !important
}

.select2-container--default .select2-results__option--selected {
	background-color: #00CCCC !important;
	color: #fff !important
}

.select2-container--default .select2-results__option--highlighted.select2-results__option--selectable {
	background-color: #00CCCC !important;
	color: #fff !important
}

.select2-selection:focus,
.select2-selection:active {
	outline: none;
	border-color: #00CCCC !important
}

.select2-results__option {
	color: #8492a6
}

.select2-dropdown {
	border: 1px solid #dee2e6 !important;
	border-radius: 5px !important
}

.apexcharts-tooltip {
	background: #fff !important;
	color: #343a40;
	border-color: #e9ecef !important
}

.apexcharts-gridlines-horizontal,
.apexcharts-gridlines-vertical,
.apexcharts-grid,
.apexcharts-gridline,
.apexcharts-xaxis-tick,
.apexcharts-xaxis line,
.apexcharts-gridline line,
.apexcharts-radar-series line,
.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,
.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,
.apexcharts-radar-series path,
.apexcharts-radar-series polygon {
	pointer-events: none;
	stroke: #e9ecef
}

.apexcharts-tooltip-title {
	background: #fff !important;
	color: #343a40;
	border-color: #e9ecef !important
}

.apexcharts-data-labels,
.apexcharts-datalabels text,
.apexcharts-xaxis text,
.apexcharts-yaxis text {
	fill: #343a40 !important
}

.apexcharts-legend-text {
	color: #343a40 !important;
	font-family: "Inter", sans-serif !important
}

.map {
	line-height: 0
}

.map iframe {
	width: 100%;
	height: 400px
}

.subcribe-form .btn {
	padding: 10px 20px
}

.subcribe-form input {
	padding: 12px 20px;
	width: 100%;
	color: #343a40 !important;
	border: none;
	outline: none !important;
	padding-right: 160px;
	padding-left: 20px;
	background-color: rgba(255, 255, 255, 0.8)
}

.subcribe-form button {
	position: absolute;
	top: 1.5px;
	right: 2px;
	outline: none !important
}

.subcribe-form form {
	position: relative;
	max-width: 600px;
	margin: 0px auto
}

.table-responsive {
	display: block;
	width: 100%;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch
}

.table-responsive .table tr td {
	border-color: #ffffff;
	vertical-align: middle;
	padding: 12px 16px !important;
	font-size: 14px;
	color: #3F3F46;
}

.table-responsive .table th {
	vertical-align: middle;
	border-color: #f2f4f6;
	padding: 12px 16px;
}

.table-responsive .table-center th {
	vertical-align: middle !important;
	cursor: pointer;
	font-weight: 600;
	font-size: 16px;
}

.table-responsive .table-center.invoice-tb th,
.table-responsive .table-center.invoice-tb td {
	text-align: end
}

.table-responsive .table-padding tr td {
	padding-top: 20px;
	padding-bottom: 20px
}

.social-icon li a {
	color: #343a40;
	border: 1px solid #343a40;
	display: inline-block;
	height: 32px;
	width: 32px;
	line-height: 30px;
	text-align: center;
	transition: all 0.4s ease;
	overflow: hidden;
	position: relative
}

.social-icon li a .fea-social {
	stroke-width: 2
}

.social-icon li a:hover {
	background-color: #00CCCC !important;
	border-color: #00CCCC !important;
	color: #fff !important
}

.social-icon li a:hover .fea-social {
	fill: #00CCCC
}

.social-icon.footer-social li a {
	border: none;
	color: #adb5bd;
	background-color: #2c385a
}

.social-icon.social li a {
	color: #adb5bd;
	border-color: #adb5bd
}

.home-shape-arrow {
	position: absolute;
	left: 0;
	right: 0;
	bottom: -24px;
	z-index: 1;
	text-align: center
}

.back-to-top {
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 99;
	display: none
}

.back-to-home {
	position: fixed;
	top: 4%;
	right: 2%;
	z-index: 1
}

.sticky-bar {
	position: sticky;
	top: 80px
}

.fea {
	stroke-width: 1.8
}

.fea.icon-sm {
	height: 16px;
	width: 16px
}

.fea.icon-ex-md {
	height: 20px;
	width: 20px
}

.fea.icon-m-md {
	height: 28px;
	width: 28px
}

.fea.icon-md {
	height: 35px;
	width: 35px
}

.fea.icon-lg {
	height: 42px;
	width: 42px
}

.fea.icon-ex-lg {
	height: 52px;
	width: 52px
}

[class^="uil-"]:before,
[class*=" uil-"]:before {
	margin: 0
}

.uim-svg {
	vertical-align: 0 !important
}

@media (max-width: 768px) {
	.display-1 {
		font-size: 56px !important
	}

	.display-2 {
		font-size: 50px !important
	}

	.display-3 {
		font-size: 42px !important
	}

	.display-4 {
		font-size: 36px !important
	}
}

body {
	background: #f8f9fc;
	font-family: "Inter", sans-serif;
	overflow-x: hidden !important;
	font-size: 16px;
	color: #201E29;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
	font-family: "Inter", sans-serif
}

::selection {
	background: rgba(57, 108, 240, 0.9);
	color: #fff
}

a {
	text-decoration: none !important
}

p {
	line-height: 1.6;
	color: #93969F;
}

#style-switcher .t-dark,
#style-switcher .t-rtl-light {
	display: inline-block
}

#style-switcher .t-ltr-light,
#style-switcher .t-light,
#style-switcher .t-rtl-dark,
#style-switcher .t-ltr-dark {
	display: none
}

.section {
	padding: 100px 0;
	position: relative
}

@media (max-width: 768px) {
	.section {
		padding: 60px 0
	}
}

.bg-overlay {
	background-color: rgba(52, 58, 64, 0.75);
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%
}

.heading-title {
	line-height: 26px
}

.heading-title .heading {
	font-size: 42px !important;
	letter-spacing: 1px
}

.heading-title .title {
	font-size: 32px !important;
	letter-spacing: 1px
}

.heading-title .para-desc {
	font-size: 17px
}

.section-title {
	position: relative
}

.section-title .title {
	letter-spacing: 0.5px;
	font-size: 24px !important
}

.section-title .sub-title {
	letter-spacing: 0.5px;
	font-size: 28px !important
}

.para-desc {
	max-width: 600px
}

.mt-100 {
	margin-top: 100px
}

.shape {
	position: absolute;
	pointer-events: none;
	right: 0;
	bottom: -2px;
	left: 0
}

.shape>svg {
	transform: scale(2);
	width: 100%;
	height: auto;
	transform-origin: top center
}

.shape.integration-hero {
	clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
	height: 250px;
	background: #fff
}

@media (max-width: 768px) {
	.shape.integration-hero {
		height: 140px
	}
}

@media (max-width: 425px) {
	.shape.integration-hero {
		height: 60px
	}
}

@media (max-width: 425px) {
	.shape {
		bottom: -4px
	}
}

.features-absolute {
	position: relative;
	margin: -200px 0 0px;
	z-index: 2;
	transition: all 0.5s ease
}

@media (max-width: 768px) {
	.features-absolute {
		margin: -140px 0 0
	}
}

.features-absolute.career-form {
	margin: -145px 0 0px
}

@media (max-width: 768px) {
	.features-absolute.career-form {
		margin: -105px 0 0px
	}
}

.feature-posts-placeholder {
	position: absolute;
	bottom: 0px;
	left: 0;
	right: 0;
	height: 66.6%
}

@media (max-width: 425px) {
	.feature-posts-placeholder {
		height: 80%
	}
}

@media (max-width: 768px) {
	.heading-title .heading {
		font-size: 36px !important
	}

	.heading-title .para-desc {
		font-size: 18px
	}

	.section-title .title {
		font-size: 24px !important
	}

	.mt-60 {
		margin-top: 60px
	}
}

#topnav {
	position: fixed;
	right: 0;
	left: 0;
	top: 0;
	z-index: 1030;
	background-color: transparent;
	border: 0;
	transition: all .5s ease
}

#topnav .logo {
	float: left;
	color: #343a40 !important;
	outline: none
}

#topnav .logo .l-dark,
#topnav .logo .logo-dark-mode {
	display: none
}

#topnav .logo .l-light,
#topnav .logo .logo-light-mode {
	display: inline-block
}

#topnav .has-submenu.active a {
	color: #fff
}

#topnav .has-submenu.active .submenu li.active>a {
	color: #00CCCC !important
}

#topnav .has-submenu.active.active .menu-arrow {
	border-color: #00CCCC
}

#topnav .has-submenu {
	position: relative
}

#topnav .has-submenu .submenu .submenu-arrow {
	border: solid #343a40;
	border-radius: 0.5px;
	border-width: 0 2px 2px 0;
	display: inline-block;
	padding: 2px;
	transform: rotate(-45deg);
	position: absolute;
	right: 20px;
	top: 14px
}

#topnav .has-submenu .submenu .has-submenu:hover .submenu-arrow,
#topnav .has-submenu .submenu .has-submenu.active .submenu-arrow {
	border-color: #00CCCC
}

#topnav .navbar-toggle {
	border: 0;
	position: relative;
	width: 60px;
	padding: 0;
	margin: 0;
	cursor: pointer
}

#topnav .navbar-toggle .lines {
	width: 25px;
	display: block;
	position: relative;
	margin: 30px 10px 26px;
	height: 18px
}

#topnav .navbar-toggle span {
	height: 2px;
	width: 100%;
	background-color: #343a40;
	display: block;
	margin-bottom: 5px;
	transition: transform .5s ease
}

#topnav .navbar-toggle span:last-child {
	margin-bottom: 0
}

#topnav .dropdowns {
	float: right;
	line-height: 68px;
	padding: 2.5px 0
}

#topnav .dropdowns>li {
	line-height: initial
}

#topnav .dropdowns .login-btn-primary {
	display: none
}

#topnav .dropdowns .login-btn-light {
	display: inline-block
}

#topnav .navbar-toggle.open span {
	position: absolute
}

#topnav .navbar-toggle.open span:first-child {
	top: 6px;
	transform: rotate(45deg)
}

#topnav .navbar-toggle.open span:nth-child(2) {
	visibility: hidden
}

#topnav .navbar-toggle.open span:last-child {
	width: 100%;
	top: 6px;
	transform: rotate(-45deg)
}

#topnav .navbar-toggle.open span:hover {
	background-color: #00CCCC
}

#topnav .navbar-toggle:hover,
#topnav .navbar-toggle:focus,
#topnav .navbar-toggle .navigation-menu>li>a:hover,
#topnav .navbar-toggle:focus {
	background-color: transparent
}

#topnav .navigation-menu {
	list-style: none;
	margin: 0;
	padding: 0
}

#topnav .navigation-menu>li {
	float: left;
	display: block;
	position: relative;
	margin: 0 10px
}

#topnav .navigation-menu>li:hover>a,
#topnav .navigation-menu>li.active>a {
	color: #00CCCC !important
}

#topnav .navigation-menu>li>a {
	display: block;
	color: #343a40;
	font-size: 13px;
	background-color: transparent !important;
	font-weight: 600;
	letter-spacing: 1px;
	line-height: 24px;
	text-transform: uppercase;
	transition: all 0.5s;
	font-family: "Inter", sans-serif;
	padding-left: 15px;
	padding-right: 15px
}

#topnav .navigation-menu>li>a:hover,
#topnav .navigation-menu>li>a:active {
	color: #00CCCC
}

#topnav .navigation-menu .has-submenu .menu-arrow {
	border: solid #343a40;
	border-radius: 0.5px;
	border-width: 0 2px 2px 0;
	display: inline-block;
	padding: 2px;
	transform: rotate(45deg);
	position: absolute;
	transition: all 0.5s;
	right: -1px;
	top: 32px
}

#topnav .navigation-menu .has-submenu:hover .menu-arrow {
	transform: rotate(225deg)
}

#topnav .menu-extras {
	float: right
}

#topnav.scroll {
	background-color: #fff;
	border: none;
	box-shadow: 0 0 3px rgba(52, 58, 64, 0.15)
}

#topnav.scroll .navigation-menu>li>a {
	color: #343a40
}

#topnav.scroll .navigation-menu>li>.menu-arrow {
	border-color: #343a40
}

#topnav.scroll .navigation-menu>li:hover>a,
#topnav.scroll .navigation-menu>li.active>a {
	color: #00CCCC
}

#topnav.scroll .navigation-menu>li:hover>.menu-arrow,
#topnav.scroll .navigation-menu>li.active>.menu-arrow {
	border-color: #00CCCC
}

#topnav.defaultscroll.dark-menubar .logo {
	line-height: 70px
}

#topnav.defaultscroll.scroll .logo {
	line-height: 62px
}

#topnav.defaultscroll.scroll.dark-menubar .logo {
	line-height: 62px
}

#topnav.nav-sticky {
	background: #fff;
	box-shadow: 0 0 3px rgba(52, 58, 64, 0.15)
}

#topnav.nav-sticky .navigation-menu.nav-light>li>a {
	color: #343a40
}

#topnav.nav-sticky .navigation-menu.nav-light>li.active>a {
	color: #00CCCC !important
}

#topnav.nav-sticky .navigation-menu.nav-light>li:hover>.menu-arrow,
#topnav.nav-sticky .navigation-menu.nav-light>li.active>.menu-arrow {
	border-color: #00CCCC !important
}

#topnav.nav-sticky .navigation-menu.nav-light>li:hover>a,
#topnav.nav-sticky .navigation-menu.nav-light>li.active>a {
	color: #00CCCC !important
}

#topnav.nav-sticky .navigation-menu.nav-light .has-submenu .menu-arrow {
	border-color: #343a40
}

#topnav.nav-sticky .dropdowns .login-btn-primary {
	display: inline-block
}

#topnav.nav-sticky .dropdowns .login-btn-light {
	display: none
}

#topnav.nav-sticky .logo .l-dark {
	display: inline-block
}

#topnav.nav-sticky .logo .l-light {
	display: none
}

.logo {
	font-weight: 600;
	font-size: 24px;
	padding: 0 0 6px;
	letter-spacing: 1px;
	line-height: 68px
}

.search-bar {
	padding-top: 14.5px;
	padding-bottom: 14.5px
}

.search-bar .menu-search form {
	position: relative
}

.search-bar .menu-search input[type="text"],
.search-bar .searchform input[type="text"] {
	box-shadow: none;
	padding: 12px 15px;
	height: 40px;
	font-size: 14px;
	display: block;
	width: 100%;
	outline: none !important;
	padding-right: 45px;
	opacity: 0.7
}

.search-bar .menu-search input[type="submit"],
.search-bar .searchform input[type="submit"] {
	position: absolute;
	top: 5px;
	right: 10px;
	opacity: 0;
	width: 40px;
	height: 40px
}

.search-bar .menu-search .searchform:after {
	content: "\\F0349";
	position: absolute;
	font-family: "Material Design Icons";
	right: 16px;
	top: 12px;
	font-size: 20px;
	line-height: 20px;
	pointer-events: none
}

@media (min-width: 992px) {
	#topnav .navigation-menu {
		display: flex;
		justify-content: center
	}

	#topnav .navigation-menu>.has-submenu>.submenu>.has-submenu>.submenu::before {
		top: 15px;
		margin-left: -20px;
		box-shadow: 1px 1px 0px 0px rgba(52, 58, 64, 0.15);
		border-color: transparent #fff #fff transparent
	}

	#topnav .navigation-menu>.has-submenu:hover .menu-arrow {
		top: 35px !important
	}

	#topnav .navigation-menu>.has-submenu.active .menu-arrow {
		top: 32px
	}

	#topnav .navigation-menu>li .submenu {
		position: absolute;
		top: 100%;
		left: 15px;
		z-index: 1000;
		padding: 15px 0;
		list-style: none;
		min-width: 180px;
		visibility: hidden;
		opacity: 0;
		margin-top: 10px;
		transition: all .2s ease;
		border-radius: 5px;
		background-color: #fff;
		box-shadow: 0 0 3px rgba(52, 58, 64, 0.15)
	}

	#topnav .navigation-menu>li .submenu li {
		position: relative
	}

	#topnav .navigation-menu>li .submenu li a {
		display: block;
		padding: 10px 20px;
		clear: both;
		white-space: nowrap;
		font-size: 11px;
		text-transform: uppercase;
		letter-spacing: 0.04em;
		font-weight: 600;
		color: #343a40 !important;
		transition: all 0.3s
	}

	#topnav .navigation-menu>li .submenu li a:hover {
		color: #00CCCC !important
	}

	#topnav .navigation-menu>li .submenu li ul {
		list-style: none;
		padding-left: 0;
		margin: 0
	}

	#topnav .navigation-menu>li .submenu.megamenu {
		white-space: nowrap;
		width: auto
	}

	#topnav .navigation-menu>li .submenu.megamenu>li {
		overflow: hidden;
		min-width: 180px;
		display: inline-block;
		vertical-align: top
	}

	#topnav .navigation-menu>li .submenu.megamenu>li .submenu {
		left: 100%;
		top: 0;
		margin-left: 10px;
		margin-top: -1px
	}

	#topnav .navigation-menu>li .submenu>li .submenu {
		left: 101%;
		top: 0;
		margin-left: 10px;
		margin-top: -1px
	}

	#topnav .navigation-menu>li>a {
		padding-top: 25px;
		padding-bottom: 25px;
		min-height: 62px
	}

	#topnav .navigation-menu>li:hover>.menu-arrow {
		border-color: #00CCCC
	}

	#topnav .navigation-menu>li:hover>a,
	#topnav .navigation-menu>li.active>a {
		color: #00CCCC !important
	}

	#topnav .navigation-menu>li.last-elements .submenu {
		left: auto;
		right: 0
	}

	#topnav .navigation-menu>li.last-elements .submenu:before {
		left: auto;
		right: 10px
	}

	#topnav .navigation-menu>li.last-elements .submenu>li.has-submenu .submenu {
		left: auto;
		right: 106%;
		margin-left: 0;
		margin-right: 10px
	}

	#topnav .navigation-menu>li.last-elements .submenu>li.has-submenu .submenu:before {
		transform: rotate(-45deg);
		right: -3px
	}

	#topnav .navigation-menu.nav-light>li>a {
		color: rgba(255, 255, 255, 0.5)
	}

	#topnav .navigation-menu.nav-light>li.active>a {
		color: #fff !important
	}

	#topnav .navigation-menu.nav-light>li:hover>.menu-arrow {
		border-color: #fff !important
	}

	#topnav .navigation-menu.nav-light>li:hover>a {
		color: #fff !important
	}

	#topnav .navigation-menu.nav-light .has-submenu .menu-arrow {
		border-color: rgba(255, 255, 255, 0.5)
	}

	#topnav .navigation-menu.nav-light .has-submenu.active .menu-arrow {
		border-color: #fff !important
	}

	#topnav .navigation-menu.nav-right {
		justify-content: flex-end !important
	}

	#topnav .navigation-menu.nav-left {
		justify-content: flex-start !important
	}

	#topnav .navigation-menu.nav-left>li.last-elements .submenu {
		left: auto;
		right: 0
	}

	#topnav .navigation-menu.nav-left>li.last-elements .submenu:before {
		right: -5px
	}

	#topnav .logo {
		margin-right: 30px
	}

	#topnav .dropdowns {
		padding-left: 15px;
		margin-left: 15px
	}

	#topnav .navbar-toggle {
		display: none
	}

	#topnav #navigation {
		display: block !important
	}

	#topnav.scroll {
		top: 0
	}

	#topnav.scroll .navigation-menu>li>a {
		padding-top: 20px;
		padding-bottom: 20px
	}

	#topnav.scroll-active .navigation-menu>li>a {
		padding-top: 25px;
		padding-bottom: 25px
	}

	#topnav .search-bar .menu-search input[type="text"],
	#topnav .search-bar .searchform input[type="text"] {
		width: 250px !important
	}
}

@media (max-width: 991px) {
	#topnav {
		background-color: #fff;
		box-shadow: 0 0 3px rgba(52, 58, 64, 0.15);
		min-height: 74px
	}

	#topnav .logo {
		padding: 3px 0 !important
	}

	#topnav .logo .l-dark {
		display: inline-block !important
	}

	#topnav .logo .l-light {
		display: none !important
	}

	#topnav .container {
		width: auto
	}

	#topnav #navigation {
		max-height: 400px
	}

	#topnav .navigation-menu {
		float: none
	}

	#topnav .navigation-menu>li {
		float: none
	}

	#topnav .navigation-menu>li .submenu {
		display: none;
		list-style: none;
		padding-left: 20px;
		margin: 0
	}

	#topnav .navigation-menu>li .submenu li a {
		display: block;
		position: relative;
		padding: 7px 15px;
		text-transform: uppercase;
		font-size: 11px;
		letter-spacing: 0.04em;
		font-weight: 600;
		color: #343a40 !important;
		transition: all 0.3s
	}

	#topnav .navigation-menu>li .submenu.open {
		display: block
	}

	#topnav .navigation-menu>li .submenu .submenu {
		display: none;
		list-style: none
	}

	#topnav .navigation-menu>li .submenu .submenu.open {
		display: block
	}

	#topnav .navigation-menu>li .submenu.megamenu>li>ul {
		list-style: none;
		padding-left: 0
	}

	#topnav .navigation-menu>li .submenu.megamenu>li>ul>li>span {
		display: block;
		position: relative;
		padding: 10px 15px;
		text-transform: uppercase;
		font-size: 12px;
		letter-spacing: 2px;
		color: #8492a6
	}

	#topnav .navigation-menu>li>a {
		color: #343a40;
		padding: 10px 20px
	}

	#topnav .navigation-menu>li>a:after {
		position: absolute;
		right: 15px
	}

	#topnav .navigation-menu>li>a:hover,
	#topnav .navigation-menu>li .submenu li a:hover,
	#topnav .navigation-menu>li.has-submenu.open>a {
		color: #00CCCC
	}

	#topnav .menu-extras .menu-item {
		border-color: #8492a6
	}

	#topnav .navbar-header {
		float: left
	}

	#topnav .dropdowns .login-btn-primary {
		display: inline-block !important
	}

	#topnav .dropdowns .login-btn-light {
		display: none
	}

	#topnav .has-submenu .submenu .submenu-arrow {
		transform: rotate(45deg);
		position: absolute;
		right: 20px;
		top: 12px
	}

	#topnav .has-submenu.active a {
		color: #00CCCC
	}

	#navigation {
		position: absolute;
		top: 74px;
		left: 0;
		width: 100%;
		display: none;
		height: auto;
		padding-bottom: 0;
		overflow: auto;
		border-top: 1px solid #f1f3f9;
		border-bottom: 1px solid #f1f3f9;
		background-color: #fff
	}

	#navigation.open {
		display: block;
		overflow-y: auto
	}
}

@media (max-width: 768px) {
	#topnav .navigation-menu .has-submenu .menu-arrow {
		right: 16px;
		top: 16px
	}
}

@media (min-width: 768px) {
	#topnav .navigation-menu>li.has-submenu:hover>.submenu {
		visibility: visible;
		opacity: 1;
		margin-top: 0
	}

	#topnav .navigation-menu>li.has-submenu:hover>.submenu>li.has-submenu:hover>.submenu {
		visibility: visible;
		opacity: 1;
		margin-left: 0;
		margin-right: 0
	}

	.navbar-toggle {
		display: block
	}
}

@media (max-width: 425px) {
	#topnav .navbar-toggle .lines {
		margin-right: 0 !important
	}
}

@media (max-width: 375px) {
	#topnav .dropdowns {
		margin: 0 0 0 10px
	}
}

.sidebar-nav {
	padding: 15px 0
}

.sidebar-nav>.navbar-item {
	padding: 6.5px 15px
}

.sidebar-nav>.navbar-item .navbar-link {
	color: #343a40 !important;
	font-size: 15px;
	font-weight: 500
}

.sidebar-nav>.navbar-item .navbar-link .navbar-icon {
	font-size: 18px;
	margin-right: 6px
}

.sidebar-nav>.navbar-item:hover .navbar-link,
.sidebar-nav>.navbar-item.active .navbar-link {
	color: #00CCCC !important
}

.page-wrapper {
	height: 100vh
}

.page-wrapper.doctris-theme .sidebar-wrapper {
	box-shadow: 0 0 3px rgba(52, 58, 64, 0.15);
	background-color: #fff;
	transition: all 0.3s ease
}

.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu {
	border-top: 1px solid #e9ecef
}

.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header .user-info .user-role,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header .user-info .user-status,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand>a,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li a {
	color: #93969F;
	font-weight: 400;
	font-size: 16px;
}

.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:hover>a,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li.active>a,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:active>a,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:active>a:before,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:hover>a:before,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li.active>a:before,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header .user-info,
.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand>a:hover {
	color: #00CCCC !important;
}

.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand .logo-dark-mode {
	display: none
}

.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand .logo-light-mode {
	display: inline-block
}

.page-wrapper .sidebar-wrapper {
	width: 300px;
	height: 100%;
	max-height: 100%;
	position: fixed;
	top: 0;
	left: -300px;
	z-index: 999
}

@media (min-width: 1025px) {
	.page-wrapper .sidebar-wrapper {
		z-index: 1000
	}
}

@media (max-width: 1024px) {
	.page-wrapper .sidebar-wrapper {
		left: 0
	}
}

@media (max-width: 425px) {
	.page-wrapper .sidebar-wrapper {
		width: 260px
	}
}

.page-wrapper .sidebar-wrapper ul {
	list-style-type: none;
	padding: 0;
	margin: 0
}

.page-wrapper .sidebar-wrapper a {
	text-decoration: none
}

.page-wrapper .sidebar-wrapper .sidebar-content {
	/* max-height: calc(100% - 30px); */
	/* height: calc(100% - 30px); */
	overflow-y: auto;
	position: relative;
	height: 100vh;
}

.page-wrapper .sidebar-wrapper .sidebar-content::-webkit-scrollbar {
	width: 7px;
}

.page-wrapper .sidebar-wrapper .sidebar-content::-webkit-scrollbar-track {
	border-radius: 10px;
	background: whitesmoke;
}

.page-wrapper .sidebar-wrapper .sidebar-content::-webkit-scrollbar-thumb {
	background: #00CCCC;
	border-radius: 10px;
}

.page-wrapper .sidebar-wrapper .sidebar-content.desktop {
	overflow-y: hidden
}

.page-wrapper .sidebar-wrapper .sidebar-brand {
	padding: 10px 20px;
	display: flex;
	align-items: center;
}

.page-wrapper .sidebar-wrapper .sidebar-brand>a {
	text-transform: uppercase;
	font-weight: bold;
	flex-grow: 1;
	transition: all 0.3s ease
}

.page-wrapper .sidebar-wrapper .sidebar-brand>a:focus {
	outline: none
}

.page-wrapper .sidebar-wrapper .sidebar-brand #close-sidebar {
	cursor: pointer;
	font-size: 24px;
	transition: all 0.3s ease
}

.page-wrapper .sidebar-wrapper .sidebar-header {
	padding: 20px;
	overflow: hidden
}

.page-wrapper .sidebar-wrapper .sidebar-menu {
	padding-bottom: 10px
}

.page-wrapper .sidebar-wrapper .sidebar-menu .header-menu span {
	font-weight: bold;
	font-size: 14px;
	padding: 15px 20px 5px 20px;
	display: inline-block
}

.page-wrapper .sidebar-wrapper .sidebar-menu li a {
	display: inline-block;
	width: 100%;
	text-decoration: none;
	position: relative;
	padding: 9px 25px;
	transition: all 0.3s ease
}

.page-wrapper .sidebar-wrapper .sidebar-menu li a:hover>i::before {
	display: inline-block
}

.page-wrapper .sidebar-wrapper .sidebar-menu li a:focus {
	outline: none
}

.page-wrapper .sidebar-wrapper .sidebar-menu li a i {
	width: 30px;
	height: 30px;
	line-height: 30px;
	background-color: transparent;
	font-size: 18px;
	text-align: center;
	border-radius: 5px;
	transition: all 0.3s ease;
	margin-right: 12px;
	vertical-align: -2px;
}

.page-wrapper .sidebar-wrapper .sidebar-menu li:hover i,
.page-wrapper .sidebar-wrapper .sidebar-menu li.active i {
	/* 	background-color: rgba(57, 108, 240, 0.1) */
}

.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown>a:after {
	content: "\\F0142" !important;
	color: #93969F;
	font-family: 'Material Design Icons';
	font-size: 22px;
	position: absolute;
	right: 10px;
	top: 6px;
	transition: all 0.3s ease;
}

.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a:after {
	transform: rotate(90deg);
	right: 10px;
	color: #00CCCC;
}

.page-wrapper .sidebar-wrapper .sidebar-menu li.active>a {
	background: #E0F9F9;
}

.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu {
	display: none
}

.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul {
	padding: 5px 0
}

.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li {
	padding-left: 30px;
	font-size: 14px
}

.sidebar-submenu ul li a {
	font-size: 14px !important;
	line-height: 21px;
}

.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li a:before {
	content: "\\F035F" !important;
	color: #93969F;
	font-family: 'Material Design Icons';
	margin-right: 2px;
	font-size: 24px;
	transition: all 0.3s ease;
	vertical-align: -3px;
}

.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li a .badge,
.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li a .label {
	float: right;
	margin-top: 0px
}

.page-wrapper .sidebar-wrapper .sidebar-menu ul li a span.label,
.page-wrapper .sidebar-wrapper .sidebar-menu ul li a span.badge {
	float: right;
	margin-top: 8px;
	margin-left: 5px
}

.page-wrapper .page-content {
	display: inline-block;
	width: 100%;
	padding-left: 0px;
	overflow-x: hidden;
	transition: all 0.3s ease
}

.page-wrapper .page-content .top-header {
	position: fixed;
	right: 0;
	top: 0;
	z-index: 999;
	max-height: 70px;
	left: 0px;
	transition: all 0.3s
}

.page-wrapper .page-content .top-header .header-bar {
	background: #fff;
	height: 71px;
	position: relative;
	justify-content: space-between;
	align-items: center;
	padding: 24px
}

@media (max-width: 425px) {
	.page-wrapper .page-content .top-header .header-bar {
		padding: 24px 12px
	}
}

.page-wrapper .page-content .top-header .header-bar .logo-icon {
	display: none
}

@media (max-width: 1024px) {
	.page-wrapper .page-content .top-header .header-bar .logo-icon {
		display: block
	}
}

.page-wrapper .page-content .top-header .header-bar .logo-icon .small {
	display: none
}

@media (max-width: 767px) {
	.page-wrapper .page-content .top-header .header-bar .logo-icon .small {
		display: block
	}
}

.page-wrapper .page-content .top-header .header-bar .logo-icon .big {
	display: none
}

.page-wrapper .page-content .top-header .header-bar .logo-icon .big .logo-dark-mode {
	display: none
}

.page-wrapper .page-content .top-header .header-bar .logo-icon .big .logo-light-mode {
	display: inline-block
}

@media (min-width: 768px) and (max-width: 1024px) {
	.page-wrapper .page-content .top-header .header-bar .logo-icon .big {
		display: block
	}
}

.page-wrapper .page-content .top-header .header-bar .search-bar {
	padding-top: 14.5px;
	padding-bottom: 14.5px
}

.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search form {
	position: relative
}

.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search input[type="text"],
.page-wrapper .page-content .top-header .header-bar .search-bar .searchform input[type="text"] {
	box-shadow: none;
	padding: 12px 15px;
	height: 40px;
	font-size: 14px;
	display: block;
	width: 250px;
	outline: none !important;
	padding-right: 45px;
	opacity: 0.7
}

.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search input[type="submit"],
.page-wrapper .page-content .top-header .header-bar .search-bar .searchform input[type="submit"] {
	position: absolute;
	top: 5px;
	right: 10px;
	opacity: 0;
	width: 40px;
	height: 40px
}

.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search .searchform:after {
	content: "\\F0349";
	position: absolute;
	font-family: "Material Design Icons";
	right: 16px;
	top: 12px;
	font-size: 20px;
	line-height: 20px;
	pointer-events: none
}

.page-wrapper .page-content .layout-specing {
	padding: 94px 14px 24px !important;
	/* min-height: calc(100vh - 56px) !important; */
	position: relative
}

@media (max-width: 425px) {
	.page-wrapper .page-content .layout-specing {
		padding: 94px 0 24px !important
	}
}

@media screen and (min-width: 1025px) {
	.page-wrapper.toggled .page-content {
		padding-left: 300px
	}
}

.page-wrapper.toggled .top-header {
	left: 301px
}

@media (max-width: 1024px) {
	.page-wrapper.toggled .top-header {
		left: 0
	}
}

.page-wrapper.toggled .sidebar-wrapper {
	left: 0px
}

@media (max-width: 1024px) {
	.page-wrapper.toggled .sidebar-wrapper {
		left: -300px
	}
}

.sidebar-footer {
	position: absolute;
	width: 100%;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 9px 15px !important;
	box-shadow: 0 0 3px rgba(52, 58, 64, 0.15)
}

.bg-home {
	height: 100vh;
	background-size: cover;
	align-self: center;
	position: relative;
	background-position: center center
}

.bg-half-260 {
	padding: 260px 0;
	background-size: cover;
	align-self: center;
	position: relative;
	background-position: center center
}

.bg-half-170 {
	padding: 170px 0;
	background-size: cover;
	align-self: center;
	position: relative;
	background-position: center center
}

.bg-half-150 {
	padding: 150px 0;
	background-size: cover;
	align-self: center;
	position: relative;
	background-position: center center
}

.bg-profile {
	padding: 80px 0;
	background-size: cover;
	align-self: center;
	position: relative;
	background-position: center center
}

.bg-dashboard {
	padding: 100px 0 30px;
	background-size: cover;
	align-self: center;
	position: relative;
	background-position: center center
}

.bg-hero {
	padding: 100px 0;
	background-size: cover;
	align-self: center;
	position: relative;
	background-position: center center
}

.dr-profile-img {
	position: absolute;
	bottom: 0
}

@media (max-width: 425px) {
	.dr-profile-img {
		position: relative;
		padding: 24px
	}
}

.home-slider .carousel-control-next,
.home-slider .carousel-control-prev {
	width: 30px;
	height: 30px;
	top: 50%;
	transform: translateY(-50%);
	border-radius: 30px;
	border: 1px solid #ced4da
}

.home-slider .carousel-control-next-icon,
.home-slider .carousel-control-prev-icon {
	width: 30%
}

.home-slider .carousel-control-next {
	right: 8px
}

.home-slider .carousel-control-prev {
	left: 8px
}

.carousel-indicators [data-bs-target] {
	width: 7px;
	height: 7px;
	border-radius: 30px;
	background: rgba(57, 108, 240, 0.5) !important;
	transition: all 0.5s ease;
	border: 2px solid rgba(255, 255, 255, 0.5);
	margin: 0 4px;
	padding: 0
}

.carousel-indicators .active {
	background: #00CCCC !important;
	border-color: #00CCCC
}

@media (max-width: 767px) {

	.bg-home,
	.bg-half-170,
	.bg-half-260,
	.main-slider .slides .bg-slider {
		padding: 150px 0;
		height: auto
	}
}

.features.feature-primary .title:hover {
	color: #00CCCC !important
}

.features.feature-primary .icon {
	color: #00CCCC !important;
	background-color: rgba(57, 108, 240, 0.05) !important
}

.features.feature-primary .link {
	color: #00CCCC !important
}

.features.feature-bg-primary:hover {
	background-color: #00CCCC !important
}

.features.feature-secondary .title:hover {
	color: #5a6d90 !important
}

.features.feature-secondary .icon {
	color: #5a6d90 !important;
	background-color: rgba(90, 109, 144, 0.05) !important
}

.features.feature-secondary .link {
	color: #5a6d90 !important
}

.features.feature-bg-secondary:hover {
	background-color: #5a6d90 !important
}

.features.feature-success .title:hover {
	color: #53c797 !important
}

.features.feature-success .icon {
	color: #53c797 !important;
	background-color: rgba(83, 199, 151, 0.05) !important
}

.features.feature-success .link {
	color: #53c797 !important
}

.features.feature-bg-success:hover {
	background-color: #53c797 !important
}

.features.feature-warning .title:hover {
	color: #f1b561 !important
}

.features.feature-warning .icon {
	color: #f1b561 !important;
	background-color: rgba(241, 181, 97, 0.05) !important
}

.features.feature-warning .link {
	color: #f1b561 !important
}

.features.feature-bg-warning:hover {
	background-color: #f1b561 !important
}

.features.feature-info .title:hover {
	color: #64c2f1 !important
}

.features.feature-info .icon {
	color: #64c2f1 !important;
	background-color: rgba(100, 194, 241, 0.05) !important
}

.features.feature-info .link {
	color: #64c2f1 !important
}

.features.feature-bg-info:hover {
	background-color: #64c2f1 !important
}

.features.feature-danger .title:hover {
	color: #f0735a !important
}

.features.feature-danger .icon {
	color: #f0735a !important;
	background-color: rgba(240, 115, 90, 0.05) !important
}

.features.feature-danger .link {
	color: #f0735a !important
}

.features.feature-bg-danger:hover {
	background-color: #f0735a !important
}

.features.feature-dark .title:hover {
	color: #343a40 !important
}

.features.feature-dark .icon {
	color: #343a40 !important;
	background-color: rgba(52, 58, 64, 0.05) !important
}

.features.feature-dark .link {
	color: #343a40 !important
}

.features.feature-bg-dark:hover {
	background-color: #343a40 !important
}

.features.feature-muted .title:hover {
	color: #8492a6 !important
}

.features.feature-muted .icon {
	color: #8492a6 !important;
	background-color: rgba(132, 146, 166, 0.05) !important
}

.features.feature-muted .link {
	color: #8492a6 !important
}

.features.feature-bg-muted:hover {
	background-color: #8492a6 !important
}

.features.feature-light .title:hover {
	color: #f8f9fc !important
}

.features.feature-light .icon {
	color: #f8f9fc !important;
	background-color: rgba(248, 249, 252, 0.05) !important
}

.features.feature-light .link {
	color: #f8f9fc !important
}

.features.feature-bg-light:hover {
	background-color: #f8f9fc !important
}

.features.feature-footer .title:hover {
	color: #202942 !important
}

.features.feature-footer .icon {
	color: #202942 !important;
	background-color: rgba(32, 41, 66, 0.05) !important
}

.features.feature-footer .link {
	color: #202942 !important
}

.features.feature-bg-footer:hover {
	background-color: #202942 !important
}

.features {
	transition: all 0.5s ease
}

.features .icon {
	height: 65px;
	width: 65px;
	display: flex;
	align-items: center;
	justify-content: center
}

.features .title {
	font-weight: 500
}

.features .big-icon {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 20px;
	opacity: 0.05;
	font-size: 120px
}

.features .titles,
.features .icons,
.features .para,
.features .big-icon {
	transition: all 0.5s ease
}

.features:hover .titles,
.features:hover .icons,
.features:hover .big-icon {
	color: #fff !important
}

.features:hover .para {
	color: rgba(255, 255, 255, 0.5) !important
}

.play-btn {
	height: 78px;
	width: 78px;
	font-size: 30px;
	line-height: 76px;
	border-radius: 50%;
	display: inline-block;
	color: #fff
}

.play-icon {
	position: absolute;
	bottom: 50%;
	transform: translateY(50%);
	right: 0;
	left: 0;
	text-align: center
}

.play-icon i {
	height: 75px;
	-webkit-text-stroke: 2px #00CCCC;
	-webkit-text-fill-color: transparent;
	width: 75px;
	font-size: 25px;
	line-height: 75px;
	display: inline-block
}

.play-icon i:hover {
	-webkit-text-stroke: 2px #00CCCC;
	-webkit-text-fill-color: #00CCCC
}

.cta-review {
	position: relative;
	top: 220px
}

.chat .chat-list:hover,
.chat .chat-list.active,
.chat .chat-list:focus {
	background: #f8f9fc !important;
	box-shadow: 0 0 3px rgba(52, 58, 64, 0.15)
}

.chat .chat-list .on-off,
.chat .chat-type .on-off {
	position: absolute;
	left: -1px;
	top: -1px;
	font-size: 12px !important
}

.chat.chat-person .on-off {
	font-size: 10px
}

.chat.chat-person .chat-msg {
	margin-left: 8px
}

.chat.chat-person .chat-msg .msg {
	border: 1px solid #e9ecef
}

.chat.chat-person .chat-msg .msg-time {
	font-size: 12px !important
}

.chat.chat-person .chat-right {
	justify-content: flex-end;
	text-align: right
}

.chat.chat-person .chat-right .chat-user-image {
	order: 2
}

.chat.chat-person .chat-right .chat-user-image .on-off {
	right: -1px
}

.chat.chat-person .chat-right .chat-msg {
	margin-right: 8px;
	margin-left: 0
}

.chat.chat-person .chat-right .chat-msg .msg {
	display: inline-block
}

.chat.chat-person .chat-right .chat-msg .msg-time {
	display: block
}

.team {
	transition: all 0.5s
}

.team .team-img .team-social {
	position: absolute;
	bottom: 10px;
	left: 10px;
	opacity: 0;
	transition: all 0.5s;
	transform: translateX(-50px)
}

.team .title {
	font-weight: 500
}

.team .content,
.team .content .title,
.team .content .speciality {
	transition: all 0.5s
}

.team .team-person img {
	transition: all 0.5s
}

.team .team-person .team-like {
	position: absolute;
	top: 10px;
	right: 10px
}

.team .team-person:hover img {
	transform: scale(1.05)
}

.team:hover .team-img .team-social {
	opacity: 1;
	transform: translateX(0px)
}

.team:hover .content {
	background: #00CCCC !important
}

.team:hover .content .title {
	color: #fff !important
}

.team:hover .content .speciality {
	color: rgba(255, 255, 255, 0.5) !important
}

.tns-nav {
	text-align: center;
	margin-top: 10px
}

.tns-nav button {
	width: 10px;
	height: 10px;
	border-radius: 5px;
	background: rgba(57, 108, 240, 0.5) !important;
	transition: all 0.5s ease;
	border: 2px solid rgba(255, 255, 255, 0.5);
	margin: 0 4px;
	padding: 0
}

.tns-nav button.tns-nav-active {
	background: #00CCCC !important;
	border-color: #00CCCC
}

.tiny-timeline {
	position: relative;
	width: 100%;
	margin: 0 auto
}

.tiny-timeline:before {
	content: "";
	position: absolute;
	width: 100%;
	top: 17px;
	left: 0;
	height: 2px;
	background: #00CCCC
}

.tiny-timeline .item-box {
	margin: 70px 15px
}

.tiny-timeline .item-box:before,
.tiny-timeline .item-box:after {
	content: "";
	position: absolute;
	left: 50%;
	background: #00CCCC
}

.tiny-timeline .item-box:before {
	width: 2px;
	height: 46px;
	top: -46px;
	transform: translateX(-50%)
}

.tiny-timeline .item-box:after {
	width: 13px;
	height: 13px;
	top: -59px;
	border-radius: 3px;
	transform: translateX(-50%) rotate(45deg)
}

.slick-slider {
	overflow-x: hidden !important;
	cursor: pointer
}

.blog.blog-primary .tag {
	background: #00CCCC !important
}

.blog.blog-primary .title:hover {
	color: #00CCCC !important
}

.blog.blog-primary .link {
	color: #00CCCC !important
}

.blog.blog-primary .post-meta .like:hover,
.blog.blog-primary .post-meta .comments:hover {
	color: #00CCCC !important
}

.blog.blog-secondary .tag {
	background: #5a6d90 !important
}

.blog.blog-secondary .title:hover {
	color: #5a6d90 !important
}

.blog.blog-secondary .link {
	color: #5a6d90 !important
}

.blog.blog-secondary .post-meta .like:hover,
.blog.blog-secondary .post-meta .comments:hover {
	color: #5a6d90 !important
}

.blog.blog-success .tag {
	background: #53c797 !important
}

.blog.blog-success .title:hover {
	color: #53c797 !important
}

.blog.blog-success .link {
	color: #53c797 !important
}

.blog.blog-success .post-meta .like:hover,
.blog.blog-success .post-meta .comments:hover {
	color: #53c797 !important
}

.blog.blog-warning .tag {
	background: #f1b561 !important
}

.blog.blog-warning .title:hover {
	color: #f1b561 !important
}

.blog.blog-warning .link {
	color: #f1b561 !important
}

.blog.blog-warning .post-meta .like:hover,
.blog.blog-warning .post-meta .comments:hover {
	color: #f1b561 !important
}

.blog.blog-info .tag {
	background: #64c2f1 !important
}

.blog.blog-info .title:hover {
	color: #64c2f1 !important
}

.blog.blog-info .link {
	color: #64c2f1 !important
}

.blog.blog-info .post-meta .like:hover,
.blog.blog-info .post-meta .comments:hover {
	color: #64c2f1 !important
}

.blog.blog-danger .tag {
	background: #f0735a !important
}

.blog.blog-danger .title:hover {
	color: #f0735a !important
}

.blog.blog-danger .link {
	color: #f0735a !important
}

.blog.blog-danger .post-meta .like:hover,
.blog.blog-danger .post-meta .comments:hover {
	color: #f0735a !important
}

.blog.blog-dark .tag {
	background: #343a40 !important
}

.blog.blog-dark .title:hover {
	color: #343a40 !important
}

.blog.blog-dark .link {
	color: #343a40 !important
}

.blog.blog-dark .post-meta .like:hover,
.blog.blog-dark .post-meta .comments:hover {
	color: #343a40 !important
}

.blog.blog-muted .tag {
	background: #8492a6 !important
}

.blog.blog-muted .title:hover {
	color: #8492a6 !important
}

.blog.blog-muted .link {
	color: #8492a6 !important
}

.blog.blog-muted .post-meta .like:hover,
.blog.blog-muted .post-meta .comments:hover {
	color: #8492a6 !important
}

.blog.blog-light .tag {
	background: #f8f9fc !important
}

.blog.blog-light .title:hover {
	color: #f8f9fc !important
}

.blog.blog-light .link {
	color: #f8f9fc !important
}

.blog.blog-light .post-meta .like:hover,
.blog.blog-light .post-meta .comments:hover {
	color: #f8f9fc !important
}

.blog.blog-footer .tag {
	background: #202942 !important
}

.blog.blog-footer .title:hover {
	color: #202942 !important
}

.blog.blog-footer .link {
	color: #202942 !important
}

.blog.blog-footer .post-meta .like:hover,
.blog.blog-footer .post-meta .comments:hover {
	color: #202942 !important
}

.blog .title {
	font-weight: 500
}

.sidebar .widget .widget-search form {
	position: relative
}

.sidebar .widget .widget-search input[type="text"],
.sidebar .widget .searchform input[type="text"] {
	box-shadow: none;
	padding: 12px 15px;
	height: 45px;
	font-size: 14px;
	display: block;
	width: 100%;
	outline: none !important;
	padding-right: 45px
}

.sidebar .widget .widget-search input[type="submit"],
.sidebar .widget .searchform input[type="submit"] {
	position: absolute;
	top: 5px;
	right: 10px;
	opacity: 0;
	width: 40px;
	height: 40px
}

.sidebar .widget .widget-search .searchform:after {
	content: "\\F0349";
	position: absolute;
	font-family: "Material Design Icons";
	right: 16px;
	top: 15px;
	font-size: 20px;
	line-height: 20px;
	pointer-events: none
}

.sidebar .widget .post-recent {
	padding-bottom: 15px
}

.sidebar .widget .post-recent:last-child {
	padding-bottom: 0
}

.sidebar .widget .post-recent .post-recent-thumb {
	width: 25%
}

.sidebar .widget .post-recent .post-recent-content {
	width: 75%;
	padding-left: 10px
}

.sidebar .widget .post-recent .post-recent-content a {
	display: block;
	color: #343a40;
	font-size: 15px;
	transition: all 0.5s ease
}

.sidebar .widget .post-recent .post-recent-content a:hover {
	color: #00CCCC
}

.sidebar .widget .post-recent .post-recent-content span {
	font-size: 13px
}

.sidebar .widget .tagcloud>a {
	background: #f8f9fa;
	color: #343a40;
	display: inline-block;
	font-size: 9px;
	letter-spacing: 1px;
	margin: 5px 10px 5px 0;
	padding: 8px 12px 7px;
	text-transform: uppercase;
	transition: all 0.5s ease;
	font-weight: 600
}

.sidebar .widget .tagcloud>a:hover {
	background: #00CCCC;
	color: #fff
}

.pharpachy-categories .category-title {
	position: absolute;
	top: 20px;
	left: 20px;
	z-index: 1
}

.fc-event-title-container,
#external-events .fc-event {
	cursor: pointer;
	margin: 4px 2px
}

#external-events .fc-event .fc-event-main {
	padding: 5px
}

.fc .fc-non-business {
	background-color: transparent
}

.fc .fc-daygrid-day-number {
	padding: 5px;
	font-weight: 600
}

.fc .fc-col-header-cell-cushion {
	padding: 8px 4px !important
}

.fc .fc-scrollgrid-liquid {
	border-radius: 5px !important
}

.fc-theme-standard .fc-scrollgrid,
.fc-theme-standard td,
.fc-theme-standard th {
	border-color: #e9ecef !important
}

.fc-header-toolbar .fc-toolbar-chunk .fc-toolbar-title {
	font-size: 18px !important
}

.fc-direction-ltr .fc-daygrid-event.fc-event-start {
	margin: auto 8px 4px
}

.fc-event-main {
	background-color: #00CCCC
}

.fc-daygrid-dot-event {
	background: #f8f9fa;
	border: 1px solid #e9ecef
}

.fc-daygrid-dot-event:hover {
	background-color: #e9ecef
}

.fc .fc-button {
	padding: 4px 8px;
	font-size: 13px !important;
	background-color: #00CCCC !important;
	border: 1px solid #00CCCC !important;
	color: #fff !important;
	text-transform: capitalize !important
}

.fc .fc-button:disabled,
.fc .fc-button:disabled:hover,
.fc .fc-button:disabled:focus,
.fc .fc-button:disabled:active,
.fc .fc-button:disabled.active,
.fc .fc-button:disabled.focus {
	background-color: rgba(57, 108, 240, 0.1) !important;
	border: 1px solid rgba(57, 108, 240, 0.1) !important;
	color: #00CCCC !important
}

.fc .fc-button:hover,
.fc .fc-button:focus,
.fc .fc-button:active,
.fc .fc-button.active,
.fc .fc-button.focus {
	background-color: #215aee !important;
	border-color: #215aee !important
}

.fc .fc-button:focus {
	box-shadow: none !important
}

.fc .fc-icon {
	font-size: 16px !important
}

#calendar {
	max-width: 1240px
}

.shop-list .shop-image .shop-icons,
.shop-list .shop-image .qty-icons {
	position: absolute;
	opacity: 0;
	transition: all 0.5s ease
}

.shop-list .shop-image .shop-icons {
	top: 15px;
	left: 15px;
	z-index: 2
}

.shop-list .shop-image .qty-icons {
	bottom: 15px;
	text-align: center;
	right: 0;
	left: 0;
	z-index: 2;
	transform: translateY(100px)
}

.shop-list .shop-image:hover .shop-icons,
.shop-list .shop-image:hover .qty-icons {
	opacity: 1
}

.shop-list .shop-image:hover .qty-icons {
	transform: translateY(0)
}

.shop-list .content .product-name {
	transition: all 0.5s ease
}

.shop-list .content .product-name:hover {
	color: #00CCCC !important
}

.shop-list .label {
	position: absolute;
	top: 15px;
	right: 15px;
	z-index: 2
}

.shop-list .qty-btn {
	pointer-events: none;
	width: 65px;
	padding-left: 16px
}

@media (max-width: 1024px) {
	.shop-list .qty-btn {
		padding-left: 0
	}
}

.error {
	margin: 8px 0px;
	display: none;
	color: #f0735a
}

#ajaxsuccess {
	font-size: 16px;
	width: 100%;
	display: none;
	clear: both;
	margin: 8px 0px
}

.error_message,
#success_page {
	padding: 10px;
	margin-bottom: 20px;
	text-align: center;
	border-radius: 5px
}

.error_message {
	background-color: rgba(240, 115, 90, 0.1) !important;
	border: 2px solid rgba(240, 115, 90, 0.1) !important;
	color: #f0735a !important;
	font-size: 14px
}

.contact-loader {
	display: none
}

#success_page {
	background-color: rgba(83, 199, 151, 0.1) !important;
	border: 2px solid rgba(83, 199, 151, 0.1) !important;
	color: #53c797 !important
}

#success_page p {
	margin-bottom: 0 !important
}

.simplebar-track.simplebar-vertical {
	width: 8px !important
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
	width: 4px !important;
	background: #adb5bd !important
}

footer {
	padding: 60px 0 24px;
	position: relative;
	color: #adb5bd
}

footer .text-foot {
	color: #adb5bd
}

footer .footer-head {
	font-size: 18px !important;
	letter-spacing: 1px;
	font-weight: 500
}

footer .footer-list {
	margin-bottom: 0
}

footer .footer-list li {
	margin-bottom: 10px
}

footer .footer-list li a {
	transition: all 0.5s ease
}

footer .footer-list li a:hover {
	color: #e6e8ea
}

footer .footer-list li:last-child {
	margin-bottom: 0
}

footer .footer-bar,
footer.footer-bar {
	border-top: 1px solid #2a3656
}

.csrm-user-dv {
	background: #FFFFFF;
	box-shadow: 0px 4px 15px rgb(0 0 0 / 10%);
	border-radius: 0px 0px 10px 10px;
	width: 190px;
	margin-top: 12px !important;
	padding: 0px;
}

.csrm-user-dv a, .csrm-user-dv button {
	display: block;
	padding: 8px 10px;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: #3F3F46;
}

.csrm-user-dv a:hover, .csrm-user-dv button:hover {
	background: #E0F9F9;
	color: #00CCCC;
}

a.cstm-logout, button.cstm-logout {
	color: #EE6F57;
}

button.cstm-logout {
	background: none;
	border: none;
	width: 100%;
    text-align: left;
}

.active-us {
	background: #E0F9F9;
	color: #00CCCC !important;
}

.active-nav {
	background: #E0F9F9;
	color: #00CCCC !important;
}

.active-nav-in {
	color: #00CCCC !important;
}

.active-nav-in:before {
	color: #00CCCC !important;
}


.cstm-revenue-analytics img {
	width: 100%;
}

.cstm-organization-charity img {
	width: 100%;
}

.view-all-link a {
	text-decoration: underline !important;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
	color: #3F3F46;
}

.view-all-link a:hover {
	color: #00CCCC !important;
	text-decoration: none !important;
}

.w-1 {
	width: 1% !important
}

.w-2 {
	width: 2% !important
}

.w-3 {
	width: 3% !important
}

.w-4 {
	width: 4% !important
}

.w-5 {
	width: 5% !important
}

.w-6 {
	width: 6% !important
}

.w-7 {
	width: 7% !important
}

.w-8 {
	width: 8% !important
}

.w-9 {
	width: 9% !important
}

.w-10 {
	width: 10% !important
}

.w-11 {
	width: 11% !important
}

.w-12 {
	width: 12% !important
}

.w-13 {
	width: 13% !important
}

.w-14 {
	width: 14% !important
}

.w-15 {
	width: 15% !important
}

.w-16 {
	width: 16% !important
}

.w-17 {
	width: 17% !important
}

.w-18 {
	width: 18% !important
}

.w-19 {
	width: 19% !important
}

.w-20 {
	width: 20% !important
}

.w-31 {
	width: 31% !important
}

.w-32 {
	width: 32% !important
}

.w-33 {
	width: 33% !important
}

.w-34 {
	width: 34% !important
}

.w-35 {
	width: 35% !important
}

.w-36 {
	width: 36% !important
}

.w-37 {
	width: 37% !important
}

.w-38 {
	width: 38% !important
}

.w-39 {
	width: 39% !important
}

.w-40 {
	width: 40% !important
}

.w-41 {
	width: 41% !important
}

.w-42 {
	width: 42% !important
}

.w-43 {
	width: 43% !important
}

.w-44 {
	width: 44% !important
}

.w-45 {
	width: 45% !important
}

.w-46 {
	width: 46% !important
}

.w-47 {
	width: 47% !important
}

.w-48 {
	width: 48% !important
}

.w-49 {
	width: 49% !important
}

.w-50 {
	width: 50% !important
}

.w-51 {
	width: 51% !important
}

.w-52 {
	width: 52% !important
}

.w-53 {
	width: 53% !important
}

.w-54 {
	width: 54% !important
}

.w-55 {
	width: 55% !important
}

.w-56 {
	width: 56% !important
}

.w-57 {
	width: 57% !important
}

.w-58 {
	width: 58% !important
}

.w-59 {
	width: 59% !important
}

.w-60 {
	width: 60% !important
}

.w-61 {
	width: 61% !important
}

.w-62 {
	width: 62% !important
}

.w-63 {
	width: 63% !important
}

.w-64 {
	width: 64% !important
}

.w-65 {
	width: 65% !important
}

.w-66 {
	width: 66% !important
}

.w-67 {
	width: 67% !important
}

.w-68 {
	width: 68% !important
}

.w-69 {
	width: 69% !important
}

.w-70 {
	width: 70% !important
}

.w-71 {
	width: 71% !important
}

.w-72 {
	width: 72% !important
}

.w-73 {
	width: 73% !important
}

.w-74 {
	width: 74% !important
}

.w-75 {
	width: 75% !important
}

.w-76 {
	width: 76% !important
}

.w-77 {
	width: 77% !important
}

.w-78 {
	width: 78% !important
}

.w-79 {
	width: 79% !important
}

.w-80 {
	width: 80% !important
}

.w-81 {
	width: 81% !important
}

.w-82 {
	width: 82% !important
}

.w-83 {
	width: 83% !important
}

.w-84 {
	width: 84% !important
}

.w-85 {
	width: 85% !important
}

.w-86 {
	width: 86% !important
}

.w-87 {
	width: 87% !important
}

.w-78 {
	width: 88% !important
}

.w-89 {
	width: 89% !important
}

.w-90 {
	width: 90% !important
}

.w-91 {
	width: 91% !important
}

.w-92 {
	width: 92% !important
}

.w-93 {
	width: 93% !important
}

.w-94 {
	width: 94% !important
}

.w-95 {
	width: 95% !important
}

.w-96 {
	width: 96% !important
}

.w-97 {
	width: 97% !important
}

.w-98 {
	width: 98% !important
}

.w-99 {
	width: 99% !important
}

.w-100 {
	width: 100% !important
}

.cstm-rco-photo {
	width: 48px;
	height: 48px;
}

.cstm-rco-photo {
	width: 48px;
	height: 48px;
	object-fit: cover;
	border-radius: 50%;
}

.cstm-eye {
	height: 40px;
	width: 40px;
	display: inline-block;
	border: 1px solid #bdbdbd;
	border-radius: 50%;
	text-align: center;
	line-height: 44px;
	color: #3F3F46;
	font-size: 18px;
	margin-right: 12px;
	vertical-align: top;
}

.cstm-eye:hover {
	background-color: #3F3F46;
	color: #FFF;
	border: 1px solid #3F3F46;
}

.cstm-chekmank {
	height: 40px;
	width: 40px;
	display: inline-block;
	border: 1px solid #75d5d5;
	border-radius: 50%;
	text-align: center;
	line-height: 44px;
	color: #00CCCC;
	font-size: 18px;
	margin-right: 12px;
	vertical-align: top;
}

.cstm-chekmank:hover {
	background-color: #00CCCC;
	color: #FFF;
	border: 1px solid #00CCCC;
}

.cstm-cross {
	height: 40px;
	width: 40px;
	display: inline-block;
	border: 1px solid #edaea2;
	border-radius: 50%;
	text-align: center;
	line-height: 42px;
	color: #EE6F57;
	font-size: 14px;
	margin-right: 12px;
	vertical-align: top;
}

.cstm-cross:hover {
	background-color: #EE6F57;
	color: #FFF;
	border: 1px solid #EE6F57;
}

.cstm-delete {
	height: 40px;
	width: 40px;
	display: inline-block;
	border: 1px solid #edaea2;
	border-radius: 50%;
	text-align: center;
	line-height: 42px;
	color: #EE6F57;
	font-size: 18px;
	margin-right: 12px;
	vertical-align: top;
}

.cstm-delete:hover {
	background-color: #EE6F57;
	color: #FFF;
	border: 1px solid #EE6F57;
}

.cstm-delete-share {
	height: 40px;
	width: 40px;
	display: inline-block;
	border: 1px solid #edaea2;
	border-radius: 50%;
	text-align: center;
	line-height: 42px;
	color: #008000;
	font-size: 18px;
	margin-right: 12px;
	vertical-align: top;
}

.cstm-delete-share:hover {
	background-color: #008000;
	color: #FFF;
	border: 1px solid #008000;
}

.cstm-edit {
	height: 40px;
	width: 40px;
	display: inline-block;
	border: 1px solid #77dfdf;
	border-radius: 50%;
	text-align: center;
	line-height: 42px;
	color: #00CCCC;
	font-size: 16px;
	margin-right: 12px;
	vertical-align: top;
}

.cstm-edit:hover {
	background-color: #00CCCC;
	color: #FFF;
	border: 1px solid #00CCCC;
}

.cstm-restore {
	height: 40px;
	width: 40px;
	display: inline-block;
	border: 1px solid #edaea2;
	border-radius: 50%;
	text-align: center;
	line-height: 42px;
	color: #EE6F57;
	font-size: 16px;
	margin-right: 12px;
	vertical-align: top;
}

.cstm-restore:hover {
	background-color: #EE6F57;
	color: #FFF;
	border: 1px solid #EE6F57;
}

.mrn-rt {
	margin-right: 0px !important;
}

.cstm-recently-joined-user-table {
	height: 423px;
}

.cstm-recently-joined-user-table::-webkit-scrollbar {
	width: 6px;
}

.cstm-recently-joined-user-table::-webkit-scrollbar-track {
	border-radius: 10px;
}

.cstm-recently-joined-user-table::-webkit-scrollbar-thumb {
	background: #00CCCC;
	border-radius: 10px;
}

.btn {
	border: none;
}

.cstm-user-main-photo {
	height: 40px;
	width: 40px;
	object-fit: cover;
	border-radius: 50%;
}

.cstm-icon-mn {
	margin-left: 4px;
	font-size: 25px;
	vertical-align: -7px;
}

.page-nav-list {
	font-weight: 400;
	font-size: 12px;
	line-height: 15px;
	color: #8492A6;
}

a {
	color: #00cccc;
}

a:hover {
	color: #000;
}

.mr-1,
.pr-1 {
	margin-right: 4px !important;
}

.mr-2,
.pr-2 {
	margin-right: 8px !important;
}

.mr-3,
.pr-3 {
	margin-right: 12px !important;
}

.mr-4,
.pr-4 {
	margin-right: 16px !important;
}

.mr-5,
.pr-5 {
	margin-right: 20px !important;
}

.mr-6,
.pr-6 {
	margin-right: 24px !important;
}


.ml-1,
.pl-1 {
	margin-left: 4px !important;
}

.ml-2,
.pl-2 {
	margin-left: 8px !important;
}

.ml-3,
.pl-3 {
	margin-left: 12px !important;
}

.ml-4,
.pl-4 {
	margin-left: 16px !important;
}

.ml-5,
.pl-5 {
	margin-left: 20px !important;
}

.ml-6,
.pl-6 {
	margin-left: 24px !important;
}

.profile-upl-img {
	width: 112px;
	height: 112px;
	object-fit: cover;
	border-radius: 50%;
}

.cstm-btn-red {
	background: red;
	border-radius: 5px;
	height: 40px;
	border: none;
	font-weight: 700;
	font-size: 14px;
	line-height: 16px;
	color: #FFF;
	padding: 10px 31px;
	font-family: "Inter", sans-serif;
}

.cstm-btn {
	background: #00CCCC;
	border-radius: 5px;
	height: 40px;
	border: none;
	font-weight: 700;
	font-size: 14px;
	line-height: 16px;
	color: #FFF;
	padding: 10px 31px;
	font-family: "Inter", sans-serif;
}

.cstm-btn:hover {
	background: #000;
	color: #FFF;
}

.cstm-btn {
	background: #00CCCC;
	border-radius: 5px;
	height: 40px;
	border: none;
	font-weight: 700;
	font-size: 14px;
	line-height: 16px;
	color: #FFF;
	padding: 10px 31px;
	font-family: "Inter", sans-serif;
}

.cstm-btn:hover {
	background: #000;
	color: #FFF;
}

.cstm-btn-click {
	border-radius: 5px;
	height: 40px;
	border: none;
	font-weight: 700;
	font-size: 14px;
	line-height: 16px;
	padding: 10px 31px;
	font-family: "Inter", sans-serif;
	background: #000;
	color: #FFF;
}

.cstm-btn2 {
	background: #FFF;
	border-radius: 5px;
	height: 40px;
	border: 1px solid #939393;
	font-weight: 700;
	font-size: 14px;
	line-height: 16px;
	color: #585858;
	padding: 10px 31px;
	font-family: "Inter", sans-serif;
}

.cstm-btn2:hover {
	background: #000;
	color: #FFF;
}
input::placeholder{
	color: #78787d;
}
.cstm-input {
	display: block;
	width: 100%;
	height: 56px;
	padding: 16px 24px;
	font-weight: 400;
	font-size: 16px;
	border: 1px solid #EEEEEE;
	border-radius: 10px;
	/* color: #78787d; */
}

.cstm-input-moderation-field {
	display: block;
	width: 100%;
	height: 200px;
	padding: 16px 24px;
	font-weight: 400;
	font-size: 16px;
	border: 1px solid #EEEEEE;
	border-radius: 10px;
}

.cstm-label {
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: #3F3F46;
	opacity: 0.7;
	font-family: "Inter", sans-serif;
	margin-bottom: 6px;
}

input:focus-visible {
	outline: none;
}

.cstm-select {
	display: block;
	width: 100%;
	height: 56px;
	line-height: 36px;
	padding: 6px 24px;
	font-weight: 400;
	font-size: 16px;
	border: 1px solid #EEEEEE;
	border-radius: 10px;
	color: #93969F;
	-webkit-appearance: none;
	-moz-appearance: none;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: right center;
	cursor: pointer;
}

select:focus-visible {
	outline: none;
}

.cstm-textarea {
	display: block;
	width: 100%;
	padding: 16px 24px;
	font-weight: 400;
	font-size: 16px;
	border: 1px solid #EEEEEE;
	border-radius: 10px;
}

.cstn-discard {
	width: 159px;
}

button {
	transition: all 0.5s ease;
}

.cstm-input-seacrh {
	display: block;
	width: 100%;
	height: 40px;
	padding: 5px 12px 5px 40px;
	font-weight: 400;
	font-size: 14px;
	border: 1px solid #EEEEEE;
	border-radius: 5px;
}

.cstm-search-ro {
	position: absolute;
	margin: 11px 0px 0px 15px;
}

.csatm-od-photo {
	height: 80px;
	width: 80px;
	object-fit: cover;
	border-radius: 500%;
}

hr {
	opacity: 0.12;
}

.title2 {
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	color: #93969F;
	margin-bottom: 8px;
}

.cstm-website-link {
	text-decoration: underline;
}

.cstm-tabs-pf .nav {
	border-bottom: 1px solid #e4e4e5;
}

.cstm-tabs-pf .nav li a {
	font-style: normal;
	font-weight: 400;
	font-size: 15px;
	line-height: 17px;
	color: #93969F;
	padding: 15px 35px;
	font-weight: 500;
	position: relative;
}

.cstm-tabs-pf .nav li a:hover {
	color: #000;
}

.cstm-tabs-pf .nav li a.active {
	color: #000;
}

.cstm-tabs-pf .nav li a.active:after {
	background: #000;
	width: 100%;
	height: 2px;
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
}

.cstm-table-down-arrow {
	vertical-align: -3px;
	font-size: 18px;
	line-height: 10px;
}

.cstm-om-slc {
	height: 40px;
	padding: 0px 15px;
	border-radius: 5px;
}

.cstm-om-input {
	width: 100%;
}

.col-all-auto {
	width: auto;
}

.cstm-cd-photo {
	position: absolute;
}

.cstm-od-details {
	padding-left: 100px;
}

.cstm-add-greetings-link a {
	text-decoration: underline !important;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
}

.delete-link {
	font-weight: 500;
	font-size: 12px;
	line-height: 16px;
	text-decoration-line: underline !important;
	color: #EE6F57;
}

.delete-link:hover {
	color: #000;
}

.edit-link {
	font-weight: 500;
	font-size: 12px;
	line-height: 16px;
	text-decoration-line: underline !important;
	color: #3F3F46;
}

.cstm-greeting-active {
	background: #E0F9F9;
}

span.cstm-published {
	background: #00CCCC;
	border-radius: 5px;
	font-weight: 600;
	font-size: 10px;
	line-height: 20px;
	color: #FFFFFF;
	margin-left: 20px;
	height: 20px;
	padding: 0px 11px;
}

/**/
.cstm-login {
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32%;
}

.cstm-btn-submit-login {
	background-color: #E0F9F9;
	border: 1px solid #E0F9F9;
	border-radius: .375rem;
	color: #00CCCC;
	transition: 0.3s ease-in-out;
}

.cstm-btn-submit-login:hover {
	background-color: #000;
	border-color: #000;
	color: #fff;
}

.cstm-submitbutton {
	background-color: #00CCCC;
	border: 1px solid #00CCCC;
	border-radius: .375rem;
	color: #fff;
	transition: 0.2s ease-in-out;
	padding: 8px 20px;
}

.cstm-submitbutton-disable {
	background-color: #99a3a3;
	border: 1px solid #99a3a3;
	border-radius: .375rem;
	color: #fff;
	transition: 0.2s ease-in-out;
	padding: 8px 20px;
}

.cstm-submitbutton-disable:hover {
	background-color: #99a3a3;
	border: 1px solid #99a3a3;
	border-radius: .375rem;
	color: #fff;
	transition: 0.2s ease-in-out;
	padding: 8px 20px;
}

.cstm-submitbutton:hover {
	background-color: #E0F9F9;
	border-color: #E0F9F9;
	color: #00CCCC;
}
/* .submit-btnMain {
	text-align: center;
} */

.NoRecord-cstm {
	transition: 0.5s ease-in-out;
	text-align: center;
	height: calc(100vh - 289px);
	line-height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.cstm-profile-img.cstm-AdminProfile-img img {
	width: 120px;
	height: 120px;
	margin-right: 10px;
	border-radius: 50%;
}

.cstm-profile-img.cstm-AdminProfile-img input {
	vertical-align: middle;
}

textarea:focus {
	outline: 0;
}

.cstm-organization-profile-pagination {
	padding: 12px 16px;
}

.submit-btnMain.cstm-loader {
    position: relative;
    width: auto;
    float: left;
}

.loader-main { 
    height: 100%;
    position: absolute;
    top: 0;
    text-align: center;
    background-color: #f8f9fceb;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loader-main img {
	width: 25px;
	height: 25px;
}
 
.cstm-table-main {
	/* height: calc(100vh - 188px); */
}

.form-select:focus {
	border-color: #EEEEEE;
	outline: 0;
	box-shadow: none;
}
select::placeholder{
	color: #78787d;
}
.cstm-category {
	padding: 16px 24px;
	border-color: #EEEEEE;
	border-radius: 10px;
	
}

.cstm-header-image img {
	border-radius: 50%;
}

.btn-close:focus {
	box-shadow: none;
}

.cstm-FAQHeader {
	display: flex;
	justify-content: space-between;
}

.cstm-Replied-by-user {
	align-self: center;
	text-align: right;
}

.cstm-Replied-by-user img {
	padding-right: 8px;
}

.cstm-Replied-by-user span {
	color: #8492A6;
	font-size: 12px;
	align-self: center;
}

.pending-status button {
	background-color: #EE6F57;
}

.pending-status button {
	background-color: #EE6F57;
	border: 1px solid #EE6F57;
	border-radius: 10px;
	font-size: 14px;
	padding: 4px 8px;
}

.in-progress-status button {
	background-color: #FFE000;
	border: 1px solid #FFE000;
	font-size: 14px;
	color: #3F3F46;
	padding: 4px 8px;
	border-radius: 10px;
}

.completed-status button {
	background-color: #00CCCC;
	border: 1px solid #00CCCC;
	font-size: 14px;
	color: #3F3F46;
	padding: 4px 8px;
	border-radius: 10px;
}

.re-text {
	color: #00CCCC;
	font-weight: 600;
}

.issue-regarding-no h4 {
	font-size: 16px;
	font-weight: 600;
	margin: 0 0 8px 0;
	color: #3F3F46;
}

.issue-regarding-no p {
	line-height: 28px;
	margin-bottom: 0;
}

.ticket1 span {
	color: #8492A6;
	font-size: 14px;
}

.ticket1 strong {
	color: #3F3F46;
	font-size: 14px;
}

.cstm-checkbox {
	height: 20px;
	width: 20px;
	margin-right: 8px;
	vertical-align: middle;
	accent-color: #0c9d9d;
	color: #fff;
}

.checkmark-content {
	color: #93969F;
	font-size: 14px;
	vertical-align: middle;
}

.cstm-textarea2 {
	padding: 0;
	height: 130px;
	overflow: hidden;
}

.pending-main1 {
	height: calc(100vh - 496px);
}

.pending-main2 {
	height: calc(100vh - 310px);
}

.pending-main3 {
	height: calc(100vh - 150px);
	overflow: hidden;
}

.checkmark-main {
	border: 1px solid #93969F;
	border-radius: 5px;
	padding: 12px;
}

.inprogress-bg {
	background-color: #E0F9F9;
}

.cstm-search-icon {
	position: absolute;
	margin: 16px 0px 0px 20px;
	z-index: 1;
	width: 35px;
}

.cstm-input-screen2 {
	display: block;
	width: 100%;
	height: 40px;
	padding: 16px 12px 16px 50px;
	font-weight: 400;
	font-size: 14px;
	border: 1px solid #EEEEEE;
	border-radius: 10px;
	height: 50px;
}

.AddOrganization-bannerImg {
	width: 400px;
    height: 250px;
    object-fit: cover;
    margin-bottom: 1rem;
    margin-left: 20px;
    padding: 10px;
}

.modal-dialog.cstm-modal-dialog.modal-dialog-centered {
	width: 50%;
	margin-right: 0;
	margin-left: 0;
}

.cstm-uploadHide {
	display: none;
}

.cstm-uploadbtn {
	line-height: normal;
	cursor: pointer;
}

/* .cstm-bg-input{
	background-color: #fff;
} */
.cstm-Videoalign {
	display: flex;
	align-items: center;
}
.pageloader{
	width: 50px;
	height: 50px;
}
.cstm-Tabledesign:hover{
	background-color: #e0f9f94d;
}
/* date-picker */

.react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover {
    border-radius: 50px;
    background-color: #00CCCC;
	color: #fff;
}
.react-datepicker__header {
    background-color: #fff;
    border-bottom: 0;
}
.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {
    margin: 13px 0;
}
.react-datepicker__navigation {
    top: 12px;
	background: #E0F9F9;
	border-radius: 5px;
}
.react-datepicker__navigation-icon--previous::before {
    transform: rotate(225deg);
    right: -7px;
	left: -5px;
}
.react-datepicker__navigation-icon--next::before {
    transform: rotate(45deg);
    left: -7px;
    left: -3px;
}
.react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {
	border-color: #424242;
    border-style: solid;
    border-width: 2px 2px 0 0;
    top: 11px;
    width: 9px;
}
.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
    background-color: #00cccc;
    color: #fff;
	border-radius: 50px;
}
.react-datepicker {
    border: 1px solid #EEEEEE;
}

.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {
    margin-top: 12px;
}
.react-datepicker__input-container input {
	border: 1px solid #eeeeee;
	font-size: 13px;
    padding: 6px 8px;
	width: 100%;
}
/**/

.ctsm-addGreeting a{
	text-decoration: underline !important;
	font-size: 14px;
}
.cstm-maincontent{
	border: 1px solid #eeeeee;
    padding: 12px 16px;
    border-radius: 5px;
}
.cstm-addgreetinginput{
	display: block;
    width: 139%;
    height: 18px;
    padding: 16px 24px;
    font-weight: 400;
    font-size: 16px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
    color: #78787d;
}
.cstm-giftinginput{
	display: block;
    width: 30%;
    height: 18px;
    padding: 16px 24px;
    font-weight: 400;
    font-size: 16px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
    color: #78787d;
}
.cstm-gift-icon{
    width: 75px;
    height: 75px;
    object-fit: cover;
}
.cstm-textarea{
	height: auto;
}
.cstm-imagevideo{
	display: flex;
	align-items: center;
}

.cstm-faq-main{
	display: flex;
    justify-content: space-between;
    padding-left: 30px;
}

.cstm-faq-main{
	display: flex;
    justify-content: space-between;
    padding-left: 30px;
}
div#accordion__heading-\\:r0\\:{
	position: relative;
}
.accordion__button:before {
    display: inline-block;
    content: '';
    height: 10px;
    width: 10px;
    margin-right: 12px;
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(-45deg);
    position: absolute;
	margin-top: 7px;
}
.accordion__button {
    background-color: #e0f9f94d;
    color: #93969F;
	transition: 1s ease-in-out all;
}
.accordion__button:hover {
    background-color: #e0f9f9a6;
}
.cstm-terms-condidtion{
	/* height: calc(100vh - 188px); */
}
.cstm-usertable-design{
	border: 1px solid #FFFFFF;
	padding: 12px 16px;
}
.cstm-userheading{
	padding: 12px 16px !important;
}
.cstm-usertable-design td{
	padding: 12px 16px;
}
.cstm-datepicker input{
	padding: 16px 24px;
	border-radius: 10px;
	height: 56px;
	color: #78787d;
	font-size: 16px;
}
.cstm-editor{
	border: 1px solid #F1F1F1;
    padding: 16px;
}

/* table design */
.cstm-cl-mn2 tr th:nth-child(2) {
    width: 32%;
}
.cstm-cl-mn3 tr th:nth-child(3) {
    width: 32%;
}
.cstm-cl-mn4 tr th:nth-child(4) {
    width: 32%;
}
.cstm-cl-mn5 tr th:nth-child(5) {
    width: 32%;
}
.cstm-cl-mn6 tr th:nth-child(6) {
    width: 32%;
}
.cstm-cl-mn7 tr th:nth-child(7) {
    width: 32%;
}

.partially-registered-user-notes > div {
	border: 1px solid #EEEEEE;
	border-radius: 10px;
	padding: 0.5rem;
	margin-bottom: 0.5rem;
}

.partially-registered-user-notes > div > span {
	font-size: small;
	color: #93969F;
}

.partially-registered-user-notes > div > p {
	font-weight: bold;
	margin: 0;
	white-space: pre-wrap;
}

.single-selection-button-group {

}

.single-selection-button-group button {
    border: 1px solid #00CCCC;
    color: #00CCCC;
    transition: 0.2s ease-in-out;
    padding: 8px 20px;
}

.single-selection-button-group button.active {
    background-color: #00CCCC;
    color: #fff;
}

.single-selection-button-group button:hover {
    background-color: #E0F9F9;
    border-color: #E0F9F9;
    color: #00CCCC;
}

.single-selection-button-group button:first-child {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
}

.single-selection-button-group button:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}

.custom-filter-icon-btn {
	height: 40px;
	width: 40px;
	border: 1px solid #00CCCC;
	border-radius: 50%;
	color: #00CCCC;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	line-height: 0;
}

.custom-filter-icon-btn:hover {
	background-color: #00CCCC;
	color: white;
}

.custom-skeleton-loader-full {
	z-index: 1000;
	background-color: #e2e5e7;
	background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
	background-size: 40px 100%;
	background-repeat: no-repeat;
	background-position: left -40px top 0;
	animation: custom-skeleton-loader-full-shine 1s ease infinite;
}

.custom-skeleton-loader-full > * {
	visibility: hidden;
}

@keyframes custom-skeleton-loader-full-shine {
	to {
		background-position: right -40px top 0;
	}
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.min.css"],"names":[],"mappings":"AAEA;KACK,UAAU;AACf;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;CACd,yBAAyB;IACtB,UAAU;AACd;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IAEzB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IAGI,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;;AAGA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;;;CAGC,eAAe;CACf,gBAAgB;CAChB;AACD;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;CACpB,sBAAsB;IACnB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;CACpB,sBAAsB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kDAAkD;CAClD,kDAAkD;CAClD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kDAAkD;CAClD,kDAAkD;CAClD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sCAAsC;CACtC;AACD;;AAEA;CACC,sCAAsC;CACtC;AACD;;AAEA;CACC,yCAAyC;CACzC;AACD;;AAEA;CACC,uCAAuC;CACvC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,kDAAkD;CAClD,kDAAkD;CAClD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,kDAAkD;CAClD,kDAAkD;CAClD,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;CACtB;AACD;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,qBAAqB;CACrB,eAAe;CACf,qBAAqB;CACrB,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,iCAAiC;CACjC;AACD;;AAEA;CACC,uCAAuC;CACvC,qDAAqD;CACrD,0CAA0C;CAC1C;AACD;;AAEA;;;;;CAKC;AACD;;AAEA;CACC,0CAA0C;CAC1C,cAAc;CACd,0CAA0C;CAC1C;AACD;;AAEA;;;;;CAKC,gBAAgB;CAChB;AACD;;AAEA;CACC,oCAAoC;CACpC,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC;AACD;;AAEA;CACC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,kDAAkD;CAClD,kDAAkD;CAClD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,qDAAqD;CACrD,qDAAqD;CACrD;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB;AACD;;AAEA;CACC,kDAAkD;CAClD,kDAAkD;CAClD;AACD;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,yBAAyB;CACzB,iCAAiC;CACjC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;;;;;CAKC,6BAA6B;CAC7B;AACD;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,0CAA0C;CAC1C,wBAAwB;AACzB;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,yBAAyB;CACzB,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,0CAA0C;CAC1C,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,uCAAuC;CACvC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,0CAA0C;CAC1C,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,0CAA0C;CAC1C,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,uCAAuC;CACvC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;CACT,YAAY;CACZ;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;CACjB;AACD;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,4BAA4B;CAC5B,cAAc;CACd,oCAAoC;CACpC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;CAC3B;AACD;;AAEA;CACC,4BAA4B;CAC5B;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,8BAA8B;CAC9B,qBAAqB;CACrB;AACD;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,oDAAoD;CACpD;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,QAAQ;CACR;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;;CAEC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;;EAEC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,oCAAoC;CACpC,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,2BAA2B;CAC3B;AACD;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB;AACD;;AAEA;CACC,SAAS;CACT,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ;AACD;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,iCAAiC;CACjC,oCAAoC;CACpC,6BAA6B;CAC7B,uBAAuB;CACvB;AACD;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;CAC5B;AACD;;AAEA;CACC,yDAAyD;CACzD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;;CAEC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oCAAoC;CACpC;AACD;;AAEA;CACC,2BAA2B;CAC3B,cAAc;CACd;AACD;;AAEA;;;;;;;;;;;;CAYC,oBAAoB;CACpB;AACD;;AAEA;CACC,2BAA2B;CAC3B,cAAc;CACd;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,YAAY;CACZ,wBAAwB;CACxB,oBAAoB;CACpB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,6BAA6B;CAC7B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;CAEC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;CAChC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,aAAa;CACb,UAAU;CACV;AACD;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC,eAAe;CACf,OAAO;CACP,SAAS;CACT;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;CAChC,6BAA6B;CAC7B,eAAe;CACf,cAAc;AACf;;AAEA;;;;;;;;;;;;CAYC;AACD;;AAEA;CACC,mCAAmC;CACnC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,wCAAwC;CACxC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,OAAO;CACP,SAAS;CACT,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B;AACD;;AAEA;CACC,0BAA0B;CAC1B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,QAAQ;CACR,YAAY;CACZ;AACD;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,8CAA8C;CAC9C,aAAa;CACb;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,UAAU;CACV;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,QAAQ;CACR;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,OAAO;CACP,MAAM;CACN,aAAa;CACb,6BAA6B;CAC7B,SAAS;CACT;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,yBAAyB;CACzB,qBAAqB;CACrB,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,SAAS;CACT;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,QAAQ;CACR;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,QAAQ;CACR;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,cAAc;CACd,cAAc;CACd,eAAe;CACf,wCAAwC;CACxC,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;CACjB,yBAAyB;CACzB,oBAAoB;CACpB,gCAAgC;CAChC,kBAAkB;CAClB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,yBAAyB;CACzB,qBAAqB;CACrB,YAAY;CACZ,wBAAwB;CACxB,kBAAkB;CAClB,oBAAoB;CACpB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,WAAW;CACX,wBAAwB;CACxB,mBAAmB;CACnB;AACD;;AAEA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,oCAAoC;CACpC,WAAW;CACX,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC;EACC,aAAa;EACb;CACD;;CAEA;EACC,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB;CACD;;CAEA;EACC;CACD;;CAEA;EACC,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB;CACD;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf;CACD;;CAEA;EACC,mBAAmB;EACnB;CACD;;CAEA;EACC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB;CACD;;CAEA;EACC,UAAU;EACV,MAAM;EACN,iBAAiB;EACjB;CACD;;CAEA;EACC,UAAU;EACV,MAAM;EACN,iBAAiB;EACjB;CACD;;CAEA;EACC,iBAAiB;EACjB,oBAAoB;EACpB;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC,UAAU;EACV;CACD;;CAEA;EACC,UAAU;EACV;CACD;;CAEA;EACC,UAAU;EACV,WAAW;EACX,cAAc;EACd;CACD;;CAEA;EACC,yBAAyB;EACzB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,UAAU;EACV;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,iBAAiB;EACjB;CACD;;CAEA;EACC,iBAAiB;EACjB;CACD;;CAEA;;EAEC;CACD;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,0CAA0C;EAC1C;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB;CACD;;CAEA;EACC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB;CACD;;CAEA;EACC;CACD;;CAEA;EACC,aAAa;EACb;CACD;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;EAChB;CACD;;CAEA;EACC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;;CAEA;;;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX;CACD;;CAEA;EACC;CACD;;CAEA;EACC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;EAChC;CACD;;CAEA;EACC,cAAc;EACd;CACD;AACD;;AAEA;CACC;EACC,WAAW;EACX;CACD;AACD;;AAEA;CACC;EACC,mBAAmB;EACnB,UAAU;EACV;CACD;;CAEA;EACC,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0CAA0C;CAC1C,sBAAsB;CACtB;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,MAAM;CACN,YAAY;CACZ;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mCAAmC;CACnC,+BAA+B;CAC/B,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,eAAe;CACf;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,2BAA2B;CAC3B;AACD;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,6BAA6B;CAC7B,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;;CAEC,+CAA+C;AAChD;;AAEA;CACC,4BAA4B;CAC5B,cAAc;CACd,oCAAoC;CACpC,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,0BAA0B;CAC1B,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;CAC5B,cAAc;CACd,oCAAoC;CACpC,iBAAiB;CACjB,eAAe;CACf,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;;CAEC,YAAY;CACZ;AACD;;AAEA;;CAEC,YAAY;CACZ,eAAe;CACf;AACD;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT;AACD;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,8BAA8B;CAC9B,mBAAmB;CACnB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,YAAY;CACZ,wBAAwB;CACxB,mBAAmB;CACnB;AACD;;AAEA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,oCAAoC;CACpC,WAAW;CACX,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC,kCAAkC;CAClC,+CAA+C;CAC/C;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,OAAO;CACP,QAAQ;CACR,4BAA4B;CAC5B;AACD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB;CACD;AACD;;AAEA;;CAEC,WAAW;CACX,YAAY;CACZ,QAAQ;CACR,2BAA2B;CAC3B,mBAAmB;CACnB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,8CAA8C;CAC9C,yBAAyB;CACzB,0CAA0C;CAC1C,aAAa;CACb;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;;CAEC;;;;EAIC,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;CAC3B,WAAW;CACX,aAAa;CACb;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,0BAA0B;CAC1B,QAAQ;CACR,OAAO;CACP;AACD;;AAEA;CACC,YAAY;CACZ,gCAAgC;CAChC,oCAAoC;CACpC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC,gCAAgC;CAChC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;;;CAGC,8BAA8B;CAC9B;AACD;;AAEA;;CAEC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,UAAU;CACV,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,8CAA8C;CAC9C,yBAAyB;CACzB,0CAA0C;CAC1C,aAAa;CACb;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,OAAO;CACP,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT;AACD;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,UAAU;CACV;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB;AACD;;AAEA;CACC,6BAA6B;CAC7B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,WAAW;CACX,wBAAwB;CACxB;AACD;;AAEA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,oCAAoC;CACpC,WAAW;CACX,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,cAAc;CACd,cAAc;CACd,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,qBAAqB;CACrB,cAAc;CACd,mBAAmB;CACnB,sBAAsB;CACtB,qBAAqB;CACrB,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV;AACD;;AAEA;;CAEC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,0BAA0B;CAC1B,oCAAoC;CACpC,oCAAoC;CACpC,sBAAsB;CACtB;AACD;;AAEA;;;;;;CAMC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;;;;;CAKC,oCAAoC;CACpC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,kBAAkB;CAClB,UAAU;CACV;AACD;;AAEA;CACC,SAAS;CACT,UAAU;CACV;AACD;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,UAAU;CACV;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX;AACD;;AAEA;CACC,oBAAoB;CACpB,WAAW;CACX;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,eAAe;CACf,aAAa;CACb;AACD;;AAEA;CACC,eAAe;CACf,WAAW;CACX,aAAa;CACb,WAAW;CACX;AACD;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oDAAoD;CACpD,oDAAoD;CACpD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,mBAAmB;CACnB,yCAAyC;CACzC,gCAAgC;CAChC,YAAY;CACZ,2BAA2B;CAC3B,YAAY;AACb;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,WAAW;IACR,gBAAgB;AACpB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;;AAGA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;AACjC;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;AAC9B;;;AAGA;;CAEC,2BAA2B;AAC5B;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,yBAAyB;CACzB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,YAAY;CACZ,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,yDAAyD;CACzD,4BAA4B;CAC5B,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,0BAA0B;CAC1B,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,OAAO;AACR;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,0CAA0C;CAC1C,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,0CAA0C;CAC1C,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,iBAAiB;CACjB,YAAY;CACZ,iBAAiB;AAClB;;AAEA,GAAG;AACH;CACC,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,sBAAsB;CACtB,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,sBAAsB;CACtB,WAAW;CACX,4BAA4B;CAC5B,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,sBAAsB;CACtB,WAAW;CACX,4BAA4B;CAC5B,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,sBAAsB;CACtB,WAAW;CACX,4BAA4B;CAC5B,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;;GAEG;;AAEH;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,2BAA2B;CAC3B,iBAAiB;CACjB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;;AAEpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,sBAAsB;CACtB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,YAAY;IACT,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;CACC,UAAU;CACV,eAAe;CACf,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;GAEG;AACH;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,2BAA2B;AAC5B;AACA,gBAAgB;;AAEhB;IACI,mBAAmB;IACnB,yBAAyB;CAC5B,WAAW;AACZ;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,SAAS;CACZ,mBAAmB;CACnB,kBAAkB;AACnB;AACA;IACI,yBAAyB;IACzB,WAAW;CACd,UAAU;AACX;AACA;IACI,wBAAwB;IACxB,UAAU;IACV,UAAU;AACd;AACA;CACC,qBAAqB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,WAAW;CACd,mBAAmB;AACpB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;AACA;CACC,yBAAyB;CACzB,eAAe;IACZ,gBAAgB;CACnB,WAAW;AACZ;AACA,GAAG;;AAEH;CACC,qCAAqC;CACrC,eAAe;AAChB;AACA;CACC,yBAAyB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;CACC,cAAc;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;AACA;CACC,cAAc;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;CACC,YAAY;AACb;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;IACV,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;CACC,aAAa;IACV,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;CACrB,eAAe;AAChB;AACA;IACI,2BAA2B;IAC3B,cAAc;CACjB,8BAA8B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;CACC,iCAAiC;AAClC;AACA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;CACZ,cAAc;CACd,eAAe;AAChB;AACA;CACC,yBAAyB;IACtB,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,SAAS;CACT,qBAAqB;AACtB;;AAEA;;AAEA;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,uBAAuB;CACvB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,kHAAkH;CAClH,0BAA0B;CAC1B,4BAA4B;CAC5B,qCAAqC;CACrC,6DAA6D;AAC9D;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,sCAAsC;CACvC;AACD","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&amp;display=swap\");\r\n\r\n.cstm-charity-table tr th:last-child{\r\n     width: 15%;\r\n}\r\n.cstm-gift-price-main {\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.autocomplete-dropdown-container {\r\n    position: absolute;\r\n    background: #FFF;\r\n    z-index: 88;\r\n\tborder: 1px solid #dddddd;\r\n    width: 56%;\r\n}\r\nspan.drag-gift-sp-cstm {\r\n    font-size: 24px;\r\n    line-height: 16px;\r\n}\r\n \r\n.cstm-gp-btn {\r\n    position: absolute;\r\n    top: 38px;\r\n    right: 8px;\r\n    height: 40px;\r\n    width: 40px;\r\n    display: inline-block;\r\n    border: 1px solid #edaea2;\r\n    border-radius: 7px;\r\n    text-align: center;\r\n    line-height: 42px;\r\n    color: #EE6F57;\r\n    font-size: 18px;\r\n    margin-right: 12px;\r\n    vertical-align: top;\r\n    background: white;\r\n}\r\n.cstm-gp-btn:hover {\r\n    background: #EE6F57;\r\n    color: #FFF;\r\n}\r\n.cstm-gift-price-main .cstm-input {\r\n    padding-right: 60px;\r\n}\r\n.cstm-switch .switch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 52px;\r\n    height: 24px;\r\n}\r\n.cstm-switch .switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n.cstm-switch .slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #ededed;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n.cstm-switch .slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 18px;\r\n    width: 18px;\r\n    top: 3px;\r\n    left: 4px;\r\n    bottom: 4px;\r\n    background-color: white;\r\n    transition: .4s;\r\n}\r\n.cstm-switch input:checked+.slider {\r\n    background-color: #00CCCC;\r\n}\r\n.cstm-switch input:focus+.slider {\r\n    box-shadow: 0 0 1px #00CCCC;\r\n}\r\n.cstm-switch input:checked+.slider:before {\r\n    -webkit-transform: translateX(26px);\r\n    -ms-transform: translateX(26px);\r\n    transform: translateX(26px);\r\n}\r\n.cstm-switch .slider.round {\r\n    border-radius: 34px;\r\n}\r\n.cstm-switch .slider.round:before {\r\n    border-radius: 50%;\r\n}\r\n\r\n\r\n.error-yup {\r\n\tcolor: red\r\n}\r\n\r\n.logo-brand-admin-portal {\r\n\ttext-align: center;\r\n\tpadding-bottom: 40px;\r\n}\r\n\r\n.cstm-privacy-policy-main .DraftEditor-editorContainer {\r\n    height: 600px;\r\n}\r\n\r\nh1,\r\n.h1 {\r\n\tfont-size: 42px;\r\n\tline-height: 1.5;\r\n\tfont-weight: 600\r\n}\r\n\r\nh2,\r\n.h2 {\r\n\tfont-size: 30px;\r\n\tline-height: 1.5;\r\n\tfont-weight: 600\r\n}\r\n\r\nh3,\r\n.h3 {\r\n\tfont-size: 24px;\r\n\tline-height: 1.5;\r\n\tfont-weight: 600\r\n}\r\n\r\nh4,\r\n.h4 {\r\n\tfont-size: 20px;\r\n\tline-height: 1.5;\r\n\tfont-weight: 600\r\n}\r\n\r\nh5,\r\n.h5 { \r\n\tfont-size: 16px;\r\n\tline-height: 1.5;\r\n\tfont-weight: 600\r\n}\r\n\r\nh6,\r\n.h6 {\r\n\r\n\tfont-size: 14px;\r\n\tline-height: 1.5;\r\n\tfont-weight: 600\r\n}\r\n.cstm-rr input[type=\"checkbox\"] {\r\n    accent-color: #14a5a5;\r\n    height: 16px;\r\n    width: 16px;\r\n    vertical-align: -2px;\r\n    margin-right: 5px;\r\n}\r\nspan.topic-label-in button {\r\n    position: absolute;\r\n    top: -7px;\r\n    right: -5px;\r\n    color: #939393;\r\n    border-radius: 50px;\r\n    background: #FFF;\r\n    border: 1px solid #d7d7d7;\r\n    font-size: 16px;\r\n    padding: 0px 4px 2px 4px;\r\n    line-height: 16px;\r\n}\r\nspan.topic-label-in {\r\n    border: 1px solid #00cccc;\r\n    padding: 5px 20px 5px 15px;\r\n    border-radius: 40px;\r\n    margin: 0px 15px 10px 0px;\r\n    font-weight: 300;\r\n    font-family: \"Inter\", sans-serif;\r\n    position: relative;\r\n}\r\n.cstm-vi-bx img {\r\n    width: 200px;\r\n    height: 170px;\r\n    object-fit: cover;\r\n\tvertical-align: middle;\r\n    align-items: center;\r\n}\r\n.cstm-vi-bx video {\r\n    width: 200px;\r\n    height: 170px;\r\n    object-fit: cover;\r\n\tvertical-align: middle;\r\n    align-items: center;\r\n}\r\n\r\n.cstm-vi-box {\r\n    margin-right: 20px;\r\n    position: relative;  \r\n    margin-bottom: 20px;\r\n    border: 1px solid #e5e5e5; \r\n} \r\n.cstm-vi-box button {\r\n    color: #939393; \r\n    position: absolute;\r\n    right: -12px;\r\n    top: -12px;\r\n    border-radius: 50px;\r\n    background: #FFF;\r\n    border: 1px solid #d7d7d7;\r\n}\r\n.cstm-vi-box button:hover {\r\n    background: #00cccc;\r\n    color: #FFF;\r\n}\r\n.cstm-video-image-upload {\r\n    min-height: 40px;\r\n}\r\n.cstm-vi-in {\r\n    padding-left: 170px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n.cstm-video-image-upload .cstm-uploadbtn {\r\n    position: absolute;\r\n}\r\n.DraftEditor-editorContainer {\r\n    height: 600px;\r\n}\r\n.display-1 {\r\n\tfont-size: 80px\r\n}\r\n\r\n.display-2 {\r\n\tfont-size: 72px\r\n}\r\n\r\n.display-3 {\r\n\tfont-size: 64px\r\n}\r\n\r\n.display-4 {\r\n\tfont-size: 56px\r\n}\r\n\r\n.bg-primary {\r\n\tbackground-color: #00CCCC !important\r\n}\r\n\r\n.bg-soft-primary {\r\n\tbackground-color: rgba(57, 108, 240, 0.1) !important;\r\n\tborder: 1px solid rgba(57, 108, 240, 0.1) !important;\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.text-primary {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-primary:hover,\r\na.text-primary:focus {\r\n\tcolor: #215aee !important\r\n}\r\n\r\n.bg-secondary {\r\n\tbackground-color: #5a6d90 !important\r\n}\r\n\r\n.bg-soft-secondary {\r\n\tbackground-color: rgba(90, 109, 144, 0.1) !important;\r\n\tborder: 1px solid rgba(90, 109, 144, 0.1) !important;\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.text-secondary {\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-secondary:hover,\r\na.text-secondary:focus {\r\n\tcolor: #506180 !important\r\n}\r\n\r\n.bg-success {\r\n\tbackground-color: #53c797 !important\r\n}\r\n\r\n.bg-soft-success {\r\n\tbackground-color: rgba(83, 199, 151, 0.1) !important;\r\n\tborder: 1px solid rgba(83, 199, 151, 0.1) !important;\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.text-success {\r\n\tcolor: #53c797 !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-success:hover,\r\na.text-success:focus {\r\n\tcolor: #40c18b !important\r\n}\r\n\r\n.bg-warning {\r\n\tbackground-color: #f1b561 !important\r\n}\r\n\r\n.bg-soft-warning {\r\n\tbackground-color: rgba(241, 181, 97, 0.1) !important;\r\n\tborder: 1px solid rgba(241, 181, 97, 0.1) !important;\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.text-warning {\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-warning:hover,\r\na.text-warning:focus {\r\n\tcolor: #efaa4a !important\r\n}\r\n\r\n.bg-info {\r\n\tbackground-color: #64c2f1 !important\r\n}\r\n\r\n.bg-soft-info {\r\n\tbackground-color: rgba(100, 194, 241, 0.1) !important;\r\n\tborder: 1px solid rgba(100, 194, 241, 0.1) !important;\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.text-info {\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-info:hover,\r\na.text-info:focus {\r\n\tcolor: #4db9ef !important\r\n}\r\n\r\n.bg-danger {\r\n\tbackground-color: #f0735a !important\r\n}\r\n\r\n.bg-soft-danger {\r\n\tbackground-color: rgba(240, 115, 90, 0.1) !important;\r\n\tborder: 1px solid rgba(240, 115, 90, 0.1) !important;\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.text-danger {\r\n\tcolor: #f0735a !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-danger:hover,\r\na.text-danger:focus {\r\n\tcolor: #ee5f43 !important\r\n}\r\n\r\n.bg-dark {\r\n\tbackground-color: #343a40 !important\r\n}\r\n\r\n.bg-soft-dark {\r\n\tbackground-color: rgba(52, 58, 64, 0.1) !important;\r\n\tborder: 1px solid rgba(52, 58, 64, 0.1) !important;\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.text-dark {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-dark:hover,\r\na.text-dark:focus {\r\n\tcolor: #292d32 !important\r\n}\r\n\r\n.bg-muted {\r\n\tbackground-color: #8492a6 !important\r\n}\r\n\r\n.bg-soft-muted {\r\n\tbackground-color: rgba(132, 146, 166, 0.1) !important;\r\n\tborder: 1px solid rgba(132, 146, 166, 0.1) !important;\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.text-muted {\r\n\tcolor: #8492A6 !important\r\n}\r\n\r\n.cstm-tx14 {\r\n\tfont-size: 14px;\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-muted:hover,\r\na.text-muted:focus {\r\n\tcolor: #75859b !important\r\n}\r\n\r\n.bg-light {\r\n\tbackground-color: #f8f9fc !important\r\n}\r\n\r\n.bg-soft-light {\r\n\tbackground-color: rgba(248, 249, 252, 0.1) !important;\r\n\tborder: 1px solid rgba(248, 249, 252, 0.1) !important;\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.text-light {\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-light:hover,\r\na.text-light:focus {\r\n\tcolor: #e6eaf4 !important\r\n}\r\n\r\n.bg-footer {\r\n\tbackground-color: #202942 !important\r\n}\r\n\r\n.bg-soft-footer {\r\n\tbackground-color: rgba(32, 41, 66, 0.1) !important;\r\n\tborder: 1px solid rgba(32, 41, 66, 0.1) !important;\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.text-footer {\r\n\tcolor: #202942 !important\r\n}\r\n\r\na {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\na.text-footer:hover,\r\na.text-footer:focus {\r\n\tcolor: #181e30 !important\r\n}\r\n\r\n.bg-white-50 {\r\n\tbackground-color: rgba(255, 255, 255, 0.5)\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n\t.container {\r\n\t\tmax-width: 1140px !important\r\n\t}\r\n}\r\n\r\n.row>* {\r\n\tposition: relative\r\n}\r\n\r\n.list-inline-item:not(:last-child) {\r\n\tmargin-right: 0px;\r\n\tmargin-bottom: 5px\r\n}\r\n\r\n.margin-nagative.mt-n5 {\r\n\tmargin-top: -48px\r\n}\r\n\r\n.d-flex .flex-1 {\r\n\tflex: 1\r\n}\r\n\r\n.rounded {\r\n\tborder-radius: 5px !important\r\n}\r\n\r\n.rounded-top {\r\n\tborder-top-left-radius: 5px !important;\r\n\tborder-top-right-radius: 5px !important\r\n}\r\n\r\n.rounded-left {\r\n\tborder-top-left-radius: 5px !important;\r\n\tborder-bottom-left-radius: 5px !important\r\n}\r\n\r\n.rounded-bottom {\r\n\tborder-bottom-left-radius: 5px !important;\r\n\tborder-bottom-right-radius: 5px !important\r\n}\r\n\r\n.rounded-right {\r\n\tborder-top-right-radius: 5px !important;\r\n\tborder-bottom-right-radius: 5px !important\r\n}\r\n\r\n.rounded-md {\r\n\tborder-radius: 10px !important\r\n}\r\n\r\n.rounded-lg {\r\n\tborder-radius: 30px !important\r\n}\r\n\r\n.border {\r\n\tborder: 1px solid #e9ecef !important\r\n}\r\n\r\n.border-top {\r\n\tborder-top: 1px solid #e9ecef !important\r\n}\r\n\r\n.border-bottom {\r\n\tborder-bottom: 1px solid #e9ecef !important\r\n}\r\n\r\n.border-left {\r\n\tborder-left: 1px solid #e9ecef !important\r\n}\r\n\r\n.border-right {\r\n\tborder-right: 1px solid #e9ecef !important\r\n}\r\n\r\n.small,\r\nsmall {\r\n\tfont-size: 14px;\r\n}\r\n\r\n.card {\r\n\tborder: 0\r\n}\r\n\r\n.card .card-body {\r\n\tpadding: 1.5rem\r\n}\r\n\r\n.offcanvas .offcanvas-header .dark-version {\r\n\tdisplay: none\r\n}\r\n\r\n.offcanvas .offcanvas-header .light-version {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.offcanvas .offcanvas-header .btn-close {\r\n\tcolor: #343a40;\r\n\tbackground: none\r\n}\r\n\r\n.btn-primary {\r\n\tbackground-color: #00CCCC !important;\r\n\tborder: 1px solid #00CCCC !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(57, 108, 240, 0.3)\r\n}\r\n\r\n.btn-primary:hover,\r\n.btn-primary:focus,\r\n.btn-primary:active,\r\n.btn-primary.active,\r\n.btn-primary.focus {\r\n\tbackground-color: #215aee !important;\r\n\tborder-color: #215aee !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-primary {\r\n\tbackground-color: rgba(57, 108, 240, 0.1) !important;\r\n\tborder: 1px solid rgba(57, 108, 240, 0.1) !important;\r\n\tcolor: #00CCCC !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(57, 108, 240, 0.3)\r\n}\r\n\r\n.btn-soft-primary:hover,\r\n.btn-soft-primary:focus,\r\n.btn-soft-primary:active,\r\n.btn-soft-primary.active,\r\n.btn-soft-primary.focus {\r\n\tbackground-color: #00CCCC !important;\r\n\tborder-color: #00CCCC !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-primary {\r\n\tborder: 1px solid #00CCCC;\r\n\tcolor: #00CCCC;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-primary:hover,\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary:active,\r\n.btn-outline-primary.active,\r\n.btn-outline-primary.focus,\r\n.btn-outline-primary:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #00CCCC;\r\n\tborder-color: #00CCCC;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(57, 108, 240, 0.3)\r\n}\r\n\r\n.btn-secondary {\r\n\tbackground-color: #5a6d90 !important;\r\n\tborder: 1px solid #5a6d90 !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(90, 109, 144, 0.3)\r\n}\r\n\r\n.btn-secondary:hover,\r\n.btn-secondary:focus,\r\n.btn-secondary:active,\r\n.btn-secondary.active,\r\n.btn-secondary.focus {\r\n\tbackground-color: #506180 !important;\r\n\tborder-color: #506180 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-secondary {\r\n\tbackground-color: rgba(90, 109, 144, 0.1) !important;\r\n\tborder: 1px solid rgba(90, 109, 144, 0.1) !important;\r\n\tcolor: #5a6d90 !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(90, 109, 144, 0.3)\r\n}\r\n\r\n.btn-soft-secondary:hover,\r\n.btn-soft-secondary:focus,\r\n.btn-soft-secondary:active,\r\n.btn-soft-secondary.active,\r\n.btn-soft-secondary.focus {\r\n\tbackground-color: #5a6d90 !important;\r\n\tborder-color: #5a6d90 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-secondary {\r\n\tborder: 1px solid #5a6d90;\r\n\tcolor: #5a6d90;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-secondary:hover,\r\n.btn-outline-secondary:focus,\r\n.btn-outline-secondary:active,\r\n.btn-outline-secondary.active,\r\n.btn-outline-secondary.focus,\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #5a6d90;\r\n\tborder-color: #5a6d90;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(90, 109, 144, 0.3)\r\n}\r\n\r\n.btn-success {\r\n\tbackground-color: #53c797 !important;\r\n\tborder: 1px solid #53c797 !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(83, 199, 151, 0.3)\r\n}\r\n\r\n.btn-success:hover,\r\n.btn-success:focus,\r\n.btn-success:active,\r\n.btn-success.active,\r\n.btn-success.focus {\r\n\tbackground-color: #40c18b !important;\r\n\tborder-color: #40c18b !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-success {\r\n\tbackground-color: rgba(83, 199, 151, 0.1) !important;\r\n\tborder: 1px solid rgba(83, 199, 151, 0.1) !important;\r\n\tcolor: #53c797 !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(83, 199, 151, 0.3)\r\n}\r\n\r\n.btn-soft-success:hover,\r\n.btn-soft-success:focus,\r\n.btn-soft-success:active,\r\n.btn-soft-success.active,\r\n.btn-soft-success.focus {\r\n\tbackground-color: #53c797 !important;\r\n\tborder-color: #53c797 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-success {\r\n\tborder: 1px solid #53c797;\r\n\tcolor: #53c797;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-success:hover,\r\n.btn-outline-success:focus,\r\n.btn-outline-success:active,\r\n.btn-outline-success.active,\r\n.btn-outline-success.focus,\r\n.btn-outline-success:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #53c797;\r\n\tborder-color: #53c797;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(83, 199, 151, 0.3)\r\n}\r\n\r\n.btn-warning {\r\n\tbackground-color: #f1b561 !important;\r\n\tborder: 1px solid #f1b561 !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(241, 181, 97, 0.3)\r\n}\r\n\r\n.btn-warning:hover,\r\n.btn-warning:focus,\r\n.btn-warning:active,\r\n.btn-warning.active,\r\n.btn-warning.focus {\r\n\tbackground-color: #efaa4a !important;\r\n\tborder-color: #efaa4a !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-warning {\r\n\tbackground-color: rgba(241, 181, 97, 0.1) !important;\r\n\tborder: 1px solid rgba(241, 181, 97, 0.1) !important;\r\n\tcolor: #f1b561 !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(241, 181, 97, 0.3)\r\n}\r\n\r\n.btn-soft-warning:hover,\r\n.btn-soft-warning:focus,\r\n.btn-soft-warning:active,\r\n.btn-soft-warning.active,\r\n.btn-soft-warning.focus {\r\n\tbackground-color: #f1b561 !important;\r\n\tborder-color: #f1b561 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-warning {\r\n\tborder: 1px solid #f1b561;\r\n\tcolor: #f1b561;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-warning:hover,\r\n.btn-outline-warning:focus,\r\n.btn-outline-warning:active,\r\n.btn-outline-warning.active,\r\n.btn-outline-warning.focus,\r\n.btn-outline-warning:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #f1b561;\r\n\tborder-color: #f1b561;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(241, 181, 97, 0.3)\r\n}\r\n\r\n.btn-info {\r\n\tbackground-color: #64c2f1 !important;\r\n\tborder: 1px solid #64c2f1 !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(100, 194, 241, 0.3)\r\n}\r\n\r\n.btn-info:hover,\r\n.btn-info:focus,\r\n.btn-info:active,\r\n.btn-info.active,\r\n.btn-info.focus {\r\n\tbackground-color: #4db9ef !important;\r\n\tborder-color: #4db9ef !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-info {\r\n\tbackground-color: rgba(100, 194, 241, 0.1) !important;\r\n\tborder: 1px solid rgba(100, 194, 241, 0.1) !important;\r\n\tcolor: #64c2f1 !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(100, 194, 241, 0.3)\r\n}\r\n\r\n.btn-soft-info:hover,\r\n.btn-soft-info:focus,\r\n.btn-soft-info:active,\r\n.btn-soft-info.active,\r\n.btn-soft-info.focus {\r\n\tbackground-color: #64c2f1 !important;\r\n\tborder-color: #64c2f1 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-info {\r\n\tborder: 1px solid #64c2f1;\r\n\tcolor: #64c2f1;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-info:hover,\r\n.btn-outline-info:focus,\r\n.btn-outline-info:active,\r\n.btn-outline-info.active,\r\n.btn-outline-info.focus,\r\n.btn-outline-info:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #64c2f1;\r\n\tborder-color: #64c2f1;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(100, 194, 241, 0.3)\r\n}\r\n\r\n.btn-danger {\r\n\tbackground-color: #f0735a !important;\r\n\tborder: 1px solid #f0735a !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(240, 115, 90, 0.3)\r\n}\r\n\r\n.btn-danger:hover,\r\n.btn-danger:focus,\r\n.btn-danger:active,\r\n.btn-danger.active,\r\n.btn-danger.focus {\r\n\tbackground-color: #ee5f43 !important;\r\n\tborder-color: #ee5f43 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-danger {\r\n\tbackground-color: rgba(240, 115, 90, 0.1) !important;\r\n\tborder: 1px solid rgba(240, 115, 90, 0.1) !important;\r\n\tcolor: #f0735a !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(240, 115, 90, 0.3)\r\n}\r\n\r\n.btn-soft-danger:hover,\r\n.btn-soft-danger:focus,\r\n.btn-soft-danger:active,\r\n.btn-soft-danger.active,\r\n.btn-soft-danger.focus {\r\n\tbackground-color: #f0735a !important;\r\n\tborder-color: #f0735a !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-danger {\r\n\tborder: 1px solid #f0735a;\r\n\tcolor: #f0735a;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-danger:hover,\r\n.btn-outline-danger:focus,\r\n.btn-outline-danger:active,\r\n.btn-outline-danger.active,\r\n.btn-outline-danger.focus,\r\n.btn-outline-danger:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #f0735a;\r\n\tborder-color: #f0735a;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(240, 115, 90, 0.3)\r\n}\r\n\r\n.btn-dark {\r\n\tbackground-color: #343a40 !important;\r\n\tborder: 1px solid #343a40 !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(52, 58, 64, 0.3)\r\n}\r\n\r\n.btn-dark:hover,\r\n.btn-dark:focus,\r\n.btn-dark:active,\r\n.btn-dark.active,\r\n.btn-dark.focus {\r\n\tbackground-color: #292d32 !important;\r\n\tborder-color: #292d32 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-dark {\r\n\tbackground-color: rgba(52, 58, 64, 0.1) !important;\r\n\tborder: 1px solid rgba(52, 58, 64, 0.1) !important;\r\n\tcolor: #343a40 !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(52, 58, 64, 0.3)\r\n}\r\n\r\n.btn-soft-dark:hover,\r\n.btn-soft-dark:focus,\r\n.btn-soft-dark:active,\r\n.btn-soft-dark.active,\r\n.btn-soft-dark.focus {\r\n\tbackground-color: #343a40 !important;\r\n\tborder-color: #343a40 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-dark {\r\n\tborder: 1px solid #343a40;\r\n\tcolor: #343a40;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-dark:hover,\r\n.btn-outline-dark:focus,\r\n.btn-outline-dark:active,\r\n.btn-outline-dark.active,\r\n.btn-outline-dark.focus,\r\n.btn-outline-dark:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #343a40;\r\n\tborder-color: #343a40;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(52, 58, 64, 0.3)\r\n}\r\n\r\n.btn-muted {\r\n\tbackground-color: #8492a6 !important;\r\n\tborder: 1px solid #8492a6 !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(132, 146, 166, 0.3)\r\n}\r\n\r\n.btn-muted:hover,\r\n.btn-muted:focus,\r\n.btn-muted:active,\r\n.btn-muted.active,\r\n.btn-muted.focus {\r\n\tbackground-color: #75859b !important;\r\n\tborder-color: #75859b !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-muted {\r\n\tbackground-color: rgba(132, 146, 166, 0.1) !important;\r\n\tborder: 1px solid rgba(132, 146, 166, 0.1) !important;\r\n\tcolor: #8492a6 !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(132, 146, 166, 0.3)\r\n}\r\n\r\n.btn-soft-muted:hover,\r\n.btn-soft-muted:focus,\r\n.btn-soft-muted:active,\r\n.btn-soft-muted.active,\r\n.btn-soft-muted.focus {\r\n\tbackground-color: #8492a6 !important;\r\n\tborder-color: #8492a6 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-muted {\r\n\tborder: 1px solid #8492a6;\r\n\tcolor: #8492a6;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-muted:hover,\r\n.btn-outline-muted:focus,\r\n.btn-outline-muted:active,\r\n.btn-outline-muted.active,\r\n.btn-outline-muted.focus,\r\n.btn-outline-muted:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #8492a6;\r\n\tborder-color: #8492a6;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(132, 146, 166, 0.3)\r\n}\r\n\r\n.btn-light {\r\n\tbackground-color: #f8f9fc !important;\r\n\tborder: 1px solid #f8f9fc !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.3)\r\n}\r\n\r\n.btn-light:hover,\r\n.btn-light:focus,\r\n.btn-light:active,\r\n.btn-light.active,\r\n.btn-light.focus {\r\n\tbackground-color: #e6eaf4 !important;\r\n\tborder-color: #e6eaf4 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-light {\r\n\tbackground-color: rgba(248, 249, 252, 0.1) !important;\r\n\tborder: 1px solid rgba(248, 249, 252, 0.1) !important;\r\n\tcolor: #f8f9fc !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.3)\r\n}\r\n\r\n.btn-soft-light:hover,\r\n.btn-soft-light:focus,\r\n.btn-soft-light:active,\r\n.btn-soft-light.active,\r\n.btn-soft-light.focus {\r\n\tbackground-color: #f8f9fc !important;\r\n\tborder-color: #f8f9fc !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-light {\r\n\tborder: 1px solid #f8f9fc;\r\n\tcolor: #f8f9fc;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-light:hover,\r\n.btn-outline-light:focus,\r\n.btn-outline-light:active,\r\n.btn-outline-light.active,\r\n.btn-outline-light.focus,\r\n.btn-outline-light:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #f8f9fc;\r\n\tborder-color: #f8f9fc;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.3)\r\n}\r\n\r\n.btn-footer {\r\n\tbackground-color: #202942 !important;\r\n\tborder: 1px solid #202942 !important;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(32, 41, 66, 0.3)\r\n}\r\n\r\n.btn-footer:hover,\r\n.btn-footer:focus,\r\n.btn-footer:active,\r\n.btn-footer.active,\r\n.btn-footer.focus {\r\n\tbackground-color: #181e30 !important;\r\n\tborder-color: #181e30 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-soft-footer {\r\n\tbackground-color: rgba(32, 41, 66, 0.1) !important;\r\n\tborder: 1px solid rgba(32, 41, 66, 0.1) !important;\r\n\tcolor: #202942 !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(32, 41, 66, 0.3)\r\n}\r\n\r\n.btn-soft-footer:hover,\r\n.btn-soft-footer:focus,\r\n.btn-soft-footer:active,\r\n.btn-soft-footer.active,\r\n.btn-soft-footer.focus {\r\n\tbackground-color: #202942 !important;\r\n\tborder-color: #202942 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.btn-outline-footer {\r\n\tborder: 1px solid #202942;\r\n\tcolor: #202942;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-footer:hover,\r\n.btn-outline-footer:focus,\r\n.btn-outline-footer:active,\r\n.btn-outline-footer.active,\r\n.btn-outline-footer.focus,\r\n.btn-outline-footer:not(:disabled):not(.disabled):active {\r\n\tbackground-color: #202942;\r\n\tborder-color: #202942;\r\n\tcolor: #fff !important;\r\n\tbox-shadow: 0 3px 5px 0 rgba(32, 41, 66, 0.3)\r\n}\r\n\r\n.btn {\r\n\tpadding: 8px 20px;\r\n\toutline: none;\r\n\ttext-decoration: none;\r\n\tfont-size: 15px;\r\n\tletter-spacing: 0.5px;\r\n\ttransition: all 0.3s;\r\n\tborder-radius: 5px\r\n}\r\n\r\n.btn:focus {\r\n\tbox-shadow: none !important\r\n}\r\n\r\n.btn.btn-sm {\r\n\tpadding: 7px 16px;\r\n\tfont-size: 10px\r\n}\r\n\r\n.btn.btn-lg {\r\n\tpadding: 14px 30px;\r\n\tfont-size: 16px\r\n}\r\n\r\n.btn.btn-pills {\r\n\tborder-radius: 30px\r\n}\r\n\r\n.btn.btn-light {\r\n\tcolor: #343a40 !important;\r\n\tborder: 1px solid #dee2e6 !important\r\n}\r\n\r\n.btn.btn-light:hover,\r\n.btn.btn-light:focus,\r\n.btn.btn-light:active,\r\n.btn.btn-light.active,\r\n.btn.btn-light.focus {\r\n\tbackground-color: #fff !important;\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.btn.btn-soft-light {\r\n\tcolor: rgba(52, 58, 64, 0.5) !important;\r\n\tborder: 1px solid rgba(248, 249, 252, 0.1) !important;\r\n\tbackground-color: rgba(248, 249, 252, 0.1);\r\n\tbox-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.2)\r\n}\r\n\r\n.btn.btn-soft-light:hover,\r\n.btn.btn-soft-light:focus,\r\n.btn.btn-soft-light:active,\r\n.btn.btn-soft-light.active,\r\n.btn.btn-soft-light.focus {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.btn.btn-soft-light-alt {\r\n\tbackground-color: rgba(248, 249, 252, 0.1);\r\n\tcolor: #f8f9fc;\r\n\tborder: 1px solid rgba(248, 249, 252, 0.1);\r\n\tbox-shadow: 0 3px 5px 0 rgba(248, 249, 252, 0.2)\r\n}\r\n\r\n.btn.btn-soft-light-alt:hover,\r\n.btn.btn-soft-light-alt:focus,\r\n.btn.btn-soft-light-alt:active,\r\n.btn.btn-soft-light-alt.active,\r\n.btn.btn-soft-light-alt.focus {\r\n\tbackground: #fff;\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.btn.btn-outline-light {\r\n\tborder: 1px solid #dee2e6 !important;\r\n\tcolor: #343a40 !important;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn.btn-outline-light:hover,\r\n.btn.btn-outline-light:focus,\r\n.btn.btn-outline-light:active,\r\n.btn.btn-outline-light.active,\r\n.btn.btn-outline-light.focus {\r\n\tbackground-color: #f8f9fc !important\r\n}\r\n\r\n.btn.btn-outline-light-alt {\r\n\tborder: 1px solid #dee2e6 !important;\r\n\tcolor: #fff !important;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn.btn-outline-light-alt:hover,\r\n.btn.btn-outline-light-alt:focus,\r\n.btn.btn-outline-light-alt:active,\r\n.btn.btn-outline-light-alt.active,\r\n.btn.btn-outline-light-alt.focus {\r\n\tbackground-color: #f8f9fc !important;\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.btn.btn-icon {\r\n\theight: 36px;\r\n\twidth: 36px;\r\n\tline-height: 34px;\r\n\tpadding: 0\r\n}\r\n\r\n.btn.btn-icon .icons {\r\n\theight: 16px;\r\n\twidth: 16px;\r\n\tfont-size: 16px\r\n}\r\n\r\n.btn.btn-icon.btn-lg {\r\n\theight: 48px;\r\n\twidth: 48px;\r\n\tline-height: 46px\r\n}\r\n\r\n.btn.btn-icon.btn-lg .icons {\r\n\theight: 20px;\r\n\twidth: 20px;\r\n\tfont-size: 20px\r\n}\r\n\r\n.btn.btn-icon.btn-sm {\r\n\theight: 30px;\r\n\twidth: 30px;\r\n\tline-height: 28px\r\n}\r\n\r\nbutton:not(:disabled) {\r\n\toutline: none\r\n}\r\n\r\n.shadow {\r\n\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15) !important\r\n}\r\n\r\n.shadow-lg {\r\n\tbox-shadow: 0 10px 25px rgba(52, 58, 64, 0.15) !important\r\n}\r\n\r\n.shadow-md {\r\n\tbox-shadow: 0 5px 13px rgba(52, 58, 64, 0.2) !important\r\n}\r\n\r\n.badge-primary {\r\n\tbackground-color: #00CCCC !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-primary {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #00CCCC !important;\r\n\tborder: 1px solid #00CCCC !important\r\n}\r\n\r\n.badge-soft-primary {\r\n\tbackground-color: rgba(57, 108, 240, 0.1) !important;\r\n\tborder: 1px solid rgba(57, 108, 240, 0.1) !important;\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.badge-secondary {\r\n\tbackground-color: #5a6d90 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-secondary {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #5a6d90 !important;\r\n\tborder: 1px solid #5a6d90 !important\r\n}\r\n\r\n.badge-soft-secondary {\r\n\tbackground-color: rgba(90, 109, 144, 0.1) !important;\r\n\tborder: 1px solid rgba(90, 109, 144, 0.1) !important;\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.badge-success {\r\n\tbackground-color: #53c797 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-success {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #53c797 !important;\r\n\tborder: 1px solid #53c797 !important\r\n}\r\n\r\n.badge-soft-success {\r\n\tbackground-color: rgba(83, 199, 151, 0.1) !important;\r\n\tborder: 1px solid rgba(83, 199, 151, 0.1) !important;\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.badge-warning {\r\n\tbackground-color: #f1b561 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-warning {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #f1b561 !important;\r\n\tborder: 1px solid #f1b561 !important\r\n}\r\n\r\n.badge-soft-warning {\r\n\tbackground-color: rgba(241, 181, 97, 0.1) !important;\r\n\tborder: 1px solid rgba(241, 181, 97, 0.1) !important;\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.badge-info {\r\n\tbackground-color: #64c2f1 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-info {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #64c2f1 !important;\r\n\tborder: 1px solid #64c2f1 !important\r\n}\r\n\r\n.badge-soft-info {\r\n\tbackground-color: rgba(100, 194, 241, 0.1) !important;\r\n\tborder: 1px solid rgba(100, 194, 241, 0.1) !important;\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.badge-danger {\r\n\tbackground-color: #f0735a !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-danger {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #f0735a !important;\r\n\tborder: 1px solid #f0735a !important\r\n}\r\n\r\n.badge-soft-danger {\r\n\tbackground-color: rgba(240, 115, 90, 0.1) !important;\r\n\tborder: 1px solid rgba(240, 115, 90, 0.1) !important;\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.badge-dark {\r\n\tbackground-color: #343a40 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-dark {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #343a40 !important;\r\n\tborder: 1px solid #343a40 !important\r\n}\r\n\r\n.badge-soft-dark {\r\n\tbackground-color: rgba(52, 58, 64, 0.1) !important;\r\n\tborder: 1px solid rgba(52, 58, 64, 0.1) !important;\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.badge-muted {\r\n\tbackground-color: #8492a6 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-muted {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #8492a6 !important;\r\n\tborder: 1px solid #8492a6 !important\r\n}\r\n\r\n.badge-soft-muted {\r\n\tbackground-color: rgba(132, 146, 166, 0.1) !important;\r\n\tborder: 1px solid rgba(132, 146, 166, 0.1) !important;\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.badge-light {\r\n\tbackground-color: #f8f9fc !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-light {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #f8f9fc !important;\r\n\tborder: 1px solid #f8f9fc !important\r\n}\r\n\r\n.badge-soft-light {\r\n\tbackground-color: rgba(248, 249, 252, 0.1) !important;\r\n\tborder: 1px solid rgba(248, 249, 252, 0.1) !important;\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.badge-footer {\r\n\tbackground-color: #202942 !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.badge-outline-footer {\r\n\tbackground-color: transparent !important;\r\n\tcolor: #202942 !important;\r\n\tborder: 1px solid #202942 !important\r\n}\r\n\r\n.badge-soft-footer {\r\n\tbackground-color: rgba(32, 41, 66, 0.1) !important;\r\n\tborder: 1px solid rgba(32, 41, 66, 0.1) !important;\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.badge {\r\n\tdisplay: inline-block;\r\n\tletter-spacing: 0.5px;\r\n\tpadding: 4px 8px;\r\n\tfont-weight: 600;\r\n\tline-height: 1;\r\n\ttext-align: center\r\n}\r\n\r\n.badge.badge-light {\r\n\tcolor: #343a40 !important;\r\n\tbackground-color: #f8f9fc !important\r\n}\r\n\r\n.badge.badge-outline-light {\r\n\tcolor: #343a40 !important;\r\n\tborder: 1px solid #fff !important;\r\n\tbackground-color: transparent !important\r\n}\r\n\r\n.badge.badge-pill {\r\n\tborder-radius: 12px\r\n}\r\n\r\n.badge:focus,\r\n.badge.focus {\r\n\tbox-shadow: none !important\r\n}\r\n\r\n.dropdown-primary .dropdown-menu .dropdown-item:hover,\r\n.dropdown-primary .dropdown-menu .dropdown-item.active,\r\n.dropdown-primary .dropdown-menu .dropdown-item:active,\r\n.dropdown-primary .dropdown-menu .dropdown-item.focus,\r\n.dropdown-primary .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.dropdown-secondary .dropdown-menu .dropdown-item:hover,\r\n.dropdown-secondary .dropdown-menu .dropdown-item.active,\r\n.dropdown-secondary .dropdown-menu .dropdown-item:active,\r\n.dropdown-secondary .dropdown-menu .dropdown-item.focus,\r\n.dropdown-secondary .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.dropdown-success .dropdown-menu .dropdown-item:hover,\r\n.dropdown-success .dropdown-menu .dropdown-item.active,\r\n.dropdown-success .dropdown-menu .dropdown-item:active,\r\n.dropdown-success .dropdown-menu .dropdown-item.focus,\r\n.dropdown-success .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.dropdown-warning .dropdown-menu .dropdown-item:hover,\r\n.dropdown-warning .dropdown-menu .dropdown-item.active,\r\n.dropdown-warning .dropdown-menu .dropdown-item:active,\r\n.dropdown-warning .dropdown-menu .dropdown-item.focus,\r\n.dropdown-warning .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.dropdown-info .dropdown-menu .dropdown-item:hover,\r\n.dropdown-info .dropdown-menu .dropdown-item.active,\r\n.dropdown-info .dropdown-menu .dropdown-item:active,\r\n.dropdown-info .dropdown-menu .dropdown-item.focus,\r\n.dropdown-info .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.dropdown-danger .dropdown-menu .dropdown-item:hover,\r\n.dropdown-danger .dropdown-menu .dropdown-item.active,\r\n.dropdown-danger .dropdown-menu .dropdown-item:active,\r\n.dropdown-danger .dropdown-menu .dropdown-item.focus,\r\n.dropdown-danger .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.dropdown-dark .dropdown-menu .dropdown-item:hover,\r\n.dropdown-dark .dropdown-menu .dropdown-item.active,\r\n.dropdown-dark .dropdown-menu .dropdown-item:active,\r\n.dropdown-dark .dropdown-menu .dropdown-item.focus,\r\n.dropdown-dark .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.dropdown-muted .dropdown-menu .dropdown-item:hover,\r\n.dropdown-muted .dropdown-menu .dropdown-item.active,\r\n.dropdown-muted .dropdown-menu .dropdown-item:active,\r\n.dropdown-muted .dropdown-menu .dropdown-item.focus,\r\n.dropdown-muted .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.dropdown-light .dropdown-menu .dropdown-item:hover,\r\n.dropdown-light .dropdown-menu .dropdown-item.active,\r\n.dropdown-light .dropdown-menu .dropdown-item:active,\r\n.dropdown-light .dropdown-menu .dropdown-item.focus,\r\n.dropdown-light .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.dropdown-footer .dropdown-menu .dropdown-item:hover,\r\n.dropdown-footer .dropdown-menu .dropdown-item.active,\r\n.dropdown-footer .dropdown-menu .dropdown-item:active,\r\n.dropdown-footer .dropdown-menu .dropdown-item.focus,\r\n.dropdown-footer .dropdown-menu .dropdown-item:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.dropdown-menu {\r\n\tmargin-top: 10px;\r\n\tborder: 0;\r\n\tborder-radius: 5px;\r\n\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15);\r\n\t/* top: 2px !important */\r\n}\r\n\r\n.dropdown-menu .dropdown-item {\r\n\tpadding: 5px 20px;\r\n\tclear: both;\r\n\twhite-space: nowrap;\r\n\tfont-size: 11px;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.04em;\r\n\tfont-weight: 600\r\n}\r\n\r\n.dropdown .dropdown-toggle:after {\r\n\tdisplay: none !important\r\n}\r\n\r\n.alert-primary {\r\n\tbackground-color: rgba(57, 108, 240, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #00CCCC\r\n}\r\n\r\n.alert-primary .alert-link {\r\n\tcolor: #0a2d86\r\n}\r\n\r\n.alert-outline-primary {\r\n\tbackground-color: transparent;\r\n\tcolor: #00CCCC;\r\n\tborder-color: #00CCCC\r\n}\r\n\r\n.alert-secondary {\r\n\tbackground-color: rgba(90, 109, 144, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #5a6d90\r\n}\r\n\r\n.alert-secondary .alert-link {\r\n\tcolor: #1f2632\r\n}\r\n\r\n.alert-outline-secondary {\r\n\tbackground-color: transparent;\r\n\tcolor: #5a6d90;\r\n\tborder-color: #5a6d90\r\n}\r\n\r\n.alert-success {\r\n\tbackground-color: rgba(83, 199, 151, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #53c797\r\n}\r\n\r\n.alert-success .alert-link {\r\n\tcolor: #206146\r\n}\r\n\r\n.alert-outline-success {\r\n\tbackground-color: transparent;\r\n\tcolor: #53c797;\r\n\tborder-color: #53c797\r\n}\r\n\r\n.alert-warning {\r\n\tbackground-color: rgba(241, 181, 97, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #f1b561\r\n}\r\n\r\n.alert-warning .alert-link {\r\n\tcolor: #aa690f\r\n}\r\n\r\n.alert-outline-warning {\r\n\tbackground-color: transparent;\r\n\tcolor: #f1b561;\r\n\tborder-color: #f1b561\r\n}\r\n\r\n.alert-info {\r\n\tbackground-color: rgba(100, 194, 241, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #64c2f1\r\n}\r\n\r\n.alert-info .alert-link {\r\n\tcolor: #1078ac\r\n}\r\n\r\n.alert-outline-info {\r\n\tbackground-color: transparent;\r\n\tcolor: #64c2f1;\r\n\tborder-color: #64c2f1\r\n}\r\n\r\n.alert-danger {\r\n\tbackground-color: rgba(240, 115, 90, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #f0735a\r\n}\r\n\r\n.alert-danger .alert-link {\r\n\tcolor: #a2270f\r\n}\r\n\r\n.alert-outline-danger {\r\n\tbackground-color: transparent;\r\n\tcolor: #f0735a;\r\n\tborder-color: #f0735a\r\n}\r\n\r\n.alert-dark {\r\n\tbackground-color: rgba(52, 58, 64, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #343a40\r\n}\r\n\r\n.alert-dark .alert-link {\r\n\tcolor: #000\r\n}\r\n\r\n.alert-outline-dark {\r\n\tbackground-color: transparent;\r\n\tcolor: #343a40;\r\n\tborder-color: #343a40\r\n}\r\n\r\n.alert-muted {\r\n\tbackground-color: rgba(132, 146, 166, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #8492a6\r\n}\r\n\r\n.alert-muted .alert-link {\r\n\tcolor: #3d4654\r\n}\r\n\r\n.alert-outline-muted {\r\n\tbackground-color: transparent;\r\n\tcolor: #8492a6;\r\n\tborder-color: #8492a6\r\n}\r\n\r\n.alert-light {\r\n\tbackground-color: rgba(248, 249, 252, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #f8f9fc\r\n}\r\n\r\n.alert-light .alert-link {\r\n\tcolor: #8d9dce\r\n}\r\n\r\n.alert-outline-light {\r\n\tbackground-color: transparent;\r\n\tcolor: #f8f9fc;\r\n\tborder-color: #f8f9fc\r\n}\r\n\r\n.alert-footer {\r\n\tbackground-color: rgba(32, 41, 66, 0.9);\r\n\tcolor: #fff;\r\n\tborder-color: #202942\r\n}\r\n\r\n.alert-footer .alert-link {\r\n\tcolor: #000\r\n}\r\n\r\n.alert-outline-footer {\r\n\tbackground-color: transparent;\r\n\tcolor: #202942;\r\n\tborder-color: #202942\r\n}\r\n\r\n.alert {\r\n\tpadding: 8px 15px;\r\n\tborder-radius: 5px;\r\n\tfont-size: 14px\r\n}\r\n\r\n.alert.alert-light {\r\n\tbackground-color: #fff;\r\n\tcolor: #343a40;\r\n\tborder-color: #e9ecef\r\n}\r\n\r\n.alert.alert-dismissible {\r\n\tpadding-right: 30px\r\n}\r\n\r\n.alert.alert-dismissible .close {\r\n\ttop: -2px;\r\n\tright: -10px;\r\n\tfont-size: 16px !important\r\n}\r\n\r\n.alert.alert-pills {\r\n\tborder-radius: 30px;\r\n\tdisplay: inline-block\r\n}\r\n\r\n.alert.alert-pills .content {\r\n\tfont-weight: 600\r\n}\r\n\r\n.breadcrumb {\r\n\tletter-spacing: 0.5px;\r\n\tpadding: 8px 24px;\r\n\tdisplay: block\r\n}\r\n\r\n.breadcrumb .breadcrumb-item {\r\n\ttext-transform: uppercase;\r\n\tfont-size: 12px;\r\n\tfont-weight: 500;\r\n\tpadding-left: 0;\r\n\tdisplay: inline-block\r\n}\r\n\r\n.breadcrumb .breadcrumb-item a {\r\n\tcolor: #343a40\r\n}\r\n\r\n.breadcrumb .breadcrumb-item a:hover {\r\n\tcolor: #00CCCC\r\n}\r\n\r\n.breadcrumb .breadcrumb-item.active {\r\n\tcolor: #00CCCC\r\n}\r\n\r\n.breadcrumb .breadcrumb-item:before {\r\n\tcontent: \"\"\r\n}\r\n\r\n.breadcrumb .breadcrumb-item:after {\r\n\tcontent: \"\\F0142\" !important;\r\n\tcolor: #343a40;\r\n\tfont-family: 'Material Design Icons';\r\n\tpadding-left: 5px\r\n}\r\n\r\n.breadcrumb .breadcrumb-item:last-child:after {\r\n\tdisplay: none\r\n}\r\n\r\n.pagination .page-item:first-child .page-link {\r\n\tborder-top-left-radius: 5px;\r\n\tborder-bottom-left-radius: 5px\r\n}\r\n\r\n.pagination .page-item:last-child .page-link {\r\n\tborder-top-right-radius: 5px;\r\n\tborder-bottom-right-radius: 5px\r\n}\r\n\r\n.pagination .page-item .page-link {\r\n\tcolor: #343a40;\r\n\tborder: 1px solid #dee2e6;\r\n\tpadding: 8px 16px;\r\n\tfont-size: 14px\r\n}\r\n\r\n.pagination .page-item .page-link:focus {\r\n\tbox-shadow: none\r\n}\r\n\r\n.pagination .page-item .page-link:hover {\r\n\tcolor: #fff;\r\n\tbackground: #00CCCC;\r\n\tborder-color: #00CCCC;\r\n}\r\n\r\n.pagination .page-item.active .page-link {\r\n\tcolor: #fff;\r\n\tbackground: #00CCCC !important;\r\n\tborder-color: #00CCCC;\r\n\tcursor: not-allowed\r\n}\r\n\r\n#preloader {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tbackground-image: linear-gradient(45deg, #fff, #fff);\r\n\tz-index: 9999999\r\n}\r\n\r\n#preloader #status {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\tright: 0;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%)\r\n}\r\n\r\n#preloader #status .spinner {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tposition: relative;\r\n\tmargin: 100px auto\r\n}\r\n\r\n#preloader #status .spinner .double-bounce1,\r\n#preloader #status .spinner .double-bounce2 {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder-radius: 50%;\r\n\tbackground-color: #00CCCC;\r\n\topacity: 0.6;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tanimation: sk-bounce 2s infinite ease-in-out\r\n}\r\n\r\n#preloader #status .spinner .double-bounce2 {\r\n\tanimation-delay: -1s\r\n}\r\n\r\n@keyframes sk-bounce {\r\n\r\n\t0%,\r\n\t100% {\r\n\t\ttransform: scale(0)\r\n\t}\r\n\r\n\t50% {\r\n\t\ttransform: scale(1)\r\n\t}\r\n}\r\n\r\n.avatar.avatar-ex-sm {\r\n\theight: 30px;\r\n\twidth: 30px\r\n}\r\n\r\n.avatar.avatar-ex-small {\r\n\theight: 40px;\r\n\twidth: 40px\r\n}\r\n\r\n.avatar.avatar-md-sm {\r\n\theight: 45px;\r\n\twidth: 45px\r\n}\r\n\r\n.avatar.avatar-small {\r\n\theight: 65px;\r\n\twidth: 65px\r\n}\r\n\r\n.avatar.avatar-md-md {\r\n\theight: 80px;\r\n\twidth: 80px\r\n}\r\n\r\n.avatar.avatar-medium {\r\n\theight: 110px;\r\n\twidth: 110px\r\n}\r\n\r\n.avatar.avatar-large {\r\n\theight: 140px;\r\n\twidth: 140px\r\n}\r\n\r\n.avatar.avatar-ex-large {\r\n\theight: 180px;\r\n\twidth: 180px\r\n}\r\n\r\n.avatar.avatar-client {\r\n\tmax-height: 25px\r\n}\r\n\r\n.accordion .accordion-item {\r\n\toverflow: hidden;\r\n\tbackground: transparent\r\n}\r\n\r\n.accordion .accordion-item .accordion-button {\r\n\tfont-weight: 600;\r\n\ttext-align: left;\r\n\tbox-shadow: none;\r\n\tpadding: 1rem 2.5rem 1rem 1.25rem\r\n}\r\n\r\n.accordion .accordion-item .accordion-button:focus {\r\n\tbox-shadow: none\r\n}\r\n\r\n.accordion .accordion-item .accordion-button:before {\r\n\tcontent: '\\F0143';\r\n\tdisplay: block;\r\n\tfont-family: 'Material Design Icons';\r\n\tfont-size: 16px;\r\n\tcolor: #00CCCC;\r\n\tposition: absolute;\r\n\tright: 20px;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n.accordion .accordion-item .accordion-button.collapsed {\r\n\tbackground-color: #fff;\r\n\tcolor: #343a40 !important;\r\n\ttransition: all 0.5s\r\n}\r\n\r\n.accordion .accordion-item .accordion-button.collapsed:before {\r\n\ttop: 15px;\r\n\ttransform: rotate(180deg);\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.accordion .accordion-item .accordion-button:after {\r\n\tdisplay: none\r\n}\r\n\r\n.nav-pills {\r\n\tmargin-bottom: 15px;\r\n\tbackground: #f4f6fa\r\n}\r\n\r\n.nav-pills .nav-link {\r\n\tcolor: #495057 !important;\r\n\tpadding: 5px;\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n.nav-pills .nav-link.nav-link-alt.active {\r\n\tbackground: #343a40;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.nav-pills .nav-link.active {\r\n\tbackground: #00CCCC;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.nav-pills .nav-link.active .tab-para {\r\n\tcolor: rgba(255, 255, 255, 0.65) !important\r\n}\r\n\r\n.nav-pills a .title {\r\n\tfont-size: 17px !important\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link,\r\n.nav-tabs .nav-link.active {\r\n\tcolor: #00CCCC !important;\r\n\tborder-color: transparent transparent #00CCCC !important\r\n}\r\n\r\n.nav-tabs .nav-link:focus,\r\n.nav-tabs .nav-link:hover {\r\n\tborder-color: transparent\r\n}\r\n\r\n.progress-box .title {\r\n\tfont-size: 15px\r\n}\r\n\r\n.progress-box .progress {\r\n\theight: 8px;\r\n\toverflow: visible\r\n}\r\n\r\n.progress-box .progress .progress-bar {\r\n\tborder-radius: 5px;\r\n\toverflow: visible !important\r\n}\r\n\r\n.progress-box .progress .progress-value {\r\n\tposition: absolute;\r\n\ttop: -28px;\r\n\tright: -15px;\r\n\tfont-size: 14px\r\n}\r\n\r\n.blockquote {\r\n\tborder-left: 3px solid #dee2e6;\r\n\tborder-radius: 5px;\r\n\tfont-size: 16px\r\n}\r\n\r\n.form-label {\r\n\tfont-weight: 500\r\n}\r\n\r\n.form-control {\r\n\tborder: 1px solid #e9ecef;\r\n\tfont-size: 14px;\r\n\tline-height: 26px;\r\n\tbackground-color: #fff\r\n}\r\n\r\n.form-control:focus {\r\n\tborder-color: #00CCCC;\r\n\tbox-shadow: none\r\n}\r\n\r\n.form-control[readonly] {\r\n\tbackground-color: #fff\r\n}\r\n\r\n.form-control:disabled {\r\n\tbackground-color: #e9ecef\r\n}\r\n\r\n.form-control::placeholder {\r\n\tcolor: #343a40\r\n}\r\n\r\n.form-check-input:focus {\r\n\tborder-color: #00CCCC;\r\n\tbox-shadow: none\r\n}\r\n\r\n.select2-container {\r\n\tdisplay: block !important;\r\n\twidth: 100% !important\r\n}\r\n\r\n.select2-container--default .select2-selection--single {\r\n\tbackground-color: #fff !important;\r\n\tborder: 1px solid #dee2e6 !important;\r\n\tborder-radius: 5px !important;\r\n\theight: 40px !important;\r\n\ttext-align: left\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tcolor: #343a40 !important;\r\n\tline-height: 40px !important;\r\n\tfont-size: 13px !important\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: #343a40 transparent transparent transparent;\r\n\ttop: 20px\r\n}\r\n\r\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: transparent transparent #343a40 transparent\r\n}\r\n\r\n.select2-container--default .select2-search--dropdown .select2-search__field {\r\n\tborder: 1px solid #dee2e6;\r\n\tborder-radius: 5px\r\n}\r\n\r\n.select2-container--default .select2-search--dropdown .select2-search__field:focus {\r\n\toutline: none;\r\n\tborder-color: #00CCCC !important\r\n}\r\n\r\n.select2-container--default .select2-results__option--selected {\r\n\tbackground-color: #00CCCC !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.select2-container--default .select2-results__option--highlighted.select2-results__option--selectable {\r\n\tbackground-color: #00CCCC !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.select2-selection:focus,\r\n.select2-selection:active {\r\n\toutline: none;\r\n\tborder-color: #00CCCC !important\r\n}\r\n\r\n.select2-results__option {\r\n\tcolor: #8492a6\r\n}\r\n\r\n.select2-dropdown {\r\n\tborder: 1px solid #dee2e6 !important;\r\n\tborder-radius: 5px !important\r\n}\r\n\r\n.apexcharts-tooltip {\r\n\tbackground: #fff !important;\r\n\tcolor: #343a40;\r\n\tborder-color: #e9ecef !important\r\n}\r\n\r\n.apexcharts-gridlines-horizontal,\r\n.apexcharts-gridlines-vertical,\r\n.apexcharts-grid,\r\n.apexcharts-gridline,\r\n.apexcharts-xaxis-tick,\r\n.apexcharts-xaxis line,\r\n.apexcharts-gridline line,\r\n.apexcharts-radar-series line,\r\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\r\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\r\n.apexcharts-radar-series path,\r\n.apexcharts-radar-series polygon {\r\n\tpointer-events: none;\r\n\tstroke: #e9ecef\r\n}\r\n\r\n.apexcharts-tooltip-title {\r\n\tbackground: #fff !important;\r\n\tcolor: #343a40;\r\n\tborder-color: #e9ecef !important\r\n}\r\n\r\n.apexcharts-data-labels,\r\n.apexcharts-datalabels text,\r\n.apexcharts-xaxis text,\r\n.apexcharts-yaxis text {\r\n\tfill: #343a40 !important\r\n}\r\n\r\n.apexcharts-legend-text {\r\n\tcolor: #343a40 !important;\r\n\tfont-family: \"Inter\", sans-serif !important\r\n}\r\n\r\n.map {\r\n\tline-height: 0\r\n}\r\n\r\n.map iframe {\r\n\twidth: 100%;\r\n\theight: 400px\r\n}\r\n\r\n.subcribe-form .btn {\r\n\tpadding: 10px 20px\r\n}\r\n\r\n.subcribe-form input {\r\n\tpadding: 12px 20px;\r\n\twidth: 100%;\r\n\tcolor: #343a40 !important;\r\n\tborder: none;\r\n\toutline: none !important;\r\n\tpadding-right: 160px;\r\n\tpadding-left: 20px;\r\n\tbackground-color: rgba(255, 255, 255, 0.8)\r\n}\r\n\r\n.subcribe-form button {\r\n\tposition: absolute;\r\n\ttop: 1.5px;\r\n\tright: 2px;\r\n\toutline: none !important\r\n}\r\n\r\n.subcribe-form form {\r\n\tposition: relative;\r\n\tmax-width: 600px;\r\n\tmargin: 0px auto\r\n}\r\n\r\n.table-responsive {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\toverflow-x: auto;\r\n\t-webkit-overflow-scrolling: touch\r\n}\r\n\r\n.table-responsive .table tr td {\r\n\tborder-color: #ffffff;\r\n\tvertical-align: middle;\r\n\tpadding: 12px 16px !important;\r\n\tfont-size: 14px;\r\n\tcolor: #3F3F46;\r\n}\r\n\r\n.table-responsive .table th {\r\n\tvertical-align: middle;\r\n\tborder-color: #f2f4f6;\r\n\tpadding: 12px 16px;\r\n}\r\n\r\n.table-responsive .table-center th {\r\n\tvertical-align: middle !important;\r\n\tcursor: pointer;\r\n\tfont-weight: 600;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.table-responsive .table-center.invoice-tb th,\r\n.table-responsive .table-center.invoice-tb td {\r\n\ttext-align: end\r\n}\r\n\r\n.table-responsive .table-padding tr td {\r\n\tpadding-top: 20px;\r\n\tpadding-bottom: 20px\r\n}\r\n\r\n.social-icon li a {\r\n\tcolor: #343a40;\r\n\tborder: 1px solid #343a40;\r\n\tdisplay: inline-block;\r\n\theight: 32px;\r\n\twidth: 32px;\r\n\tline-height: 30px;\r\n\ttext-align: center;\r\n\ttransition: all 0.4s ease;\r\n\toverflow: hidden;\r\n\tposition: relative\r\n}\r\n\r\n.social-icon li a .fea-social {\r\n\tstroke-width: 2\r\n}\r\n\r\n.social-icon li a:hover {\r\n\tbackground-color: #00CCCC !important;\r\n\tborder-color: #00CCCC !important;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.social-icon li a:hover .fea-social {\r\n\tfill: #00CCCC\r\n}\r\n\r\n.social-icon.footer-social li a {\r\n\tborder: none;\r\n\tcolor: #adb5bd;\r\n\tbackground-color: #2c385a\r\n}\r\n\r\n.social-icon.social li a {\r\n\tcolor: #adb5bd;\r\n\tborder-color: #adb5bd\r\n}\r\n\r\n.home-shape-arrow {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: -24px;\r\n\tz-index: 1;\r\n\ttext-align: center\r\n}\r\n\r\n.back-to-top {\r\n\tposition: fixed;\r\n\tbottom: 16px;\r\n\tright: 16px;\r\n\tz-index: 99;\r\n\tdisplay: none\r\n}\r\n\r\n.back-to-home {\r\n\tposition: fixed;\r\n\ttop: 4%;\r\n\tright: 2%;\r\n\tz-index: 1\r\n}\r\n\r\n.sticky-bar {\r\n\tposition: sticky;\r\n\ttop: 80px\r\n}\r\n\r\n.fea {\r\n\tstroke-width: 1.8\r\n}\r\n\r\n.fea.icon-sm {\r\n\theight: 16px;\r\n\twidth: 16px\r\n}\r\n\r\n.fea.icon-ex-md {\r\n\theight: 20px;\r\n\twidth: 20px\r\n}\r\n\r\n.fea.icon-m-md {\r\n\theight: 28px;\r\n\twidth: 28px\r\n}\r\n\r\n.fea.icon-md {\r\n\theight: 35px;\r\n\twidth: 35px\r\n}\r\n\r\n.fea.icon-lg {\r\n\theight: 42px;\r\n\twidth: 42px\r\n}\r\n\r\n.fea.icon-ex-lg {\r\n\theight: 52px;\r\n\twidth: 52px\r\n}\r\n\r\n[class^=\"uil-\"]:before,\r\n[class*=\" uil-\"]:before {\r\n\tmargin: 0\r\n}\r\n\r\n.uim-svg {\r\n\tvertical-align: 0 !important\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.display-1 {\r\n\t\tfont-size: 56px !important\r\n\t}\r\n\r\n\t.display-2 {\r\n\t\tfont-size: 50px !important\r\n\t}\r\n\r\n\t.display-3 {\r\n\t\tfont-size: 42px !important\r\n\t}\r\n\r\n\t.display-4 {\r\n\t\tfont-size: 36px !important\r\n\t}\r\n}\r\n\r\nbody {\r\n\tbackground: #f8f9fc;\r\n\tfont-family: \"Inter\", sans-serif;\r\n\toverflow-x: hidden !important;\r\n\tfont-size: 16px;\r\n\tcolor: #201E29;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n\tfont-family: \"Inter\", sans-serif\r\n}\r\n\r\n::selection {\r\n\tbackground: rgba(57, 108, 240, 0.9);\r\n\tcolor: #fff\r\n}\r\n\r\na {\r\n\ttext-decoration: none !important\r\n}\r\n\r\np {\r\n\tline-height: 1.6;\r\n\tcolor: #93969F;\r\n}\r\n\r\n#style-switcher .t-dark,\r\n#style-switcher .t-rtl-light {\r\n\tdisplay: inline-block\r\n}\r\n\r\n#style-switcher .t-ltr-light,\r\n#style-switcher .t-light,\r\n#style-switcher .t-rtl-dark,\r\n#style-switcher .t-ltr-dark {\r\n\tdisplay: none\r\n}\r\n\r\n.section {\r\n\tpadding: 100px 0;\r\n\tposition: relative\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.section {\r\n\t\tpadding: 60px 0\r\n\t}\r\n}\r\n\r\n.bg-overlay {\r\n\tbackground-color: rgba(52, 58, 64, 0.75);\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\twidth: 100%;\r\n\theight: 100%\r\n}\r\n\r\n.heading-title {\r\n\tline-height: 26px\r\n}\r\n\r\n.heading-title .heading {\r\n\tfont-size: 42px !important;\r\n\tletter-spacing: 1px\r\n}\r\n\r\n.heading-title .title {\r\n\tfont-size: 32px !important;\r\n\tletter-spacing: 1px\r\n}\r\n\r\n.heading-title .para-desc {\r\n\tfont-size: 17px\r\n}\r\n\r\n.section-title {\r\n\tposition: relative\r\n}\r\n\r\n.section-title .title {\r\n\tletter-spacing: 0.5px;\r\n\tfont-size: 24px !important\r\n}\r\n\r\n.section-title .sub-title {\r\n\tletter-spacing: 0.5px;\r\n\tfont-size: 28px !important\r\n}\r\n\r\n.para-desc {\r\n\tmax-width: 600px\r\n}\r\n\r\n.mt-100 {\r\n\tmargin-top: 100px\r\n}\r\n\r\n.shape {\r\n\tposition: absolute;\r\n\tpointer-events: none;\r\n\tright: 0;\r\n\tbottom: -2px;\r\n\tleft: 0\r\n}\r\n\r\n.shape>svg {\r\n\ttransform: scale(2);\r\n\twidth: 100%;\r\n\theight: auto;\r\n\ttransform-origin: top center\r\n}\r\n\r\n.shape.integration-hero {\r\n\tclip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n\theight: 250px;\r\n\tbackground: #fff\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.shape.integration-hero {\r\n\t\theight: 140px\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.shape.integration-hero {\r\n\t\theight: 60px\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.shape {\r\n\t\tbottom: -4px\r\n\t}\r\n}\r\n\r\n.features-absolute {\r\n\tposition: relative;\r\n\tmargin: -200px 0 0px;\r\n\tz-index: 2;\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.features-absolute {\r\n\t\tmargin: -140px 0 0\r\n\t}\r\n}\r\n\r\n.features-absolute.career-form {\r\n\tmargin: -145px 0 0px\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.features-absolute.career-form {\r\n\t\tmargin: -105px 0 0px\r\n\t}\r\n}\r\n\r\n.feature-posts-placeholder {\r\n\tposition: absolute;\r\n\tbottom: 0px;\r\n\tleft: 0;\r\n\tright: 0;\r\n\theight: 66.6%\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.feature-posts-placeholder {\r\n\t\theight: 80%\r\n\t}\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.heading-title .heading {\r\n\t\tfont-size: 36px !important\r\n\t}\r\n\r\n\t.heading-title .para-desc {\r\n\t\tfont-size: 18px\r\n\t}\r\n\r\n\t.section-title .title {\r\n\t\tfont-size: 24px !important\r\n\t}\r\n\r\n\t.mt-60 {\r\n\t\tmargin-top: 60px\r\n\t}\r\n}\r\n\r\n#topnav {\r\n\tposition: fixed;\r\n\tright: 0;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tz-index: 1030;\r\n\tbackground-color: transparent;\r\n\tborder: 0;\r\n\ttransition: all .5s ease\r\n}\r\n\r\n#topnav .logo {\r\n\tfloat: left;\r\n\tcolor: #343a40 !important;\r\n\toutline: none\r\n}\r\n\r\n#topnav .logo .l-dark,\r\n#topnav .logo .logo-dark-mode {\r\n\tdisplay: none\r\n}\r\n\r\n#topnav .logo .l-light,\r\n#topnav .logo .logo-light-mode {\r\n\tdisplay: inline-block\r\n}\r\n\r\n#topnav .has-submenu.active a {\r\n\tcolor: #fff\r\n}\r\n\r\n#topnav .has-submenu.active .submenu li.active>a {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n#topnav .has-submenu.active.active .menu-arrow {\r\n\tborder-color: #00CCCC\r\n}\r\n\r\n#topnav .has-submenu {\r\n\tposition: relative\r\n}\r\n\r\n#topnav .has-submenu .submenu .submenu-arrow {\r\n\tborder: solid #343a40;\r\n\tborder-radius: 0.5px;\r\n\tborder-width: 0 2px 2px 0;\r\n\tdisplay: inline-block;\r\n\tpadding: 2px;\r\n\ttransform: rotate(-45deg);\r\n\tposition: absolute;\r\n\tright: 20px;\r\n\ttop: 14px\r\n}\r\n\r\n#topnav .has-submenu .submenu .has-submenu:hover .submenu-arrow,\r\n#topnav .has-submenu .submenu .has-submenu.active .submenu-arrow {\r\n\tborder-color: #00CCCC\r\n}\r\n\r\n#topnav .navbar-toggle {\r\n\tborder: 0;\r\n\tposition: relative;\r\n\twidth: 60px;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tcursor: pointer\r\n}\r\n\r\n#topnav .navbar-toggle .lines {\r\n\twidth: 25px;\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\tmargin: 30px 10px 26px;\r\n\theight: 18px\r\n}\r\n\r\n#topnav .navbar-toggle span {\r\n\theight: 2px;\r\n\twidth: 100%;\r\n\tbackground-color: #343a40;\r\n\tdisplay: block;\r\n\tmargin-bottom: 5px;\r\n\ttransition: transform .5s ease\r\n}\r\n\r\n#topnav .navbar-toggle span:last-child {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n#topnav .dropdowns {\r\n\tfloat: right;\r\n\tline-height: 68px;\r\n\tpadding: 2.5px 0\r\n}\r\n\r\n#topnav .dropdowns>li {\r\n\tline-height: initial\r\n}\r\n\r\n#topnav .dropdowns .login-btn-primary {\r\n\tdisplay: none\r\n}\r\n\r\n#topnav .dropdowns .login-btn-light {\r\n\tdisplay: inline-block\r\n}\r\n\r\n#topnav .navbar-toggle.open span {\r\n\tposition: absolute\r\n}\r\n\r\n#topnav .navbar-toggle.open span:first-child {\r\n\ttop: 6px;\r\n\ttransform: rotate(45deg)\r\n}\r\n\r\n#topnav .navbar-toggle.open span:nth-child(2) {\r\n\tvisibility: hidden\r\n}\r\n\r\n#topnav .navbar-toggle.open span:last-child {\r\n\twidth: 100%;\r\n\ttop: 6px;\r\n\ttransform: rotate(-45deg)\r\n}\r\n\r\n#topnav .navbar-toggle.open span:hover {\r\n\tbackground-color: #00CCCC\r\n}\r\n\r\n#topnav .navbar-toggle:hover,\r\n#topnav .navbar-toggle:focus,\r\n#topnav .navbar-toggle .navigation-menu>li>a:hover,\r\n#topnav .navbar-toggle:focus {\r\n\tbackground-color: transparent\r\n}\r\n\r\n#topnav .navigation-menu {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0\r\n}\r\n\r\n#topnav .navigation-menu>li {\r\n\tfloat: left;\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\tmargin: 0 10px\r\n}\r\n\r\n#topnav .navigation-menu>li:hover>a,\r\n#topnav .navigation-menu>li.active>a {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n#topnav .navigation-menu>li>a {\r\n\tdisplay: block;\r\n\tcolor: #343a40;\r\n\tfont-size: 13px;\r\n\tbackground-color: transparent !important;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 1px;\r\n\tline-height: 24px;\r\n\ttext-transform: uppercase;\r\n\ttransition: all 0.5s;\r\n\tfont-family: \"Inter\", sans-serif;\r\n\tpadding-left: 15px;\r\n\tpadding-right: 15px\r\n}\r\n\r\n#topnav .navigation-menu>li>a:hover,\r\n#topnav .navigation-menu>li>a:active {\r\n\tcolor: #00CCCC\r\n}\r\n\r\n#topnav .navigation-menu .has-submenu .menu-arrow {\r\n\tborder: solid #343a40;\r\n\tborder-radius: 0.5px;\r\n\tborder-width: 0 2px 2px 0;\r\n\tdisplay: inline-block;\r\n\tpadding: 2px;\r\n\ttransform: rotate(45deg);\r\n\tposition: absolute;\r\n\ttransition: all 0.5s;\r\n\tright: -1px;\r\n\ttop: 32px\r\n}\r\n\r\n#topnav .navigation-menu .has-submenu:hover .menu-arrow {\r\n\ttransform: rotate(225deg)\r\n}\r\n\r\n#topnav .menu-extras {\r\n\tfloat: right\r\n}\r\n\r\n#topnav.scroll {\r\n\tbackground-color: #fff;\r\n\tborder: none;\r\n\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15)\r\n}\r\n\r\n#topnav.scroll .navigation-menu>li>a {\r\n\tcolor: #343a40\r\n}\r\n\r\n#topnav.scroll .navigation-menu>li>.menu-arrow {\r\n\tborder-color: #343a40\r\n}\r\n\r\n#topnav.scroll .navigation-menu>li:hover>a,\r\n#topnav.scroll .navigation-menu>li.active>a {\r\n\tcolor: #00CCCC\r\n}\r\n\r\n#topnav.scroll .navigation-menu>li:hover>.menu-arrow,\r\n#topnav.scroll .navigation-menu>li.active>.menu-arrow {\r\n\tborder-color: #00CCCC\r\n}\r\n\r\n#topnav.defaultscroll.dark-menubar .logo {\r\n\tline-height: 70px\r\n}\r\n\r\n#topnav.defaultscroll.scroll .logo {\r\n\tline-height: 62px\r\n}\r\n\r\n#topnav.defaultscroll.scroll.dark-menubar .logo {\r\n\tline-height: 62px\r\n}\r\n\r\n#topnav.nav-sticky {\r\n\tbackground: #fff;\r\n\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15)\r\n}\r\n\r\n#topnav.nav-sticky .navigation-menu.nav-light>li>a {\r\n\tcolor: #343a40\r\n}\r\n\r\n#topnav.nav-sticky .navigation-menu.nav-light>li.active>a {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n#topnav.nav-sticky .navigation-menu.nav-light>li:hover>.menu-arrow,\r\n#topnav.nav-sticky .navigation-menu.nav-light>li.active>.menu-arrow {\r\n\tborder-color: #00CCCC !important\r\n}\r\n\r\n#topnav.nav-sticky .navigation-menu.nav-light>li:hover>a,\r\n#topnav.nav-sticky .navigation-menu.nav-light>li.active>a {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n#topnav.nav-sticky .navigation-menu.nav-light .has-submenu .menu-arrow {\r\n\tborder-color: #343a40\r\n}\r\n\r\n#topnav.nav-sticky .dropdowns .login-btn-primary {\r\n\tdisplay: inline-block\r\n}\r\n\r\n#topnav.nav-sticky .dropdowns .login-btn-light {\r\n\tdisplay: none\r\n}\r\n\r\n#topnav.nav-sticky .logo .l-dark {\r\n\tdisplay: inline-block\r\n}\r\n\r\n#topnav.nav-sticky .logo .l-light {\r\n\tdisplay: none\r\n}\r\n\r\n.logo {\r\n\tfont-weight: 600;\r\n\tfont-size: 24px;\r\n\tpadding: 0 0 6px;\r\n\tletter-spacing: 1px;\r\n\tline-height: 68px\r\n}\r\n\r\n.search-bar {\r\n\tpadding-top: 14.5px;\r\n\tpadding-bottom: 14.5px\r\n}\r\n\r\n.search-bar .menu-search form {\r\n\tposition: relative\r\n}\r\n\r\n.search-bar .menu-search input[type=\"text\"],\r\n.search-bar .searchform input[type=\"text\"] {\r\n\tbox-shadow: none;\r\n\tpadding: 12px 15px;\r\n\theight: 40px;\r\n\tfont-size: 14px;\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\toutline: none !important;\r\n\tpadding-right: 45px;\r\n\topacity: 0.7\r\n}\r\n\r\n.search-bar .menu-search input[type=\"submit\"],\r\n.search-bar .searchform input[type=\"submit\"] {\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tright: 10px;\r\n\topacity: 0;\r\n\twidth: 40px;\r\n\theight: 40px\r\n}\r\n\r\n.search-bar .menu-search .searchform:after {\r\n\tcontent: \"\\F0349\";\r\n\tposition: absolute;\r\n\tfont-family: \"Material Design Icons\";\r\n\tright: 16px;\r\n\ttop: 12px;\r\n\tfont-size: 20px;\r\n\tline-height: 20px;\r\n\tpointer-events: none\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\t#topnav .navigation-menu {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center\r\n\t}\r\n\r\n\t#topnav .navigation-menu>.has-submenu>.submenu>.has-submenu>.submenu::before {\r\n\t\ttop: 15px;\r\n\t\tmargin-left: -20px;\r\n\t\tbox-shadow: 1px 1px 0px 0px rgba(52, 58, 64, 0.15);\r\n\t\tborder-color: transparent #fff #fff transparent\r\n\t}\r\n\r\n\t#topnav .navigation-menu>.has-submenu:hover .menu-arrow {\r\n\t\ttop: 35px !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu>.has-submenu.active .menu-arrow {\r\n\t\ttop: 32px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu {\r\n\t\tposition: absolute;\r\n\t\ttop: 100%;\r\n\t\tleft: 15px;\r\n\t\tz-index: 1000;\r\n\t\tpadding: 15px 0;\r\n\t\tlist-style: none;\r\n\t\tmin-width: 180px;\r\n\t\tvisibility: hidden;\r\n\t\topacity: 0;\r\n\t\tmargin-top: 10px;\r\n\t\ttransition: all .2s ease;\r\n\t\tborder-radius: 5px;\r\n\t\tbackground-color: #fff;\r\n\t\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15)\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu li {\r\n\t\tposition: relative\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu li a {\r\n\t\tdisplay: block;\r\n\t\tpadding: 10px 20px;\r\n\t\tclear: both;\r\n\t\twhite-space: nowrap;\r\n\t\tfont-size: 11px;\r\n\t\ttext-transform: uppercase;\r\n\t\tletter-spacing: 0.04em;\r\n\t\tfont-weight: 600;\r\n\t\tcolor: #343a40 !important;\r\n\t\ttransition: all 0.3s\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu li a:hover {\r\n\t\tcolor: #00CCCC !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu li ul {\r\n\t\tlist-style: none;\r\n\t\tpadding-left: 0;\r\n\t\tmargin: 0\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu.megamenu {\r\n\t\twhite-space: nowrap;\r\n\t\twidth: auto\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu.megamenu>li {\r\n\t\toverflow: hidden;\r\n\t\tmin-width: 180px;\r\n\t\tdisplay: inline-block;\r\n\t\tvertical-align: top\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu.megamenu>li .submenu {\r\n\t\tleft: 100%;\r\n\t\ttop: 0;\r\n\t\tmargin-left: 10px;\r\n\t\tmargin-top: -1px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu>li .submenu {\r\n\t\tleft: 101%;\r\n\t\ttop: 0;\r\n\t\tmargin-left: 10px;\r\n\t\tmargin-top: -1px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li>a {\r\n\t\tpadding-top: 25px;\r\n\t\tpadding-bottom: 25px;\r\n\t\tmin-height: 62px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li:hover>.menu-arrow {\r\n\t\tborder-color: #00CCCC\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li:hover>a,\r\n\t#topnav .navigation-menu>li.active>a {\r\n\t\tcolor: #00CCCC !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li.last-elements .submenu {\r\n\t\tleft: auto;\r\n\t\tright: 0\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li.last-elements .submenu:before {\r\n\t\tleft: auto;\r\n\t\tright: 10px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li.last-elements .submenu>li.has-submenu .submenu {\r\n\t\tleft: auto;\r\n\t\tright: 106%;\r\n\t\tmargin-left: 0;\r\n\t\tmargin-right: 10px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li.last-elements .submenu>li.has-submenu .submenu:before {\r\n\t\ttransform: rotate(-45deg);\r\n\t\tright: -3px\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-light>li>a {\r\n\t\tcolor: rgba(255, 255, 255, 0.5)\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-light>li.active>a {\r\n\t\tcolor: #fff !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-light>li:hover>.menu-arrow {\r\n\t\tborder-color: #fff !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-light>li:hover>a {\r\n\t\tcolor: #fff !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-light .has-submenu .menu-arrow {\r\n\t\tborder-color: rgba(255, 255, 255, 0.5)\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-light .has-submenu.active .menu-arrow {\r\n\t\tborder-color: #fff !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-right {\r\n\t\tjustify-content: flex-end !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-left {\r\n\t\tjustify-content: flex-start !important\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-left>li.last-elements .submenu {\r\n\t\tleft: auto;\r\n\t\tright: 0\r\n\t}\r\n\r\n\t#topnav .navigation-menu.nav-left>li.last-elements .submenu:before {\r\n\t\tright: -5px\r\n\t}\r\n\r\n\t#topnav .logo {\r\n\t\tmargin-right: 30px\r\n\t}\r\n\r\n\t#topnav .dropdowns {\r\n\t\tpadding-left: 15px;\r\n\t\tmargin-left: 15px\r\n\t}\r\n\r\n\t#topnav .navbar-toggle {\r\n\t\tdisplay: none\r\n\t}\r\n\r\n\t#topnav #navigation {\r\n\t\tdisplay: block !important\r\n\t}\r\n\r\n\t#topnav.scroll {\r\n\t\ttop: 0\r\n\t}\r\n\r\n\t#topnav.scroll .navigation-menu>li>a {\r\n\t\tpadding-top: 20px;\r\n\t\tpadding-bottom: 20px\r\n\t}\r\n\r\n\t#topnav.scroll-active .navigation-menu>li>a {\r\n\t\tpadding-top: 25px;\r\n\t\tpadding-bottom: 25px\r\n\t}\r\n\r\n\t#topnav .search-bar .menu-search input[type=\"text\"],\r\n\t#topnav .search-bar .searchform input[type=\"text\"] {\r\n\t\twidth: 250px !important\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t#topnav {\r\n\t\tbackground-color: #fff;\r\n\t\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15);\r\n\t\tmin-height: 74px\r\n\t}\r\n\r\n\t#topnav .logo {\r\n\t\tpadding: 3px 0 !important\r\n\t}\r\n\r\n\t#topnav .logo .l-dark {\r\n\t\tdisplay: inline-block !important\r\n\t}\r\n\r\n\t#topnav .logo .l-light {\r\n\t\tdisplay: none !important\r\n\t}\r\n\r\n\t#topnav .container {\r\n\t\twidth: auto\r\n\t}\r\n\r\n\t#topnav #navigation {\r\n\t\tmax-height: 400px\r\n\t}\r\n\r\n\t#topnav .navigation-menu {\r\n\t\tfloat: none\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li {\r\n\t\tfloat: none\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu {\r\n\t\tdisplay: none;\r\n\t\tlist-style: none;\r\n\t\tpadding-left: 20px;\r\n\t\tmargin: 0\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu li a {\r\n\t\tdisplay: block;\r\n\t\tposition: relative;\r\n\t\tpadding: 7px 15px;\r\n\t\ttext-transform: uppercase;\r\n\t\tfont-size: 11px;\r\n\t\tletter-spacing: 0.04em;\r\n\t\tfont-weight: 600;\r\n\t\tcolor: #343a40 !important;\r\n\t\ttransition: all 0.3s\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu.open {\r\n\t\tdisplay: block\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu .submenu {\r\n\t\tdisplay: none;\r\n\t\tlist-style: none\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu .submenu.open {\r\n\t\tdisplay: block\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu.megamenu>li>ul {\r\n\t\tlist-style: none;\r\n\t\tpadding-left: 0\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li .submenu.megamenu>li>ul>li>span {\r\n\t\tdisplay: block;\r\n\t\tposition: relative;\r\n\t\tpadding: 10px 15px;\r\n\t\ttext-transform: uppercase;\r\n\t\tfont-size: 12px;\r\n\t\tletter-spacing: 2px;\r\n\t\tcolor: #8492a6\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li>a {\r\n\t\tcolor: #343a40;\r\n\t\tpadding: 10px 20px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li>a:after {\r\n\t\tposition: absolute;\r\n\t\tright: 15px\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li>a:hover,\r\n\t#topnav .navigation-menu>li .submenu li a:hover,\r\n\t#topnav .navigation-menu>li.has-submenu.open>a {\r\n\t\tcolor: #00CCCC\r\n\t}\r\n\r\n\t#topnav .menu-extras .menu-item {\r\n\t\tborder-color: #8492a6\r\n\t}\r\n\r\n\t#topnav .navbar-header {\r\n\t\tfloat: left\r\n\t}\r\n\r\n\t#topnav .dropdowns .login-btn-primary {\r\n\t\tdisplay: inline-block !important\r\n\t}\r\n\r\n\t#topnav .dropdowns .login-btn-light {\r\n\t\tdisplay: none\r\n\t}\r\n\r\n\t#topnav .has-submenu .submenu .submenu-arrow {\r\n\t\ttransform: rotate(45deg);\r\n\t\tposition: absolute;\r\n\t\tright: 20px;\r\n\t\ttop: 12px\r\n\t}\r\n\r\n\t#topnav .has-submenu.active a {\r\n\t\tcolor: #00CCCC\r\n\t}\r\n\r\n\t#navigation {\r\n\t\tposition: absolute;\r\n\t\ttop: 74px;\r\n\t\tleft: 0;\r\n\t\twidth: 100%;\r\n\t\tdisplay: none;\r\n\t\theight: auto;\r\n\t\tpadding-bottom: 0;\r\n\t\toverflow: auto;\r\n\t\tborder-top: 1px solid #f1f3f9;\r\n\t\tborder-bottom: 1px solid #f1f3f9;\r\n\t\tbackground-color: #fff\r\n\t}\r\n\r\n\t#navigation.open {\r\n\t\tdisplay: block;\r\n\t\toverflow-y: auto\r\n\t}\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t#topnav .navigation-menu .has-submenu .menu-arrow {\r\n\t\tright: 16px;\r\n\t\ttop: 16px\r\n\t}\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t#topnav .navigation-menu>li.has-submenu:hover>.submenu {\r\n\t\tvisibility: visible;\r\n\t\topacity: 1;\r\n\t\tmargin-top: 0\r\n\t}\r\n\r\n\t#topnav .navigation-menu>li.has-submenu:hover>.submenu>li.has-submenu:hover>.submenu {\r\n\t\tvisibility: visible;\r\n\t\topacity: 1;\r\n\t\tmargin-left: 0;\r\n\t\tmargin-right: 0\r\n\t}\r\n\r\n\t.navbar-toggle {\r\n\t\tdisplay: block\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t#topnav .navbar-toggle .lines {\r\n\t\tmargin-right: 0 !important\r\n\t}\r\n}\r\n\r\n@media (max-width: 375px) {\r\n\t#topnav .dropdowns {\r\n\t\tmargin: 0 0 0 10px\r\n\t}\r\n}\r\n\r\n.sidebar-nav {\r\n\tpadding: 15px 0\r\n}\r\n\r\n.sidebar-nav>.navbar-item {\r\n\tpadding: 6.5px 15px\r\n}\r\n\r\n.sidebar-nav>.navbar-item .navbar-link {\r\n\tcolor: #343a40 !important;\r\n\tfont-size: 15px;\r\n\tfont-weight: 500\r\n}\r\n\r\n.sidebar-nav>.navbar-item .navbar-link .navbar-icon {\r\n\tfont-size: 18px;\r\n\tmargin-right: 6px\r\n}\r\n\r\n.sidebar-nav>.navbar-item:hover .navbar-link,\r\n.sidebar-nav>.navbar-item.active .navbar-link {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.page-wrapper {\r\n\theight: 100vh\r\n}\r\n\r\n.page-wrapper.doctris-theme .sidebar-wrapper {\r\n\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15);\r\n\tbackground-color: #fff;\r\n\ttransition: all 0.3s ease\r\n}\r\n\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu {\r\n\tborder-top: 1px solid #e9ecef\r\n}\r\n\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header .user-info .user-role,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header .user-info .user-status,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand>a,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li a {\r\n\tcolor: #93969F;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:hover>a,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li.active>a,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:active>a,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:active>a:before,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li:hover>a:before,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu li.active>a:before,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-header .user-info,\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand>a:hover {\r\n\tcolor: #00CCCC !important;\r\n}\r\n\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand .logo-dark-mode {\r\n\tdisplay: none\r\n}\r\n\r\n.page-wrapper.doctris-theme .sidebar-wrapper .sidebar-brand .logo-light-mode {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper {\r\n\twidth: 300px;\r\n\theight: 100%;\r\n\tmax-height: 100%;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: -300px;\r\n\tz-index: 999\r\n}\r\n\r\n@media (min-width: 1025px) {\r\n\t.page-wrapper .sidebar-wrapper {\r\n\t\tz-index: 1000\r\n\t}\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n\t.page-wrapper .sidebar-wrapper {\r\n\t\tleft: 0\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.page-wrapper .sidebar-wrapper {\r\n\t\twidth: 260px\r\n\t}\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper ul {\r\n\tlist-style-type: none;\r\n\tpadding: 0;\r\n\tmargin: 0\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper a {\r\n\ttext-decoration: none\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-content {\r\n\t/* max-height: calc(100% - 30px); */\r\n\t/* height: calc(100% - 30px); */\r\n\toverflow-y: auto;\r\n\tposition: relative;\r\n\theight: 100vh;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-content::-webkit-scrollbar {\r\n\twidth: 7px;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-content::-webkit-scrollbar-track {\r\n\tborder-radius: 10px;\r\n\tbackground: whitesmoke;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-content::-webkit-scrollbar-thumb {\r\n\tbackground: #00CCCC;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-content.desktop {\r\n\toverflow-y: hidden\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-brand {\r\n\tpadding: 10px 20px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-brand>a {\r\n\ttext-transform: uppercase;\r\n\tfont-weight: bold;\r\n\tflex-grow: 1;\r\n\ttransition: all 0.3s ease\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-brand>a:focus {\r\n\toutline: none\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-brand #close-sidebar {\r\n\tcursor: pointer;\r\n\tfont-size: 24px;\r\n\ttransition: all 0.3s ease\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-header {\r\n\tpadding: 20px;\r\n\toverflow: hidden\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu {\r\n\tpadding-bottom: 10px\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .header-menu span {\r\n\tfont-weight: bold;\r\n\tfont-size: 14px;\r\n\tpadding: 15px 20px 5px 20px;\r\n\tdisplay: inline-block\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu li a {\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\ttext-decoration: none;\r\n\tposition: relative;\r\n\tpadding: 9px 25px;\r\n\ttransition: all 0.3s ease\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu li a:hover>i::before {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu li a:focus {\r\n\toutline: none\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu li a i {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n\tbackground-color: transparent;\r\n\tfont-size: 18px;\r\n\ttext-align: center;\r\n\tborder-radius: 5px;\r\n\ttransition: all 0.3s ease;\r\n\tmargin-right: 12px;\r\n\tvertical-align: -2px;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu li:hover i,\r\n.page-wrapper .sidebar-wrapper .sidebar-menu li.active i {\r\n\t/* \tbackground-color: rgba(57, 108, 240, 0.1) */\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown>a:after {\r\n\tcontent: \"\\F0142\" !important;\r\n\tcolor: #93969F;\r\n\tfont-family: 'Material Design Icons';\r\n\tfont-size: 22px;\r\n\tposition: absolute;\r\n\tright: 10px;\r\n\ttop: 6px;\r\n\ttransition: all 0.3s ease;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a:after {\r\n\ttransform: rotate(90deg);\r\n\tright: 10px;\r\n\tcolor: #00CCCC;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu li.active>a {\r\n\tbackground: #E0F9F9;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu {\r\n\tdisplay: none\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul {\r\n\tpadding: 5px 0\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li {\r\n\tpadding-left: 30px;\r\n\tfont-size: 14px\r\n}\r\n\r\n.sidebar-submenu ul li a {\r\n\tfont-size: 14px !important;\r\n\tline-height: 21px;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li a:before {\r\n\tcontent: \"\\F035F\" !important;\r\n\tcolor: #93969F;\r\n\tfont-family: 'Material Design Icons';\r\n\tmargin-right: 2px;\r\n\tfont-size: 24px;\r\n\ttransition: all 0.3s ease;\r\n\tvertical-align: -3px;\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li a .badge,\r\n.page-wrapper .sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul li a .label {\r\n\tfloat: right;\r\n\tmargin-top: 0px\r\n}\r\n\r\n.page-wrapper .sidebar-wrapper .sidebar-menu ul li a span.label,\r\n.page-wrapper .sidebar-wrapper .sidebar-menu ul li a span.badge {\r\n\tfloat: right;\r\n\tmargin-top: 8px;\r\n\tmargin-left: 5px\r\n}\r\n\r\n.page-wrapper .page-content {\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\tpadding-left: 0px;\r\n\toverflow-x: hidden;\r\n\ttransition: all 0.3s ease\r\n}\r\n\r\n.page-wrapper .page-content .top-header {\r\n\tposition: fixed;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tz-index: 999;\r\n\tmax-height: 70px;\r\n\tleft: 0px;\r\n\ttransition: all 0.3s\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar {\r\n\tbackground: #fff;\r\n\theight: 71px;\r\n\tposition: relative;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 24px\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.page-wrapper .page-content .top-header .header-bar {\r\n\t\tpadding: 24px 12px\r\n\t}\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .logo-icon {\r\n\tdisplay: none\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n\t.page-wrapper .page-content .top-header .header-bar .logo-icon {\r\n\t\tdisplay: block\r\n\t}\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .logo-icon .small {\r\n\tdisplay: none\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.page-wrapper .page-content .top-header .header-bar .logo-icon .small {\r\n\t\tdisplay: block\r\n\t}\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .logo-icon .big {\r\n\tdisplay: none\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .logo-icon .big .logo-dark-mode {\r\n\tdisplay: none\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .logo-icon .big .logo-light-mode {\r\n\tdisplay: inline-block\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n\t.page-wrapper .page-content .top-header .header-bar .logo-icon .big {\r\n\t\tdisplay: block\r\n\t}\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .search-bar {\r\n\tpadding-top: 14.5px;\r\n\tpadding-bottom: 14.5px\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search form {\r\n\tposition: relative\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search input[type=\"text\"],\r\n.page-wrapper .page-content .top-header .header-bar .search-bar .searchform input[type=\"text\"] {\r\n\tbox-shadow: none;\r\n\tpadding: 12px 15px;\r\n\theight: 40px;\r\n\tfont-size: 14px;\r\n\tdisplay: block;\r\n\twidth: 250px;\r\n\toutline: none !important;\r\n\tpadding-right: 45px;\r\n\topacity: 0.7\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search input[type=\"submit\"],\r\n.page-wrapper .page-content .top-header .header-bar .search-bar .searchform input[type=\"submit\"] {\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tright: 10px;\r\n\topacity: 0;\r\n\twidth: 40px;\r\n\theight: 40px\r\n}\r\n\r\n.page-wrapper .page-content .top-header .header-bar .search-bar .menu-search .searchform:after {\r\n\tcontent: \"\\F0349\";\r\n\tposition: absolute;\r\n\tfont-family: \"Material Design Icons\";\r\n\tright: 16px;\r\n\ttop: 12px;\r\n\tfont-size: 20px;\r\n\tline-height: 20px;\r\n\tpointer-events: none\r\n}\r\n\r\n.page-wrapper .page-content .layout-specing {\r\n\tpadding: 94px 14px 24px !important;\r\n\t/* min-height: calc(100vh - 56px) !important; */\r\n\tposition: relative\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.page-wrapper .page-content .layout-specing {\r\n\t\tpadding: 94px 0 24px !important\r\n\t}\r\n}\r\n\r\n@media screen and (min-width: 1025px) {\r\n\t.page-wrapper.toggled .page-content {\r\n\t\tpadding-left: 300px\r\n\t}\r\n}\r\n\r\n.page-wrapper.toggled .top-header {\r\n\tleft: 301px\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n\t.page-wrapper.toggled .top-header {\r\n\t\tleft: 0\r\n\t}\r\n}\r\n\r\n.page-wrapper.toggled .sidebar-wrapper {\r\n\tleft: 0px\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n\t.page-wrapper.toggled .sidebar-wrapper {\r\n\t\tleft: -300px\r\n\t}\r\n}\r\n\r\n.sidebar-footer {\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tpadding: 9px 15px !important;\r\n\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15)\r\n}\r\n\r\n.bg-home {\r\n\theight: 100vh;\r\n\tbackground-size: cover;\r\n\talign-self: center;\r\n\tposition: relative;\r\n\tbackground-position: center center\r\n}\r\n\r\n.bg-half-260 {\r\n\tpadding: 260px 0;\r\n\tbackground-size: cover;\r\n\talign-self: center;\r\n\tposition: relative;\r\n\tbackground-position: center center\r\n}\r\n\r\n.bg-half-170 {\r\n\tpadding: 170px 0;\r\n\tbackground-size: cover;\r\n\talign-self: center;\r\n\tposition: relative;\r\n\tbackground-position: center center\r\n}\r\n\r\n.bg-half-150 {\r\n\tpadding: 150px 0;\r\n\tbackground-size: cover;\r\n\talign-self: center;\r\n\tposition: relative;\r\n\tbackground-position: center center\r\n}\r\n\r\n.bg-profile {\r\n\tpadding: 80px 0;\r\n\tbackground-size: cover;\r\n\talign-self: center;\r\n\tposition: relative;\r\n\tbackground-position: center center\r\n}\r\n\r\n.bg-dashboard {\r\n\tpadding: 100px 0 30px;\r\n\tbackground-size: cover;\r\n\talign-self: center;\r\n\tposition: relative;\r\n\tbackground-position: center center\r\n}\r\n\r\n.bg-hero {\r\n\tpadding: 100px 0;\r\n\tbackground-size: cover;\r\n\talign-self: center;\r\n\tposition: relative;\r\n\tbackground-position: center center\r\n}\r\n\r\n.dr-profile-img {\r\n\tposition: absolute;\r\n\tbottom: 0\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.dr-profile-img {\r\n\t\tposition: relative;\r\n\t\tpadding: 24px\r\n\t}\r\n}\r\n\r\n.home-slider .carousel-control-next,\r\n.home-slider .carousel-control-prev {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n\tborder-radius: 30px;\r\n\tborder: 1px solid #ced4da\r\n}\r\n\r\n.home-slider .carousel-control-next-icon,\r\n.home-slider .carousel-control-prev-icon {\r\n\twidth: 30%\r\n}\r\n\r\n.home-slider .carousel-control-next {\r\n\tright: 8px\r\n}\r\n\r\n.home-slider .carousel-control-prev {\r\n\tleft: 8px\r\n}\r\n\r\n.carousel-indicators [data-bs-target] {\r\n\twidth: 7px;\r\n\theight: 7px;\r\n\tborder-radius: 30px;\r\n\tbackground: rgba(57, 108, 240, 0.5) !important;\r\n\ttransition: all 0.5s ease;\r\n\tborder: 2px solid rgba(255, 255, 255, 0.5);\r\n\tmargin: 0 4px;\r\n\tpadding: 0\r\n}\r\n\r\n.carousel-indicators .active {\r\n\tbackground: #00CCCC !important;\r\n\tborder-color: #00CCCC\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\r\n\t.bg-home,\r\n\t.bg-half-170,\r\n\t.bg-half-260,\r\n\t.main-slider .slides .bg-slider {\r\n\t\tpadding: 150px 0;\r\n\t\theight: auto\r\n\t}\r\n}\r\n\r\n.features.feature-primary .title:hover {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.features.feature-primary .icon {\r\n\tcolor: #00CCCC !important;\r\n\tbackground-color: rgba(57, 108, 240, 0.05) !important\r\n}\r\n\r\n.features.feature-primary .link {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.features.feature-bg-primary:hover {\r\n\tbackground-color: #00CCCC !important\r\n}\r\n\r\n.features.feature-secondary .title:hover {\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.features.feature-secondary .icon {\r\n\tcolor: #5a6d90 !important;\r\n\tbackground-color: rgba(90, 109, 144, 0.05) !important\r\n}\r\n\r\n.features.feature-secondary .link {\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.features.feature-bg-secondary:hover {\r\n\tbackground-color: #5a6d90 !important\r\n}\r\n\r\n.features.feature-success .title:hover {\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.features.feature-success .icon {\r\n\tcolor: #53c797 !important;\r\n\tbackground-color: rgba(83, 199, 151, 0.05) !important\r\n}\r\n\r\n.features.feature-success .link {\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.features.feature-bg-success:hover {\r\n\tbackground-color: #53c797 !important\r\n}\r\n\r\n.features.feature-warning .title:hover {\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.features.feature-warning .icon {\r\n\tcolor: #f1b561 !important;\r\n\tbackground-color: rgba(241, 181, 97, 0.05) !important\r\n}\r\n\r\n.features.feature-warning .link {\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.features.feature-bg-warning:hover {\r\n\tbackground-color: #f1b561 !important\r\n}\r\n\r\n.features.feature-info .title:hover {\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.features.feature-info .icon {\r\n\tcolor: #64c2f1 !important;\r\n\tbackground-color: rgba(100, 194, 241, 0.05) !important\r\n}\r\n\r\n.features.feature-info .link {\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.features.feature-bg-info:hover {\r\n\tbackground-color: #64c2f1 !important\r\n}\r\n\r\n.features.feature-danger .title:hover {\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.features.feature-danger .icon {\r\n\tcolor: #f0735a !important;\r\n\tbackground-color: rgba(240, 115, 90, 0.05) !important\r\n}\r\n\r\n.features.feature-danger .link {\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.features.feature-bg-danger:hover {\r\n\tbackground-color: #f0735a !important\r\n}\r\n\r\n.features.feature-dark .title:hover {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.features.feature-dark .icon {\r\n\tcolor: #343a40 !important;\r\n\tbackground-color: rgba(52, 58, 64, 0.05) !important\r\n}\r\n\r\n.features.feature-dark .link {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.features.feature-bg-dark:hover {\r\n\tbackground-color: #343a40 !important\r\n}\r\n\r\n.features.feature-muted .title:hover {\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.features.feature-muted .icon {\r\n\tcolor: #8492a6 !important;\r\n\tbackground-color: rgba(132, 146, 166, 0.05) !important\r\n}\r\n\r\n.features.feature-muted .link {\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.features.feature-bg-muted:hover {\r\n\tbackground-color: #8492a6 !important\r\n}\r\n\r\n.features.feature-light .title:hover {\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.features.feature-light .icon {\r\n\tcolor: #f8f9fc !important;\r\n\tbackground-color: rgba(248, 249, 252, 0.05) !important\r\n}\r\n\r\n.features.feature-light .link {\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.features.feature-bg-light:hover {\r\n\tbackground-color: #f8f9fc !important\r\n}\r\n\r\n.features.feature-footer .title:hover {\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.features.feature-footer .icon {\r\n\tcolor: #202942 !important;\r\n\tbackground-color: rgba(32, 41, 66, 0.05) !important\r\n}\r\n\r\n.features.feature-footer .link {\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.features.feature-bg-footer:hover {\r\n\tbackground-color: #202942 !important\r\n}\r\n\r\n.features {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n.features .icon {\r\n\theight: 65px;\r\n\twidth: 65px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center\r\n}\r\n\r\n.features .title {\r\n\tfont-weight: 500\r\n}\r\n\r\n.features .big-icon {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n\tright: 20px;\r\n\topacity: 0.05;\r\n\tfont-size: 120px\r\n}\r\n\r\n.features .titles,\r\n.features .icons,\r\n.features .para,\r\n.features .big-icon {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n.features:hover .titles,\r\n.features:hover .icons,\r\n.features:hover .big-icon {\r\n\tcolor: #fff !important\r\n}\r\n\r\n.features:hover .para {\r\n\tcolor: rgba(255, 255, 255, 0.5) !important\r\n}\r\n\r\n.play-btn {\r\n\theight: 78px;\r\n\twidth: 78px;\r\n\tfont-size: 30px;\r\n\tline-height: 76px;\r\n\tborder-radius: 50%;\r\n\tdisplay: inline-block;\r\n\tcolor: #fff\r\n}\r\n\r\n.play-icon {\r\n\tposition: absolute;\r\n\tbottom: 50%;\r\n\ttransform: translateY(50%);\r\n\tright: 0;\r\n\tleft: 0;\r\n\ttext-align: center\r\n}\r\n\r\n.play-icon i {\r\n\theight: 75px;\r\n\t-webkit-text-stroke: 2px #00CCCC;\r\n\t-webkit-text-fill-color: transparent;\r\n\twidth: 75px;\r\n\tfont-size: 25px;\r\n\tline-height: 75px;\r\n\tdisplay: inline-block\r\n}\r\n\r\n.play-icon i:hover {\r\n\t-webkit-text-stroke: 2px #00CCCC;\r\n\t-webkit-text-fill-color: #00CCCC\r\n}\r\n\r\n.cta-review {\r\n\tposition: relative;\r\n\ttop: 220px\r\n}\r\n\r\n.chat .chat-list:hover,\r\n.chat .chat-list.active,\r\n.chat .chat-list:focus {\r\n\tbackground: #f8f9fc !important;\r\n\tbox-shadow: 0 0 3px rgba(52, 58, 64, 0.15)\r\n}\r\n\r\n.chat .chat-list .on-off,\r\n.chat .chat-type .on-off {\r\n\tposition: absolute;\r\n\tleft: -1px;\r\n\ttop: -1px;\r\n\tfont-size: 12px !important\r\n}\r\n\r\n.chat.chat-person .on-off {\r\n\tfont-size: 10px\r\n}\r\n\r\n.chat.chat-person .chat-msg {\r\n\tmargin-left: 8px\r\n}\r\n\r\n.chat.chat-person .chat-msg .msg {\r\n\tborder: 1px solid #e9ecef\r\n}\r\n\r\n.chat.chat-person .chat-msg .msg-time {\r\n\tfont-size: 12px !important\r\n}\r\n\r\n.chat.chat-person .chat-right {\r\n\tjustify-content: flex-end;\r\n\ttext-align: right\r\n}\r\n\r\n.chat.chat-person .chat-right .chat-user-image {\r\n\torder: 2\r\n}\r\n\r\n.chat.chat-person .chat-right .chat-user-image .on-off {\r\n\tright: -1px\r\n}\r\n\r\n.chat.chat-person .chat-right .chat-msg {\r\n\tmargin-right: 8px;\r\n\tmargin-left: 0\r\n}\r\n\r\n.chat.chat-person .chat-right .chat-msg .msg {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.chat.chat-person .chat-right .chat-msg .msg-time {\r\n\tdisplay: block\r\n}\r\n\r\n.team {\r\n\ttransition: all 0.5s\r\n}\r\n\r\n.team .team-img .team-social {\r\n\tposition: absolute;\r\n\tbottom: 10px;\r\n\tleft: 10px;\r\n\topacity: 0;\r\n\ttransition: all 0.5s;\r\n\ttransform: translateX(-50px)\r\n}\r\n\r\n.team .title {\r\n\tfont-weight: 500\r\n}\r\n\r\n.team .content,\r\n.team .content .title,\r\n.team .content .speciality {\r\n\ttransition: all 0.5s\r\n}\r\n\r\n.team .team-person img {\r\n\ttransition: all 0.5s\r\n}\r\n\r\n.team .team-person .team-like {\r\n\tposition: absolute;\r\n\ttop: 10px;\r\n\tright: 10px\r\n}\r\n\r\n.team .team-person:hover img {\r\n\ttransform: scale(1.05)\r\n}\r\n\r\n.team:hover .team-img .team-social {\r\n\topacity: 1;\r\n\ttransform: translateX(0px)\r\n}\r\n\r\n.team:hover .content {\r\n\tbackground: #00CCCC !important\r\n}\r\n\r\n.team:hover .content .title {\r\n\tcolor: #fff !important\r\n}\r\n\r\n.team:hover .content .speciality {\r\n\tcolor: rgba(255, 255, 255, 0.5) !important\r\n}\r\n\r\n.tns-nav {\r\n\ttext-align: center;\r\n\tmargin-top: 10px\r\n}\r\n\r\n.tns-nav button {\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tborder-radius: 5px;\r\n\tbackground: rgba(57, 108, 240, 0.5) !important;\r\n\ttransition: all 0.5s ease;\r\n\tborder: 2px solid rgba(255, 255, 255, 0.5);\r\n\tmargin: 0 4px;\r\n\tpadding: 0\r\n}\r\n\r\n.tns-nav button.tns-nav-active {\r\n\tbackground: #00CCCC !important;\r\n\tborder-color: #00CCCC\r\n}\r\n\r\n.tiny-timeline {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tmargin: 0 auto\r\n}\r\n\r\n.tiny-timeline:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\ttop: 17px;\r\n\tleft: 0;\r\n\theight: 2px;\r\n\tbackground: #00CCCC\r\n}\r\n\r\n.tiny-timeline .item-box {\r\n\tmargin: 70px 15px\r\n}\r\n\r\n.tiny-timeline .item-box:before,\r\n.tiny-timeline .item-box:after {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\tbackground: #00CCCC\r\n}\r\n\r\n.tiny-timeline .item-box:before {\r\n\twidth: 2px;\r\n\theight: 46px;\r\n\ttop: -46px;\r\n\ttransform: translateX(-50%)\r\n}\r\n\r\n.tiny-timeline .item-box:after {\r\n\twidth: 13px;\r\n\theight: 13px;\r\n\ttop: -59px;\r\n\tborder-radius: 3px;\r\n\ttransform: translateX(-50%) rotate(45deg)\r\n}\r\n\r\n.slick-slider {\r\n\toverflow-x: hidden !important;\r\n\tcursor: pointer\r\n}\r\n\r\n.blog.blog-primary .tag {\r\n\tbackground: #00CCCC !important\r\n}\r\n\r\n.blog.blog-primary .title:hover {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.blog.blog-primary .link {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.blog.blog-primary .post-meta .like:hover,\r\n.blog.blog-primary .post-meta .comments:hover {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.blog.blog-secondary .tag {\r\n\tbackground: #5a6d90 !important\r\n}\r\n\r\n.blog.blog-secondary .title:hover {\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.blog.blog-secondary .link {\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.blog.blog-secondary .post-meta .like:hover,\r\n.blog.blog-secondary .post-meta .comments:hover {\r\n\tcolor: #5a6d90 !important\r\n}\r\n\r\n.blog.blog-success .tag {\r\n\tbackground: #53c797 !important\r\n}\r\n\r\n.blog.blog-success .title:hover {\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.blog.blog-success .link {\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.blog.blog-success .post-meta .like:hover,\r\n.blog.blog-success .post-meta .comments:hover {\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n.blog.blog-warning .tag {\r\n\tbackground: #f1b561 !important\r\n}\r\n\r\n.blog.blog-warning .title:hover {\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.blog.blog-warning .link {\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.blog.blog-warning .post-meta .like:hover,\r\n.blog.blog-warning .post-meta .comments:hover {\r\n\tcolor: #f1b561 !important\r\n}\r\n\r\n.blog.blog-info .tag {\r\n\tbackground: #64c2f1 !important\r\n}\r\n\r\n.blog.blog-info .title:hover {\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.blog.blog-info .link {\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.blog.blog-info .post-meta .like:hover,\r\n.blog.blog-info .post-meta .comments:hover {\r\n\tcolor: #64c2f1 !important\r\n}\r\n\r\n.blog.blog-danger .tag {\r\n\tbackground: #f0735a !important\r\n}\r\n\r\n.blog.blog-danger .title:hover {\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.blog.blog-danger .link {\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.blog.blog-danger .post-meta .like:hover,\r\n.blog.blog-danger .post-meta .comments:hover {\r\n\tcolor: #f0735a !important\r\n}\r\n\r\n.blog.blog-dark .tag {\r\n\tbackground: #343a40 !important\r\n}\r\n\r\n.blog.blog-dark .title:hover {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.blog.blog-dark .link {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.blog.blog-dark .post-meta .like:hover,\r\n.blog.blog-dark .post-meta .comments:hover {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\n.blog.blog-muted .tag {\r\n\tbackground: #8492a6 !important\r\n}\r\n\r\n.blog.blog-muted .title:hover {\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.blog.blog-muted .link {\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.blog.blog-muted .post-meta .like:hover,\r\n.blog.blog-muted .post-meta .comments:hover {\r\n\tcolor: #8492a6 !important\r\n}\r\n\r\n.blog.blog-light .tag {\r\n\tbackground: #f8f9fc !important\r\n}\r\n\r\n.blog.blog-light .title:hover {\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.blog.blog-light .link {\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.blog.blog-light .post-meta .like:hover,\r\n.blog.blog-light .post-meta .comments:hover {\r\n\tcolor: #f8f9fc !important\r\n}\r\n\r\n.blog.blog-footer .tag {\r\n\tbackground: #202942 !important\r\n}\r\n\r\n.blog.blog-footer .title:hover {\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.blog.blog-footer .link {\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.blog.blog-footer .post-meta .like:hover,\r\n.blog.blog-footer .post-meta .comments:hover {\r\n\tcolor: #202942 !important\r\n}\r\n\r\n.blog .title {\r\n\tfont-weight: 500\r\n}\r\n\r\n.sidebar .widget .widget-search form {\r\n\tposition: relative\r\n}\r\n\r\n.sidebar .widget .widget-search input[type=\"text\"],\r\n.sidebar .widget .searchform input[type=\"text\"] {\r\n\tbox-shadow: none;\r\n\tpadding: 12px 15px;\r\n\theight: 45px;\r\n\tfont-size: 14px;\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\toutline: none !important;\r\n\tpadding-right: 45px\r\n}\r\n\r\n.sidebar .widget .widget-search input[type=\"submit\"],\r\n.sidebar .widget .searchform input[type=\"submit\"] {\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tright: 10px;\r\n\topacity: 0;\r\n\twidth: 40px;\r\n\theight: 40px\r\n}\r\n\r\n.sidebar .widget .widget-search .searchform:after {\r\n\tcontent: \"\\F0349\";\r\n\tposition: absolute;\r\n\tfont-family: \"Material Design Icons\";\r\n\tright: 16px;\r\n\ttop: 15px;\r\n\tfont-size: 20px;\r\n\tline-height: 20px;\r\n\tpointer-events: none\r\n}\r\n\r\n.sidebar .widget .post-recent {\r\n\tpadding-bottom: 15px\r\n}\r\n\r\n.sidebar .widget .post-recent:last-child {\r\n\tpadding-bottom: 0\r\n}\r\n\r\n.sidebar .widget .post-recent .post-recent-thumb {\r\n\twidth: 25%\r\n}\r\n\r\n.sidebar .widget .post-recent .post-recent-content {\r\n\twidth: 75%;\r\n\tpadding-left: 10px\r\n}\r\n\r\n.sidebar .widget .post-recent .post-recent-content a {\r\n\tdisplay: block;\r\n\tcolor: #343a40;\r\n\tfont-size: 15px;\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n.sidebar .widget .post-recent .post-recent-content a:hover {\r\n\tcolor: #00CCCC\r\n}\r\n\r\n.sidebar .widget .post-recent .post-recent-content span {\r\n\tfont-size: 13px\r\n}\r\n\r\n.sidebar .widget .tagcloud>a {\r\n\tbackground: #f8f9fa;\r\n\tcolor: #343a40;\r\n\tdisplay: inline-block;\r\n\tfont-size: 9px;\r\n\tletter-spacing: 1px;\r\n\tmargin: 5px 10px 5px 0;\r\n\tpadding: 8px 12px 7px;\r\n\ttext-transform: uppercase;\r\n\ttransition: all 0.5s ease;\r\n\tfont-weight: 600\r\n}\r\n\r\n.sidebar .widget .tagcloud>a:hover {\r\n\tbackground: #00CCCC;\r\n\tcolor: #fff\r\n}\r\n\r\n.pharpachy-categories .category-title {\r\n\tposition: absolute;\r\n\ttop: 20px;\r\n\tleft: 20px;\r\n\tz-index: 1\r\n}\r\n\r\n.fc-event-title-container,\r\n#external-events .fc-event {\r\n\tcursor: pointer;\r\n\tmargin: 4px 2px\r\n}\r\n\r\n#external-events .fc-event .fc-event-main {\r\n\tpadding: 5px\r\n}\r\n\r\n.fc .fc-non-business {\r\n\tbackground-color: transparent\r\n}\r\n\r\n.fc .fc-daygrid-day-number {\r\n\tpadding: 5px;\r\n\tfont-weight: 600\r\n}\r\n\r\n.fc .fc-col-header-cell-cushion {\r\n\tpadding: 8px 4px !important\r\n}\r\n\r\n.fc .fc-scrollgrid-liquid {\r\n\tborder-radius: 5px !important\r\n}\r\n\r\n.fc-theme-standard .fc-scrollgrid,\r\n.fc-theme-standard td,\r\n.fc-theme-standard th {\r\n\tborder-color: #e9ecef !important\r\n}\r\n\r\n.fc-header-toolbar .fc-toolbar-chunk .fc-toolbar-title {\r\n\tfont-size: 18px !important\r\n}\r\n\r\n.fc-direction-ltr .fc-daygrid-event.fc-event-start {\r\n\tmargin: auto 8px 4px\r\n}\r\n\r\n.fc-event-main {\r\n\tbackground-color: #00CCCC\r\n}\r\n\r\n.fc-daygrid-dot-event {\r\n\tbackground: #f8f9fa;\r\n\tborder: 1px solid #e9ecef\r\n}\r\n\r\n.fc-daygrid-dot-event:hover {\r\n\tbackground-color: #e9ecef\r\n}\r\n\r\n.fc .fc-button {\r\n\tpadding: 4px 8px;\r\n\tfont-size: 13px !important;\r\n\tbackground-color: #00CCCC !important;\r\n\tborder: 1px solid #00CCCC !important;\r\n\tcolor: #fff !important;\r\n\ttext-transform: capitalize !important\r\n}\r\n\r\n.fc .fc-button:disabled,\r\n.fc .fc-button:disabled:hover,\r\n.fc .fc-button:disabled:focus,\r\n.fc .fc-button:disabled:active,\r\n.fc .fc-button:disabled.active,\r\n.fc .fc-button:disabled.focus {\r\n\tbackground-color: rgba(57, 108, 240, 0.1) !important;\r\n\tborder: 1px solid rgba(57, 108, 240, 0.1) !important;\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.fc .fc-button:hover,\r\n.fc .fc-button:focus,\r\n.fc .fc-button:active,\r\n.fc .fc-button.active,\r\n.fc .fc-button.focus {\r\n\tbackground-color: #215aee !important;\r\n\tborder-color: #215aee !important\r\n}\r\n\r\n.fc .fc-button:focus {\r\n\tbox-shadow: none !important\r\n}\r\n\r\n.fc .fc-icon {\r\n\tfont-size: 16px !important\r\n}\r\n\r\n#calendar {\r\n\tmax-width: 1240px\r\n}\r\n\r\n.shop-list .shop-image .shop-icons,\r\n.shop-list .shop-image .qty-icons {\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n.shop-list .shop-image .shop-icons {\r\n\ttop: 15px;\r\n\tleft: 15px;\r\n\tz-index: 2\r\n}\r\n\r\n.shop-list .shop-image .qty-icons {\r\n\tbottom: 15px;\r\n\ttext-align: center;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tz-index: 2;\r\n\ttransform: translateY(100px)\r\n}\r\n\r\n.shop-list .shop-image:hover .shop-icons,\r\n.shop-list .shop-image:hover .qty-icons {\r\n\topacity: 1\r\n}\r\n\r\n.shop-list .shop-image:hover .qty-icons {\r\n\ttransform: translateY(0)\r\n}\r\n\r\n.shop-list .content .product-name {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\n.shop-list .content .product-name:hover {\r\n\tcolor: #00CCCC !important\r\n}\r\n\r\n.shop-list .label {\r\n\tposition: absolute;\r\n\ttop: 15px;\r\n\tright: 15px;\r\n\tz-index: 2\r\n}\r\n\r\n.shop-list .qty-btn {\r\n\tpointer-events: none;\r\n\twidth: 65px;\r\n\tpadding-left: 16px\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n\t.shop-list .qty-btn {\r\n\t\tpadding-left: 0\r\n\t}\r\n}\r\n\r\n.error {\r\n\tmargin: 8px 0px;\r\n\tdisplay: none;\r\n\tcolor: #f0735a\r\n}\r\n\r\n#ajaxsuccess {\r\n\tfont-size: 16px;\r\n\twidth: 100%;\r\n\tdisplay: none;\r\n\tclear: both;\r\n\tmargin: 8px 0px\r\n}\r\n\r\n.error_message,\r\n#success_page {\r\n\tpadding: 10px;\r\n\tmargin-bottom: 20px;\r\n\ttext-align: center;\r\n\tborder-radius: 5px\r\n}\r\n\r\n.error_message {\r\n\tbackground-color: rgba(240, 115, 90, 0.1) !important;\r\n\tborder: 2px solid rgba(240, 115, 90, 0.1) !important;\r\n\tcolor: #f0735a !important;\r\n\tfont-size: 14px\r\n}\r\n\r\n.contact-loader {\r\n\tdisplay: none\r\n}\r\n\r\n#success_page {\r\n\tbackground-color: rgba(83, 199, 151, 0.1) !important;\r\n\tborder: 2px solid rgba(83, 199, 151, 0.1) !important;\r\n\tcolor: #53c797 !important\r\n}\r\n\r\n#success_page p {\r\n\tmargin-bottom: 0 !important\r\n}\r\n\r\n.simplebar-track.simplebar-vertical {\r\n\twidth: 8px !important\r\n}\r\n\r\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n\twidth: 4px !important;\r\n\tbackground: #adb5bd !important\r\n}\r\n\r\nfooter {\r\n\tpadding: 60px 0 24px;\r\n\tposition: relative;\r\n\tcolor: #adb5bd\r\n}\r\n\r\nfooter .text-foot {\r\n\tcolor: #adb5bd\r\n}\r\n\r\nfooter .footer-head {\r\n\tfont-size: 18px !important;\r\n\tletter-spacing: 1px;\r\n\tfont-weight: 500\r\n}\r\n\r\nfooter .footer-list {\r\n\tmargin-bottom: 0\r\n}\r\n\r\nfooter .footer-list li {\r\n\tmargin-bottom: 10px\r\n}\r\n\r\nfooter .footer-list li a {\r\n\ttransition: all 0.5s ease\r\n}\r\n\r\nfooter .footer-list li a:hover {\r\n\tcolor: #e6e8ea\r\n}\r\n\r\nfooter .footer-list li:last-child {\r\n\tmargin-bottom: 0\r\n}\r\n\r\nfooter .footer-bar,\r\nfooter.footer-bar {\r\n\tborder-top: 1px solid #2a3656\r\n}\r\n\r\n.csrm-user-dv {\r\n\tbackground: #FFFFFF;\r\n\tbox-shadow: 0px 4px 15px rgb(0 0 0 / 10%);\r\n\tborder-radius: 0px 0px 10px 10px;\r\n\twidth: 190px;\r\n\tmargin-top: 12px !important;\r\n\tpadding: 0px;\r\n}\r\n\r\n.csrm-user-dv a, .csrm-user-dv button {\r\n\tdisplay: block;\r\n\tpadding: 8px 10px;\r\n\tfont-weight: 500;\r\n\tfont-size: 16px;\r\n\tline-height: 24px;\r\n\tcolor: #3F3F46;\r\n}\r\n\r\n.csrm-user-dv a:hover, .csrm-user-dv button:hover {\r\n\tbackground: #E0F9F9;\r\n\tcolor: #00CCCC;\r\n}\r\n\r\na.cstm-logout, button.cstm-logout {\r\n\tcolor: #EE6F57;\r\n}\r\n\r\nbutton.cstm-logout {\r\n\tbackground: none;\r\n\tborder: none;\r\n\twidth: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.active-us {\r\n\tbackground: #E0F9F9;\r\n\tcolor: #00CCCC !important;\r\n}\r\n\r\n.active-nav {\r\n\tbackground: #E0F9F9;\r\n\tcolor: #00CCCC !important;\r\n}\r\n\r\n.active-nav-in {\r\n\tcolor: #00CCCC !important;\r\n}\r\n\r\n.active-nav-in:before {\r\n\tcolor: #00CCCC !important;\r\n}\r\n\r\n\r\n.cstm-revenue-analytics img {\r\n\twidth: 100%;\r\n}\r\n\r\n.cstm-organization-charity img {\r\n\twidth: 100%;\r\n}\r\n\r\n.view-all-link a {\r\n\ttext-decoration: underline !important;\r\n\tfont-weight: 500;\r\n\tfont-size: 14px;\r\n\tline-height: 16px;\r\n\tcolor: #3F3F46;\r\n}\r\n\r\n.view-all-link a:hover {\r\n\tcolor: #00CCCC !important;\r\n\ttext-decoration: none !important;\r\n}\r\n\r\n.w-1 {\r\n\twidth: 1% !important\r\n}\r\n\r\n.w-2 {\r\n\twidth: 2% !important\r\n}\r\n\r\n.w-3 {\r\n\twidth: 3% !important\r\n}\r\n\r\n.w-4 {\r\n\twidth: 4% !important\r\n}\r\n\r\n.w-5 {\r\n\twidth: 5% !important\r\n}\r\n\r\n.w-6 {\r\n\twidth: 6% !important\r\n}\r\n\r\n.w-7 {\r\n\twidth: 7% !important\r\n}\r\n\r\n.w-8 {\r\n\twidth: 8% !important\r\n}\r\n\r\n.w-9 {\r\n\twidth: 9% !important\r\n}\r\n\r\n.w-10 {\r\n\twidth: 10% !important\r\n}\r\n\r\n.w-11 {\r\n\twidth: 11% !important\r\n}\r\n\r\n.w-12 {\r\n\twidth: 12% !important\r\n}\r\n\r\n.w-13 {\r\n\twidth: 13% !important\r\n}\r\n\r\n.w-14 {\r\n\twidth: 14% !important\r\n}\r\n\r\n.w-15 {\r\n\twidth: 15% !important\r\n}\r\n\r\n.w-16 {\r\n\twidth: 16% !important\r\n}\r\n\r\n.w-17 {\r\n\twidth: 17% !important\r\n}\r\n\r\n.w-18 {\r\n\twidth: 18% !important\r\n}\r\n\r\n.w-19 {\r\n\twidth: 19% !important\r\n}\r\n\r\n.w-20 {\r\n\twidth: 20% !important\r\n}\r\n\r\n.w-31 {\r\n\twidth: 31% !important\r\n}\r\n\r\n.w-32 {\r\n\twidth: 32% !important\r\n}\r\n\r\n.w-33 {\r\n\twidth: 33% !important\r\n}\r\n\r\n.w-34 {\r\n\twidth: 34% !important\r\n}\r\n\r\n.w-35 {\r\n\twidth: 35% !important\r\n}\r\n\r\n.w-36 {\r\n\twidth: 36% !important\r\n}\r\n\r\n.w-37 {\r\n\twidth: 37% !important\r\n}\r\n\r\n.w-38 {\r\n\twidth: 38% !important\r\n}\r\n\r\n.w-39 {\r\n\twidth: 39% !important\r\n}\r\n\r\n.w-40 {\r\n\twidth: 40% !important\r\n}\r\n\r\n.w-41 {\r\n\twidth: 41% !important\r\n}\r\n\r\n.w-42 {\r\n\twidth: 42% !important\r\n}\r\n\r\n.w-43 {\r\n\twidth: 43% !important\r\n}\r\n\r\n.w-44 {\r\n\twidth: 44% !important\r\n}\r\n\r\n.w-45 {\r\n\twidth: 45% !important\r\n}\r\n\r\n.w-46 {\r\n\twidth: 46% !important\r\n}\r\n\r\n.w-47 {\r\n\twidth: 47% !important\r\n}\r\n\r\n.w-48 {\r\n\twidth: 48% !important\r\n}\r\n\r\n.w-49 {\r\n\twidth: 49% !important\r\n}\r\n\r\n.w-50 {\r\n\twidth: 50% !important\r\n}\r\n\r\n.w-51 {\r\n\twidth: 51% !important\r\n}\r\n\r\n.w-52 {\r\n\twidth: 52% !important\r\n}\r\n\r\n.w-53 {\r\n\twidth: 53% !important\r\n}\r\n\r\n.w-54 {\r\n\twidth: 54% !important\r\n}\r\n\r\n.w-55 {\r\n\twidth: 55% !important\r\n}\r\n\r\n.w-56 {\r\n\twidth: 56% !important\r\n}\r\n\r\n.w-57 {\r\n\twidth: 57% !important\r\n}\r\n\r\n.w-58 {\r\n\twidth: 58% !important\r\n}\r\n\r\n.w-59 {\r\n\twidth: 59% !important\r\n}\r\n\r\n.w-60 {\r\n\twidth: 60% !important\r\n}\r\n\r\n.w-61 {\r\n\twidth: 61% !important\r\n}\r\n\r\n.w-62 {\r\n\twidth: 62% !important\r\n}\r\n\r\n.w-63 {\r\n\twidth: 63% !important\r\n}\r\n\r\n.w-64 {\r\n\twidth: 64% !important\r\n}\r\n\r\n.w-65 {\r\n\twidth: 65% !important\r\n}\r\n\r\n.w-66 {\r\n\twidth: 66% !important\r\n}\r\n\r\n.w-67 {\r\n\twidth: 67% !important\r\n}\r\n\r\n.w-68 {\r\n\twidth: 68% !important\r\n}\r\n\r\n.w-69 {\r\n\twidth: 69% !important\r\n}\r\n\r\n.w-70 {\r\n\twidth: 70% !important\r\n}\r\n\r\n.w-71 {\r\n\twidth: 71% !important\r\n}\r\n\r\n.w-72 {\r\n\twidth: 72% !important\r\n}\r\n\r\n.w-73 {\r\n\twidth: 73% !important\r\n}\r\n\r\n.w-74 {\r\n\twidth: 74% !important\r\n}\r\n\r\n.w-75 {\r\n\twidth: 75% !important\r\n}\r\n\r\n.w-76 {\r\n\twidth: 76% !important\r\n}\r\n\r\n.w-77 {\r\n\twidth: 77% !important\r\n}\r\n\r\n.w-78 {\r\n\twidth: 78% !important\r\n}\r\n\r\n.w-79 {\r\n\twidth: 79% !important\r\n}\r\n\r\n.w-80 {\r\n\twidth: 80% !important\r\n}\r\n\r\n.w-81 {\r\n\twidth: 81% !important\r\n}\r\n\r\n.w-82 {\r\n\twidth: 82% !important\r\n}\r\n\r\n.w-83 {\r\n\twidth: 83% !important\r\n}\r\n\r\n.w-84 {\r\n\twidth: 84% !important\r\n}\r\n\r\n.w-85 {\r\n\twidth: 85% !important\r\n}\r\n\r\n.w-86 {\r\n\twidth: 86% !important\r\n}\r\n\r\n.w-87 {\r\n\twidth: 87% !important\r\n}\r\n\r\n.w-78 {\r\n\twidth: 88% !important\r\n}\r\n\r\n.w-89 {\r\n\twidth: 89% !important\r\n}\r\n\r\n.w-90 {\r\n\twidth: 90% !important\r\n}\r\n\r\n.w-91 {\r\n\twidth: 91% !important\r\n}\r\n\r\n.w-92 {\r\n\twidth: 92% !important\r\n}\r\n\r\n.w-93 {\r\n\twidth: 93% !important\r\n}\r\n\r\n.w-94 {\r\n\twidth: 94% !important\r\n}\r\n\r\n.w-95 {\r\n\twidth: 95% !important\r\n}\r\n\r\n.w-96 {\r\n\twidth: 96% !important\r\n}\r\n\r\n.w-97 {\r\n\twidth: 97% !important\r\n}\r\n\r\n.w-98 {\r\n\twidth: 98% !important\r\n}\r\n\r\n.w-99 {\r\n\twidth: 99% !important\r\n}\r\n\r\n.w-100 {\r\n\twidth: 100% !important\r\n}\r\n\r\n.cstm-rco-photo {\r\n\twidth: 48px;\r\n\theight: 48px;\r\n}\r\n\r\n.cstm-rco-photo {\r\n\twidth: 48px;\r\n\theight: 48px;\r\n\tobject-fit: cover;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.cstm-eye {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tdisplay: inline-block;\r\n\tborder: 1px solid #bdbdbd;\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tline-height: 44px;\r\n\tcolor: #3F3F46;\r\n\tfont-size: 18px;\r\n\tmargin-right: 12px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.cstm-eye:hover {\r\n\tbackground-color: #3F3F46;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #3F3F46;\r\n}\r\n\r\n.cstm-chekmank {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tdisplay: inline-block;\r\n\tborder: 1px solid #75d5d5;\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tline-height: 44px;\r\n\tcolor: #00CCCC;\r\n\tfont-size: 18px;\r\n\tmargin-right: 12px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.cstm-chekmank:hover {\r\n\tbackground-color: #00CCCC;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #00CCCC;\r\n}\r\n\r\n.cstm-cross {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tdisplay: inline-block;\r\n\tborder: 1px solid #edaea2;\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tline-height: 42px;\r\n\tcolor: #EE6F57;\r\n\tfont-size: 14px;\r\n\tmargin-right: 12px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.cstm-cross:hover {\r\n\tbackground-color: #EE6F57;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #EE6F57;\r\n}\r\n\r\n.cstm-delete {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tdisplay: inline-block;\r\n\tborder: 1px solid #edaea2;\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tline-height: 42px;\r\n\tcolor: #EE6F57;\r\n\tfont-size: 18px;\r\n\tmargin-right: 12px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.cstm-delete:hover {\r\n\tbackground-color: #EE6F57;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #EE6F57;\r\n}\r\n\r\n.cstm-delete-share {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tdisplay: inline-block;\r\n\tborder: 1px solid #edaea2;\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tline-height: 42px;\r\n\tcolor: #008000;\r\n\tfont-size: 18px;\r\n\tmargin-right: 12px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.cstm-delete-share:hover {\r\n\tbackground-color: #008000;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #008000;\r\n}\r\n\r\n.cstm-edit {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tdisplay: inline-block;\r\n\tborder: 1px solid #77dfdf;\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tline-height: 42px;\r\n\tcolor: #00CCCC;\r\n\tfont-size: 16px;\r\n\tmargin-right: 12px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.cstm-edit:hover {\r\n\tbackground-color: #00CCCC;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #00CCCC;\r\n}\r\n\r\n.cstm-restore {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tdisplay: inline-block;\r\n\tborder: 1px solid #edaea2;\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tline-height: 42px;\r\n\tcolor: #EE6F57;\r\n\tfont-size: 16px;\r\n\tmargin-right: 12px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.cstm-restore:hover {\r\n\tbackground-color: #EE6F57;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #EE6F57;\r\n}\r\n\r\n.mrn-rt {\r\n\tmargin-right: 0px !important;\r\n}\r\n\r\n.cstm-recently-joined-user-table {\r\n\theight: 423px;\r\n}\r\n\r\n.cstm-recently-joined-user-table::-webkit-scrollbar {\r\n\twidth: 6px;\r\n}\r\n\r\n.cstm-recently-joined-user-table::-webkit-scrollbar-track {\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.cstm-recently-joined-user-table::-webkit-scrollbar-thumb {\r\n\tbackground: #00CCCC;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.btn {\r\n\tborder: none;\r\n}\r\n\r\n.cstm-user-main-photo {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tobject-fit: cover;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.cstm-icon-mn {\r\n\tmargin-left: 4px;\r\n\tfont-size: 25px;\r\n\tvertical-align: -7px;\r\n}\r\n\r\n.page-nav-list {\r\n\tfont-weight: 400;\r\n\tfont-size: 12px;\r\n\tline-height: 15px;\r\n\tcolor: #8492A6;\r\n}\r\n\r\na {\r\n\tcolor: #00cccc;\r\n}\r\n\r\na:hover {\r\n\tcolor: #000;\r\n}\r\n\r\n.mr-1,\r\n.pr-1 {\r\n\tmargin-right: 4px !important;\r\n}\r\n\r\n.mr-2,\r\n.pr-2 {\r\n\tmargin-right: 8px !important;\r\n}\r\n\r\n.mr-3,\r\n.pr-3 {\r\n\tmargin-right: 12px !important;\r\n}\r\n\r\n.mr-4,\r\n.pr-4 {\r\n\tmargin-right: 16px !important;\r\n}\r\n\r\n.mr-5,\r\n.pr-5 {\r\n\tmargin-right: 20px !important;\r\n}\r\n\r\n.mr-6,\r\n.pr-6 {\r\n\tmargin-right: 24px !important;\r\n}\r\n\r\n\r\n.ml-1,\r\n.pl-1 {\r\n\tmargin-left: 4px !important;\r\n}\r\n\r\n.ml-2,\r\n.pl-2 {\r\n\tmargin-left: 8px !important;\r\n}\r\n\r\n.ml-3,\r\n.pl-3 {\r\n\tmargin-left: 12px !important;\r\n}\r\n\r\n.ml-4,\r\n.pl-4 {\r\n\tmargin-left: 16px !important;\r\n}\r\n\r\n.ml-5,\r\n.pl-5 {\r\n\tmargin-left: 20px !important;\r\n}\r\n\r\n.ml-6,\r\n.pl-6 {\r\n\tmargin-left: 24px !important;\r\n}\r\n\r\n.profile-upl-img {\r\n\twidth: 112px;\r\n\theight: 112px;\r\n\tobject-fit: cover;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.cstm-btn-red {\r\n\tbackground: red;\r\n\tborder-radius: 5px;\r\n\theight: 40px;\r\n\tborder: none;\r\n\tfont-weight: 700;\r\n\tfont-size: 14px;\r\n\tline-height: 16px;\r\n\tcolor: #FFF;\r\n\tpadding: 10px 31px;\r\n\tfont-family: \"Inter\", sans-serif;\r\n}\r\n\r\n.cstm-btn {\r\n\tbackground: #00CCCC;\r\n\tborder-radius: 5px;\r\n\theight: 40px;\r\n\tborder: none;\r\n\tfont-weight: 700;\r\n\tfont-size: 14px;\r\n\tline-height: 16px;\r\n\tcolor: #FFF;\r\n\tpadding: 10px 31px;\r\n\tfont-family: \"Inter\", sans-serif;\r\n}\r\n\r\n.cstm-btn:hover {\r\n\tbackground: #000;\r\n\tcolor: #FFF;\r\n}\r\n\r\n.cstm-btn {\r\n\tbackground: #00CCCC;\r\n\tborder-radius: 5px;\r\n\theight: 40px;\r\n\tborder: none;\r\n\tfont-weight: 700;\r\n\tfont-size: 14px;\r\n\tline-height: 16px;\r\n\tcolor: #FFF;\r\n\tpadding: 10px 31px;\r\n\tfont-family: \"Inter\", sans-serif;\r\n}\r\n\r\n.cstm-btn:hover {\r\n\tbackground: #000;\r\n\tcolor: #FFF;\r\n}\r\n\r\n.cstm-btn-click {\r\n\tborder-radius: 5px;\r\n\theight: 40px;\r\n\tborder: none;\r\n\tfont-weight: 700;\r\n\tfont-size: 14px;\r\n\tline-height: 16px;\r\n\tpadding: 10px 31px;\r\n\tfont-family: \"Inter\", sans-serif;\r\n\tbackground: #000;\r\n\tcolor: #FFF;\r\n}\r\n\r\n.cstm-btn2 {\r\n\tbackground: #FFF;\r\n\tborder-radius: 5px;\r\n\theight: 40px;\r\n\tborder: 1px solid #939393;\r\n\tfont-weight: 700;\r\n\tfont-size: 14px;\r\n\tline-height: 16px;\r\n\tcolor: #585858;\r\n\tpadding: 10px 31px;\r\n\tfont-family: \"Inter\", sans-serif;\r\n}\r\n\r\n.cstm-btn2:hover {\r\n\tbackground: #000;\r\n\tcolor: #FFF;\r\n}\r\ninput::placeholder{\r\n\tcolor: #78787d;\r\n}\r\n.cstm-input {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\theight: 56px;\r\n\tpadding: 16px 24px;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n\tborder: 1px solid #EEEEEE;\r\n\tborder-radius: 10px;\r\n\t/* color: #78787d; */\r\n}\r\n\r\n.cstm-input-moderation-field {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\theight: 200px;\r\n\tpadding: 16px 24px;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n\tborder: 1px solid #EEEEEE;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.cstm-label {\r\n\tfont-weight: 500;\r\n\tfont-size: 16px;\r\n\tline-height: 24px;\r\n\tcolor: #3F3F46;\r\n\topacity: 0.7;\r\n\tfont-family: \"Inter\", sans-serif;\r\n\tmargin-bottom: 6px;\r\n}\r\n\r\ninput:focus-visible {\r\n\toutline: none;\r\n}\r\n\r\n.cstm-select {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\theight: 56px;\r\n\tline-height: 36px;\r\n\tpadding: 6px 24px;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n\tborder: 1px solid #EEEEEE;\r\n\tborder-radius: 10px;\r\n\tcolor: #93969F;\r\n\t-webkit-appearance: none;\r\n\t-moz-appearance: none;\r\n\tbackground-image: url(../../assets/Images/arrow-down.png);\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: right center;\r\n\tcursor: pointer;\r\n}\r\n\r\nselect:focus-visible {\r\n\toutline: none;\r\n}\r\n\r\n.cstm-textarea {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tpadding: 16px 24px;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n\tborder: 1px solid #EEEEEE;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.cstn-discard {\r\n\twidth: 159px;\r\n}\r\n\r\nbutton {\r\n\ttransition: all 0.5s ease;\r\n}\r\n\r\n.cstm-input-seacrh {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\theight: 40px;\r\n\tpadding: 5px 12px 5px 40px;\r\n\tfont-weight: 400;\r\n\tfont-size: 14px;\r\n\tborder: 1px solid #EEEEEE;\r\n\tborder-radius: 5px;\r\n}\r\n\r\n.cstm-search-ro {\r\n\tposition: absolute;\r\n\tmargin: 11px 0px 0px 15px;\r\n}\r\n\r\n.csatm-od-photo {\r\n\theight: 80px;\r\n\twidth: 80px;\r\n\tobject-fit: cover;\r\n\tborder-radius: 500%;\r\n}\r\n\r\nhr {\r\n\topacity: 0.12;\r\n}\r\n\r\n.title2 {\r\n\tfont-style: normal;\r\n\tfont-weight: 400;\r\n\tfont-size: 14px;\r\n\tline-height: 17px;\r\n\tcolor: #93969F;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.cstm-website-link {\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.cstm-tabs-pf .nav {\r\n\tborder-bottom: 1px solid #e4e4e5;\r\n}\r\n\r\n.cstm-tabs-pf .nav li a {\r\n\tfont-style: normal;\r\n\tfont-weight: 400;\r\n\tfont-size: 15px;\r\n\tline-height: 17px;\r\n\tcolor: #93969F;\r\n\tpadding: 15px 35px;\r\n\tfont-weight: 500;\r\n\tposition: relative;\r\n}\r\n\r\n.cstm-tabs-pf .nav li a:hover {\r\n\tcolor: #000;\r\n}\r\n\r\n.cstm-tabs-pf .nav li a.active {\r\n\tcolor: #000;\r\n}\r\n\r\n.cstm-tabs-pf .nav li a.active:after {\r\n\tbackground: #000;\r\n\twidth: 100%;\r\n\theight: 2px;\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n}\r\n\r\n.cstm-table-down-arrow {\r\n\tvertical-align: -3px;\r\n\tfont-size: 18px;\r\n\tline-height: 10px;\r\n}\r\n\r\n.cstm-om-slc {\r\n\theight: 40px;\r\n\tpadding: 0px 15px;\r\n\tborder-radius: 5px;\r\n}\r\n\r\n.cstm-om-input {\r\n\twidth: 100%;\r\n}\r\n\r\n.col-all-auto {\r\n\twidth: auto;\r\n}\r\n\r\n.cstm-cd-photo {\r\n\tposition: absolute;\r\n}\r\n\r\n.cstm-od-details {\r\n\tpadding-left: 100px;\r\n}\r\n\r\n.cstm-add-greetings-link a {\r\n\ttext-decoration: underline !important;\r\n\tfont-weight: 500;\r\n\tfont-size: 14px;\r\n\tline-height: 16px;\r\n}\r\n\r\n.delete-link {\r\n\tfont-weight: 500;\r\n\tfont-size: 12px;\r\n\tline-height: 16px;\r\n\ttext-decoration-line: underline !important;\r\n\tcolor: #EE6F57;\r\n}\r\n\r\n.delete-link:hover {\r\n\tcolor: #000;\r\n}\r\n\r\n.edit-link {\r\n\tfont-weight: 500;\r\n\tfont-size: 12px;\r\n\tline-height: 16px;\r\n\ttext-decoration-line: underline !important;\r\n\tcolor: #3F3F46;\r\n}\r\n\r\n.cstm-greeting-active {\r\n\tbackground: #E0F9F9;\r\n}\r\n\r\nspan.cstm-published {\r\n\tbackground: #00CCCC;\r\n\tborder-radius: 5px;\r\n\tfont-weight: 600;\r\n\tfont-size: 10px;\r\n\tline-height: 20px;\r\n\tcolor: #FFFFFF;\r\n\tmargin-left: 20px;\r\n\theight: 20px;\r\n\tpadding: 0px 11px;\r\n}\r\n\r\n/**/\r\n.cstm-login {\r\n\theight: 100vh;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\twidth: 32%;\r\n}\r\n\r\n.cstm-btn-submit-login {\r\n\tbackground-color: #E0F9F9;\r\n\tborder: 1px solid #E0F9F9;\r\n\tborder-radius: .375rem;\r\n\tcolor: #00CCCC;\r\n\ttransition: 0.3s ease-in-out;\r\n}\r\n\r\n.cstm-btn-submit-login:hover {\r\n\tbackground-color: #000;\r\n\tborder-color: #000;\r\n\tcolor: #fff;\r\n}\r\n\r\n.cstm-submitbutton {\r\n\tbackground-color: #00CCCC;\r\n\tborder: 1px solid #00CCCC;\r\n\tborder-radius: .375rem;\r\n\tcolor: #fff;\r\n\ttransition: 0.2s ease-in-out;\r\n\tpadding: 8px 20px;\r\n}\r\n\r\n.cstm-submitbutton-disable {\r\n\tbackground-color: #99a3a3;\r\n\tborder: 1px solid #99a3a3;\r\n\tborder-radius: .375rem;\r\n\tcolor: #fff;\r\n\ttransition: 0.2s ease-in-out;\r\n\tpadding: 8px 20px;\r\n}\r\n\r\n.cstm-submitbutton-disable:hover {\r\n\tbackground-color: #99a3a3;\r\n\tborder: 1px solid #99a3a3;\r\n\tborder-radius: .375rem;\r\n\tcolor: #fff;\r\n\ttransition: 0.2s ease-in-out;\r\n\tpadding: 8px 20px;\r\n}\r\n\r\n.cstm-submitbutton:hover {\r\n\tbackground-color: #E0F9F9;\r\n\tborder-color: #E0F9F9;\r\n\tcolor: #00CCCC;\r\n}\r\n/* .submit-btnMain {\r\n\ttext-align: center;\r\n} */\r\n\r\n.NoRecord-cstm {\r\n\ttransition: 0.5s ease-in-out;\r\n\ttext-align: center;\r\n\theight: calc(100vh - 289px);\r\n\tline-height: 32px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.cstm-profile-img.cstm-AdminProfile-img img {\r\n\twidth: 120px;\r\n\theight: 120px;\r\n\tmargin-right: 10px;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.cstm-profile-img.cstm-AdminProfile-img input {\r\n\tvertical-align: middle;\r\n}\r\n\r\ntextarea:focus {\r\n\toutline: 0;\r\n}\r\n\r\n.cstm-organization-profile-pagination {\r\n\tpadding: 12px 16px;\r\n}\r\n\r\n.submit-btnMain.cstm-loader {\r\n    position: relative;\r\n    width: auto;\r\n    float: left;\r\n}\r\n\r\n.loader-main { \r\n    height: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    text-align: center;\r\n    background-color: #f8f9fceb;\r\n    left: 0;\r\n    right: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.loader-main img {\r\n\twidth: 25px;\r\n\theight: 25px;\r\n}\r\n \r\n.cstm-table-main {\r\n\t/* height: calc(100vh - 188px); */\r\n}\r\n\r\n.form-select:focus {\r\n\tborder-color: #EEEEEE;\r\n\toutline: 0;\r\n\tbox-shadow: none;\r\n}\r\nselect::placeholder{\r\n\tcolor: #78787d;\r\n}\r\n.cstm-category {\r\n\tpadding: 16px 24px;\r\n\tborder-color: #EEEEEE;\r\n\tborder-radius: 10px;\r\n\t\r\n}\r\n\r\n.cstm-header-image img {\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.btn-close:focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.cstm-FAQHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.cstm-Replied-by-user {\r\n\talign-self: center;\r\n\ttext-align: right;\r\n}\r\n\r\n.cstm-Replied-by-user img {\r\n\tpadding-right: 8px;\r\n}\r\n\r\n.cstm-Replied-by-user span {\r\n\tcolor: #8492A6;\r\n\tfont-size: 12px;\r\n\talign-self: center;\r\n}\r\n\r\n.pending-status button {\r\n\tbackground-color: #EE6F57;\r\n}\r\n\r\n.pending-status button {\r\n\tbackground-color: #EE6F57;\r\n\tborder: 1px solid #EE6F57;\r\n\tborder-radius: 10px;\r\n\tfont-size: 14px;\r\n\tpadding: 4px 8px;\r\n}\r\n\r\n.in-progress-status button {\r\n\tbackground-color: #FFE000;\r\n\tborder: 1px solid #FFE000;\r\n\tfont-size: 14px;\r\n\tcolor: #3F3F46;\r\n\tpadding: 4px 8px;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.completed-status button {\r\n\tbackground-color: #00CCCC;\r\n\tborder: 1px solid #00CCCC;\r\n\tfont-size: 14px;\r\n\tcolor: #3F3F46;\r\n\tpadding: 4px 8px;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.re-text {\r\n\tcolor: #00CCCC;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.issue-regarding-no h4 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tmargin: 0 0 8px 0;\r\n\tcolor: #3F3F46;\r\n}\r\n\r\n.issue-regarding-no p {\r\n\tline-height: 28px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.ticket1 span {\r\n\tcolor: #8492A6;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.ticket1 strong {\r\n\tcolor: #3F3F46;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.cstm-checkbox {\r\n\theight: 20px;\r\n\twidth: 20px;\r\n\tmargin-right: 8px;\r\n\tvertical-align: middle;\r\n\taccent-color: #0c9d9d;\r\n\tcolor: #fff;\r\n}\r\n\r\n.checkmark-content {\r\n\tcolor: #93969F;\r\n\tfont-size: 14px;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.cstm-textarea2 {\r\n\tpadding: 0;\r\n\theight: 130px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.pending-main1 {\r\n\theight: calc(100vh - 496px);\r\n}\r\n\r\n.pending-main2 {\r\n\theight: calc(100vh - 310px);\r\n}\r\n\r\n.pending-main3 {\r\n\theight: calc(100vh - 150px);\r\n\toverflow: hidden;\r\n}\r\n\r\n.checkmark-main {\r\n\tborder: 1px solid #93969F;\r\n\tborder-radius: 5px;\r\n\tpadding: 12px;\r\n}\r\n\r\n.inprogress-bg {\r\n\tbackground-color: #E0F9F9;\r\n}\r\n\r\n.cstm-search-icon {\r\n\tposition: absolute;\r\n\tmargin: 16px 0px 0px 20px;\r\n\tz-index: 1;\r\n\twidth: 35px;\r\n}\r\n\r\n.cstm-input-screen2 {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\theight: 40px;\r\n\tpadding: 16px 12px 16px 50px;\r\n\tfont-weight: 400;\r\n\tfont-size: 14px;\r\n\tborder: 1px solid #EEEEEE;\r\n\tborder-radius: 10px;\r\n\theight: 50px;\r\n}\r\n\r\n.AddOrganization-bannerImg {\r\n\twidth: 400px;\r\n    height: 250px;\r\n    object-fit: cover;\r\n    margin-bottom: 1rem;\r\n    margin-left: 20px;\r\n    padding: 10px;\r\n}\r\n\r\n.modal-dialog.cstm-modal-dialog.modal-dialog-centered {\r\n\twidth: 50%;\r\n\tmargin-right: 0;\r\n\tmargin-left: 0;\r\n}\r\n\r\n.cstm-uploadHide {\r\n\tdisplay: none;\r\n}\r\n\r\n.cstm-uploadbtn {\r\n\tline-height: normal;\r\n\tcursor: pointer;\r\n}\r\n\r\n/* .cstm-bg-input{\r\n\tbackground-color: #fff;\r\n} */\r\n.cstm-Videoalign {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n.pageloader{\r\n\twidth: 50px;\r\n\theight: 50px;\r\n}\r\n.cstm-Tabledesign:hover{\r\n\tbackground-color: #e0f9f94d;\r\n}\r\n/* date-picker */\r\n\r\n.react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover {\r\n    border-radius: 50px;\r\n    background-color: #00CCCC;\r\n\tcolor: #fff;\r\n}\r\n.react-datepicker__header {\r\n    background-color: #fff;\r\n    border-bottom: 0;\r\n}\r\n.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {\r\n    margin: 13px 0;\r\n}\r\n.react-datepicker__navigation {\r\n    top: 12px;\r\n\tbackground: #E0F9F9;\r\n\tborder-radius: 5px;\r\n}\r\n.react-datepicker__navigation-icon--previous::before {\r\n    transform: rotate(225deg);\r\n    right: -7px;\r\n\tleft: -5px;\r\n}\r\n.react-datepicker__navigation-icon--next::before {\r\n    transform: rotate(45deg);\r\n    left: -7px;\r\n    left: -3px;\r\n}\r\n.react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\r\n\tborder-color: #424242;\r\n    border-style: solid;\r\n    border-width: 2px 2px 0 0;\r\n    top: 11px;\r\n    width: 9px;\r\n}\r\n.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {\r\n    background-color: #00cccc;\r\n    color: #fff;\r\n\tborder-radius: 50px;\r\n}\r\n.react-datepicker {\r\n    border: 1px solid #EEEEEE;\r\n}\r\n\r\n.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {\r\n    margin-top: 12px;\r\n}\r\n.react-datepicker__input-container input {\r\n\tborder: 1px solid #eeeeee;\r\n\tfont-size: 13px;\r\n    padding: 6px 8px;\r\n\twidth: 100%;\r\n}\r\n/**/\r\n\r\n.ctsm-addGreeting a{\r\n\ttext-decoration: underline !important;\r\n\tfont-size: 14px;\r\n}\r\n.cstm-maincontent{\r\n\tborder: 1px solid #eeeeee;\r\n    padding: 12px 16px;\r\n    border-radius: 5px;\r\n}\r\n.cstm-addgreetinginput{\r\n\tdisplay: block;\r\n    width: 139%;\r\n    height: 18px;\r\n    padding: 16px 24px;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    border: 1px solid #EEEEEE;\r\n    border-radius: 10px;\r\n    color: #78787d;\r\n}\r\n.cstm-giftinginput{\r\n\tdisplay: block;\r\n    width: 30%;\r\n    height: 18px;\r\n    padding: 16px 24px;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    border: 1px solid #EEEEEE;\r\n    border-radius: 10px;\r\n    color: #78787d;\r\n}\r\n.cstm-gift-icon{\r\n    width: 75px;\r\n    height: 75px;\r\n    object-fit: cover;\r\n}\r\n.cstm-textarea{\r\n\theight: auto;\r\n}\r\n.cstm-imagevideo{\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.cstm-faq-main{\r\n\tdisplay: flex;\r\n    justify-content: space-between;\r\n    padding-left: 30px;\r\n}\r\n\r\n.cstm-faq-main{\r\n\tdisplay: flex;\r\n    justify-content: space-between;\r\n    padding-left: 30px;\r\n}\r\ndiv#accordion__heading-\\:r0\\:{\r\n\tposition: relative;\r\n}\r\n.accordion__button:before {\r\n    display: inline-block;\r\n    content: '';\r\n    height: 10px;\r\n    width: 10px;\r\n    margin-right: 12px;\r\n    border-bottom: 2px solid currentColor;\r\n    border-right: 2px solid currentColor;\r\n    transform: rotate(-45deg);\r\n    position: absolute;\r\n\tmargin-top: 7px;\r\n}\r\n.accordion__button {\r\n    background-color: #e0f9f94d;\r\n    color: #93969F;\r\n\ttransition: 1s ease-in-out all;\r\n}\r\n.accordion__button:hover {\r\n    background-color: #e0f9f9a6;\r\n}\r\n.cstm-terms-condidtion{\r\n\t/* height: calc(100vh - 188px); */\r\n}\r\n.cstm-usertable-design{\r\n\tborder: 1px solid #FFFFFF;\r\n\tpadding: 12px 16px;\r\n}\r\n.cstm-userheading{\r\n\tpadding: 12px 16px !important;\r\n}\r\n.cstm-usertable-design td{\r\n\tpadding: 12px 16px;\r\n}\r\n.cstm-datepicker input{\r\n\tpadding: 16px 24px;\r\n\tborder-radius: 10px;\r\n\theight: 56px;\r\n\tcolor: #78787d;\r\n\tfont-size: 16px;\r\n}\r\n.cstm-editor{\r\n\tborder: 1px solid #F1F1F1;\r\n    padding: 16px;\r\n}\r\n\r\n/* table design */\r\n.cstm-cl-mn2 tr th:nth-child(2) {\r\n    width: 32%;\r\n}\r\n.cstm-cl-mn3 tr th:nth-child(3) {\r\n    width: 32%;\r\n}\r\n.cstm-cl-mn4 tr th:nth-child(4) {\r\n    width: 32%;\r\n}\r\n.cstm-cl-mn5 tr th:nth-child(5) {\r\n    width: 32%;\r\n}\r\n.cstm-cl-mn6 tr th:nth-child(6) {\r\n    width: 32%;\r\n}\r\n.cstm-cl-mn7 tr th:nth-child(7) {\r\n    width: 32%;\r\n}\r\n\r\n.partially-registered-user-notes > div {\r\n\tborder: 1px solid #EEEEEE;\r\n\tborder-radius: 10px;\r\n\tpadding: 0.5rem;\r\n\tmargin-bottom: 0.5rem;\r\n}\r\n\r\n.partially-registered-user-notes > div > span {\r\n\tfont-size: small;\r\n\tcolor: #93969F;\r\n}\r\n\r\n.partially-registered-user-notes > div > p {\r\n\tfont-weight: bold;\r\n\tmargin: 0;\r\n\twhite-space: pre-wrap;\r\n}\r\n\r\n.single-selection-button-group {\r\n\r\n}\r\n\r\n.single-selection-button-group button {\r\n    border: 1px solid #00CCCC;\r\n    color: #00CCCC;\r\n    transition: 0.2s ease-in-out;\r\n    padding: 8px 20px;\r\n}\r\n\r\n.single-selection-button-group button.active {\r\n    background-color: #00CCCC;\r\n    color: #fff;\r\n}\r\n\r\n.single-selection-button-group button:hover {\r\n    background-color: #E0F9F9;\r\n    border-color: #E0F9F9;\r\n    color: #00CCCC;\r\n}\r\n\r\n.single-selection-button-group button:first-child {\r\n    border-top-left-radius: 0.375rem;\r\n    border-bottom-left-radius: 0.375rem;\r\n}\r\n\r\n.single-selection-button-group button:last-child {\r\n    border-top-right-radius: 0.375rem;\r\n    border-bottom-right-radius: 0.375rem;\r\n}\r\n\r\n.custom-filter-icon-btn {\r\n\theight: 40px;\r\n\twidth: 40px;\r\n\tborder: 1px solid #00CCCC;\r\n\tborder-radius: 50%;\r\n\tcolor: #00CCCC;\r\n\tbackground-color: white;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tline-height: 0;\r\n}\r\n\r\n.custom-filter-icon-btn:hover {\r\n\tbackground-color: #00CCCC;\r\n\tcolor: white;\r\n}\r\n\r\n.custom-skeleton-loader-full {\r\n\tz-index: 1000;\r\n\tbackground-color: #e2e5e7;\r\n\tbackground-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));\r\n\tbackground-size: 40px 100%;\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: left -40px top 0;\r\n\tanimation: custom-skeleton-loader-full-shine 1s ease infinite;\r\n}\r\n\r\n.custom-skeleton-loader-full > * {\r\n\tvisibility: hidden;\r\n}\r\n\r\n@keyframes custom-skeleton-loader-full-shine {\r\n\tto {\r\n\t\tbackground-position: right -40px top 0;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
